import * as i0 from '@angular/core';
import { Injectable, Directive, Input, Component, Inject, ViewChild, EventEmitter, Output, ErrorHandler, Optional, HostBinding, ChangeDetectionStrategy, Pipe, SecurityContext, NgModule } from '@angular/core';
import * as i12 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i1$5 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import * as i7$1 from '@headpower/components';
import { ButtonModule, SpinnerModule, CardModule, NotificationModule, PlaceholderModule, FullScreenDialogModule } from '@headpower/components';
import * as i16 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i8 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i15 from '@angular/material/core';
import { MatRippleModule } from '@angular/material/core';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i3$1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i13 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i1 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import * as i1$4 from '@angular/cdk/layout';
import { LayoutModule } from '@angular/cdk/layout';
import * as i1$2 from '@headpower/blah-ng';
import { BlahModule } from '@headpower/blah-ng';
import '@headpower/components/dayjs-typings';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject, ReplaySubject, concatMap, firstValueFrom, delay, map, timer, takeUntil as takeUntil$1, take, forkJoin, isObservable } from 'rxjs';
import { takeUntil, mergeMap, filter, map as map$1, distinctUntilKeyChanged, take as take$1, tap, switchMap } from 'rxjs/operators';
import dayjs from 'dayjs';
import * as i3 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1$1 from '@angular/common/http';
import * as i7 from '@angular/material/form-field';
import * as i1$3 from '@angular/platform-browser';
import * as i4 from '@angular/material/tooltip';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import * as i8$1 from '@angular/service-worker';
import { HubConnectionBuilder } from '@microsoft/signalr';
import * as i2$1 from '@headpower/featureflags';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { micromark } from 'micromark';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { MatListModule } from '@angular/material/list';
import { MatTableDataSource } from '@angular/material/table';
import tinycolor from 'tinycolor2';

/**
 * Toast durations.
 */
const _c0 = ["helpdeskFg"];
function HelpdeskDialogComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.contactInformationText, i0.ɵɵsanitizeHtml);
  }
}
function HelpdeskDialogComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "layout.feedbackDescription"), " ");
  }
}
function HelpdeskDialogComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.validation.required"));
  }
}
function HelpdeskDialogComponent_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.validation.required"));
  }
}
function HelpdeskDialogComponent_Conditional_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.validation.invalidEmail"));
  }
}
function HelpdeskDialogComponent_Conditional_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.validation.required"));
  }
}
function HelpdeskDialogComponent_Conditional_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.validation.required"));
  }
}
function HelpdeskDialogComponent_Conditional_51_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "hpo-button", 20);
    i0.ɵɵlistener("click", function HelpdeskDialogComponent_Conditional_51_Template_hpo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.closeDialog());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "hpo-button", 21);
    i0.ɵɵlistener("click", function HelpdeskDialogComponent_Conditional_51_Template_hpo_button_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.submitForm());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "layout.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r0.helpdeskForm.valid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, "layout.send"), " ");
  }
}
function ImportantNewsDialogComponent_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ImportantNewsDialogComponent_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirm());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("id", "confirm-important-news");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "default.close"), " ");
  }
}
function NotificationItemComponent_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "priority_high");
    i0.ɵɵelementEnd();
  }
}
const _c1 = a0 => ({
  "unread": a0
});
function NotificationsListDialogComponent_ng_container_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_ng_container_0_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeDialog());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "clear");
    i0.ɵɵelementEnd()();
  }
}
function NotificationsListDialogComponent_ng_container_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
}
function NotificationsListDialogComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "a", 9);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_ng_container_0_div_5_Template_a_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.markNewsAsRead();
      $event.stopPropagation();
      return i0.ɵɵresetView(false);
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "layout.markNewsAsRead"), " ");
  }
}
function NotificationsListDialogComponent_ng_container_0_ng_container_6_hpo_placeholder_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hpo-placeholder", 11);
  }
  if (rf & 2) {
    i0.ɵɵproperty("width", "100%")("type", "row");
  }
}
function NotificationsListDialogComponent_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationsListDialogComponent_ng_container_0_ng_container_6_hpo_placeholder_1_Template, 1, 2, "hpo-placeholder", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", " ".repeat(5).split(""));
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h6", 16);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "layout.noCurrentNews"), " ");
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_3_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "priority_high");
    i0.ɵɵelementEnd();
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notification_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "layout." + notification_r5.dateText), "");
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notification_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, notification_r5.startDate, "shortDate"), "");
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_ng_container_0_div_7_div_3_Template_div_click_0_listener() {
      const notification_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openNotification(notification_r5));
    });
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, NotificationsListDialogComponent_ng_container_0_div_7_div_3_mat_icon_2_Template, 2, 0, "mat-icon", 0);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtemplate(5, NotificationsListDialogComponent_ng_container_0_div_7_div_3_ng_container_5_Template, 3, 3, "ng-container", 0)(6, NotificationsListDialogComponent_ng_container_0_div_7_div_3_ng_container_6_Template, 3, 4, "ng-container", 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const notification_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, notification_r5.isUnchecked));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notification_r5.important);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", notification_r5.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notification_r5.dateText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !notification_r5.dateText);
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "hpo-button", 21);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_ng_container_0_div_7_div_4_Template_hpo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.prevPage());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "chevron_left");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "blah");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "hpo-button", 21);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_ng_container_0_div_7_div_4_Template_hpo_button_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.nextPage());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "blah");
    i0.ɵɵelementStart(9, "mat-icon");
    i0.ɵɵtext(10, "chevron_right");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.currentPage <= 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "default.previous"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.currentPage >= ctx_r1.noOfPages);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, "default.next"), " ");
  }
}
function NotificationsListDialogComponent_ng_container_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, NotificationsListDialogComponent_ng_container_0_div_7_div_1_Template, 4, 3, "div", 0);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtemplate(3, NotificationsListDialogComponent_ng_container_0_div_7_div_3_Template, 7, 7, "div", 14)(4, NotificationsListDialogComponent_ng_container_0_div_7_div_4_Template, 11, 8, "div", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loading && ctx_r1.allNotificationItems.length == 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.pageItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.noOfPages > 1);
  }
}
function NotificationsListDialogComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
    i0.ɵɵtemplate(3, NotificationsListDialogComponent_ng_container_0_button_3_Template, 3, 0, "button", 4)(4, NotificationsListDialogComponent_ng_container_0_div_4_Template, 1, 0, "div", 0)(5, NotificationsListDialogComponent_ng_container_0_div_5_Template, 4, 3, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, NotificationsListDialogComponent_ng_container_0_ng_container_6_Template, 2, 1, "ng-container", 0)(7, NotificationsListDialogComponent_ng_container_0_div_7_Template, 5, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.fullScreenDialog);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.fullScreenDialog);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.unReadNotificationsCount);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loading);
  }
}
function NotificationsListDialogComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "hpo-button", 24);
    i0.ɵɵlistener("click", function NotificationsListDialogComponent_div_1_Template_hpo_button_click_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.notificationIsSelected = false);
    });
    i0.ɵɵelementStart(3, "mat-icon");
    i0.ɵɵtext(4, "keyboard_backspace");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "app-notification-item", 25);
    i0.ɵɵlistener("copyLinkEvent", function NotificationsListDialogComponent_div_1_Template_app_notification_item_copyLinkEvent_7_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.copyLink($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "layout.toNews"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("notification", ctx_r1.selectedNotification);
  }
}
const _forTrack0 = ($index, $item) => $item.email;
function CompanyAdminsDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.companyAdmins"));
  }
}
function CompanyAdminsDialogComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 3);
    i0.ɵɵelement(2, "hpo-placeholder", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵelement(4, "hpo-placeholder", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵelement(6, "hpo-placeholder", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 3);
    i0.ɵɵelement(8, "hpo-placeholder", 4);
    i0.ɵɵelementEnd()();
  }
}
function CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7)(1, "div", 9)(2, "div", 10)(3, "mat-icon");
    i0.ɵɵtext(4, "phone");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const companyAdmin_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("href", "tel:", companyAdmin_r1 == null ? null : companyAdmin_r1.phone, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", companyAdmin_r1 == null ? null : companyAdmin_r1.phone, " ");
  }
}
function CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 10)(2, "mat-icon");
    i0.ɵɵtext(3, "phone");
    i0.ɵɵelementEnd()()();
  }
}
function CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7)(1, "div", 9)(2, "div", 10)(3, "mat-icon");
    i0.ɵɵtext(4, "email");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 6)(6, "a", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const companyAdmin_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("href", "mailto:", companyAdmin_r1 == null ? null : companyAdmin_r1.email, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", companyAdmin_r1 == null ? null : companyAdmin_r1.email, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", companyAdmin_r1 == null ? null : companyAdmin_r1.email, " ");
  }
}
function CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 11)(2, "mat-icon");
    i0.ɵɵtext(3, "email");
    i0.ɵɵelementEnd()()();
  }
}
function CompanyAdminsDialogComponent_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_4_Template, 7, 3, "a", 7)(5, CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_5_Template, 4, 0, "div", 8)(6, CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_6_Template, 8, 5, "a", 7)(7, CompanyAdminsDialogComponent_Conditional_3_For_2_Conditional_7_Template, 4, 0, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const companyAdmin_r1 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", companyAdmin_r1 == null ? null : companyAdmin_r1.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional((companyAdmin_r1 == null ? null : companyAdmin_r1.phone) ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((companyAdmin_r1 == null ? null : companyAdmin_r1.email) ? 6 : 7);
  }
}
function CompanyAdminsDialogComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵrepeaterCreate(1, CompanyAdminsDialogComponent_Conditional_3_For_2_Template, 8, 3, "div", 3, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.companyAdmins);
  }
}
function CompanyAdminsDialogComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "hpo-button", 12);
    i0.ɵɵlistener("click", function CompanyAdminsDialogComponent_Conditional_4_Template_hpo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialog());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "layout.close"), " ");
  }
}
const _c2 = () => ({
  "disabled": true
});
const _c3 = a0 => ({
  "disabled": a0
});
function MessagesComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "layout.noMessages"));
  }
}
function MessagesComponent_div_11_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16)(3, "div", 17);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "date");
    i0.ɵɵelementStart(6, "span", 18);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 10);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_div_8_div_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.deleteSingleMessage(item_r5));
    });
    i0.ɵɵelementStart(10, "mat-icon");
    i0.ɵɵtext(11, "clear");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(12, "div", 19)(13, "div", 20)(14, "div");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div")(17, "a", 21);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_div_8_div_1_Template_a_click_17_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.navigate(item_r5.link));
    });
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div");
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(23, "button", 22);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_div_8_div_1_Template_button_click_23_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(item_r5.expanded = !item_r5.expanded);
    });
    i0.ɵɵelementStart(24, "mat-icon");
    i0.ɵɵtext(25, " expand_more ");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const item_r5 = ctx_r5.$implicit;
    const i_r7 = ctx_r5.index;
    const group_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("id", group_r2.productName + "-message-item-" + i_r7);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background-color", group_r2.color);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", group_r2.productName + "-message-item-header-" + i_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(5, 17, item_r5.timestamp, "d.M.y H:mm"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r5.messageType);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", item_r5.creator, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("@expandCollapse", item_r5.expanded ? "expanded" : "collapsed");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", group_r2.productName + "-message-item-content-" + i_r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.content);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", group_r2.productName + "-message-item-link-" + i_r7);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", item_r5.targetType, " ", item_r5.targetId, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.targetIdentifier);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.targetName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", group_r2.productName + "-message-item-" + (item_r5.expanded ? "collapse-" : "expand-") + i_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@expandCollapseIcon", item_r5.expanded ? "expanded" : "collapsed");
  }
}
function MessagesComponent_div_11_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MessagesComponent_div_11_div_8_div_1_Template, 26, 20, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r7 = ctx.index;
    const group_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r7 < group_r2.truncate);
  }
}
function MessagesComponent_div_11_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_div_9_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const group_r2 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(group_r2.truncate = group_r2.notifications.length);
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(2, 2, "layout.showMore"), " (", group_r2.notifications.length - group_r2.truncate, ") ");
  }
}
function MessagesComponent_div_11_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_div_10_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const group_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(group_r2.truncate = ctx_r2._defaultTruncateValue);
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "layout.showLess"), " ");
  }
}
function MessagesComponent_div_11_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
  }
}
function MessagesComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 8);
    i0.ɵɵelement(2, "img", 9);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 10);
    i0.ɵɵlistener("click", function MessagesComponent_div_11_Template_button_click_5_listener() {
      const group_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteSingleProductMessages(group_r2.productId));
    });
    i0.ɵɵelementStart(6, "mat-icon");
    i0.ɵɵtext(7, "clear");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, MessagesComponent_div_11_div_8_Template, 2, 1, "div", 6)(9, MessagesComponent_div_11_div_9_Template, 3, 4, "div", 11)(10, MessagesComponent_div_11_div_10_Template, 3, 3, "div", 11)(11, MessagesComponent_div_11_div_11_Template, 1, 0, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const group_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background-color", group_r2.color);
    i0.ɵɵproperty("id", group_r2.productName + "-message-group");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("src", group_r2.productIcon, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r2.productName);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", group_r2.notifications);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.notifications.length > group_r2.truncate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.truncate > ctx_r2._defaultTruncateValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", group_r2.truncate >= group_r2.notifications.length && ctx_r2.groupedMessages.length > 1);
  }
}
const _c4 = ["chatScrollView"];
const _c5 = (a0, a1) => ({
  "chat-window": a0,
  "chat-window-mobile": a1
});
const _c6 = a0 => ({
  "chat-header-desktop": a0
});
const _c7 = (a0, a1) => ({
  "chat-footer-desktop": a0,
  "chat-footer-mobile": a1
});
const _c8 = (a0, a1) => ({
  "sent-message": a0,
  "received-message": a1
});
function FloatingChatComponent_div_0_img_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.chatData.senderPicture, i0.ɵɵsanitizeUrl);
  }
}
function FloatingChatComponent_div_0_div_20_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.chatData.receivedMessageFooter, " ");
  }
}
function FloatingChatComponent_div_0_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "div", 20);
    i0.ɵɵpipe(6, "markdownToHtml");
    i0.ɵɵtemplate(7, FloatingChatComponent_div_0_div_20_div_7_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "floating-chat-message-", i_r4, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c8, message_r3.isOwn, !message_r3.isOwn));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", message_r3.isOwn ? ctx_r1.ownProfilePictureUrl : ctx_r1.chatData.senderPicture, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r3.isOwn ? ctx_r1.ownName : ctx_r1.chatData.senderName);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "floating-chat-message-content-", i_r4, "");
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(6, 9, message_r3.text), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !message_r3.isOwn && ctx_r1.chatData.receivedMessageFooter);
  }
}
function FloatingChatComponent_div_0_div_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 19);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 24)(6, "div", 25);
    i0.ɵɵelement(7, "div", 26)(8, "div", 26)(9, "div", 26);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.chatData.senderPicture, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.chatData.senderName);
  }
}
function FloatingChatComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, FloatingChatComponent_div_0_img_3_Template, 1, 1, "img", 5);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "mat-icon", 6);
    i0.ɵɵtext(7, "info");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 7)(9, "mat-icon", 8);
    i0.ɵɵpipe(10, "blah");
    i0.ɵɵlistener("click", function FloatingChatComponent_div_0_Template_mat_icon_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.contactSupport());
    });
    i0.ɵɵtext(11, "help");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 9);
    i0.ɵɵpipe(13, "blah");
    i0.ɵɵlistener("click", function FloatingChatComponent_div_0_Template_span_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resetState());
    });
    i0.ɵɵtext(14, " chat_add_on ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "mat-icon", 10);
    i0.ɵɵpipe(16, "blah");
    i0.ɵɵlistener("click", function FloatingChatComponent_div_0_Template_mat_icon_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleChat());
    });
    i0.ɵɵtext(17, "close");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "div", 11, 0);
    i0.ɵɵtemplate(20, FloatingChatComponent_div_0_div_20_Template, 8, 14, "div", 12)(21, FloatingChatComponent_div_0_div_21_Template, 10, 2, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 14)(23, "textarea", 15);
    i0.ɵɵtwoWayListener("ngModelChange", function FloatingChatComponent_div_0_Template_textarea_ngModelChange_23_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.userMessage, $event) || (ctx_r1.userMessage = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup.enter", function FloatingChatComponent_div_0_Template_textarea_keyup_enter_23_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.sendMessage());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "mat-icon", 16);
    i0.ɵɵpipe(25, "blah");
    i0.ɵɵlistener("click", function FloatingChatComponent_div_0_Template_mat_icon_click_24_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.sendMessage());
    });
    i0.ɵɵtext(26, "send");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c5, !ctx_r1.mobile, ctx_r1.mobile))("@floatIn", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c6, !ctx_r1.mobile));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.chatData.senderPicture);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.chatData.senderName);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r1.chatData.infoText);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(10, 16, "layout.helpdesk"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(13, 18, "layout.clearChat"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(16, 20, "layout.close"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.chatData.messageHistory);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.chatData.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(29, _c7, !ctx_r1.mobile, ctx_r1.mobile));
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", ctx_r1.chatData.placeholder)("maxLength", ctx_r1.chatData.messageMaxLength);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.userMessage);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(25, 22, "layout.send"));
  }
}
const _c9 = (a0, a1) => ({
  highlight: a0,
  colored: a1
});
function AppMenuButtonComponent_div_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 6);
    i0.ɵɵtext(2, "open_in_new");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("inline", true);
  }
}
function AppMenuButtonComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵtemplate(3, AppMenuButtonComponent_div_4_ng_container_3_Template, 3, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r0.title), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.newWindow);
  }
}
function AppMenuButtonComponent_div_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-icon", 6);
    i0.ɵɵtext(2, "open_in_new");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("inline", true);
  }
}
function AppMenuButtonComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AppMenuButtonComponent_div_5_ng_container_2_Template, 3, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.newWindow);
  }
}
function AppMenuButtonComponent_div_6_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_drop_up");
    i0.ɵɵelementEnd();
  }
}
function AppMenuButtonComponent_div_6_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_drop_down");
    i0.ɵɵelementEnd();
  }
}
function AppMenuButtonComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AppMenuButtonComponent_div_6_mat_icon_1_Template, 2, 0, "mat-icon", 5)(2, AppMenuButtonComponent_div_6_mat_icon_2_Template, 2, 0, "mat-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", ctx_r0.textColor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isOpen);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isOpen);
  }
}
function AppMenuSubButtonComponent_a_0_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 6);
    i0.ɵɵtext(1, "open_in_new");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("inline", true);
  }
}
function AppMenuSubButtonComponent_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, AppMenuSubButtonComponent_a_0_mat_icon_3_Template, 2, 1, "mat-icon", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("target", ctx_r0.newWindow ? "_blank" : null);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background-color", ctx_r0.backgroundColor)("color", ctx_r0.textColor);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c9, ctx_r0.highlight, ctx_r0.backgroundColor));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.newWindow);
  }
}
function AppMenuSubButtonComponent_a_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background-color", ctx_r0.backgroundColor)("color", ctx_r0.textColor);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c9, ctx_r0.highlight, ctx_r0.backgroundColor));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
  }
}
function AppMenuSubButtonComponent_a_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background-color", ctx_r0.backgroundColor)("color", ctx_r0.textColor);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c9, ctx_r0.highlight, ctx_r0.backgroundColor));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 6, ctx_r0.title), " ");
  }
}
function AppMenuSubButtonComponent_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function AppMenuSubButtonComponent_a_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.navigated.emit());
    });
    i0.ɵɵtemplate(1, AppMenuSubButtonComponent_a_1_div_1_Template, 2, 9, "div", 8)(2, AppMenuSubButtonComponent_a_1_div_2_Template, 3, 11, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.link)("queryParams", ctx_r0.linkQueryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.translate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.translate);
  }
}
function AppMenuSubButtonComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-color", ctx_r0.backgroundColor)("color", ctx_r0.textColor);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, "\n");
  }
}
function AppMenuComponent_ng_container_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵelement(1, "hpo-app-menu-button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", item_r1.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("target", item_r1.newWindow ? "_blank" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", item_r1.title)("icon", item_r1.icon)("dropdown", item_r1.hasSubItems)("isOpen", item_r1.subItemsOpened)("translate", item_r1.translate)("newWindow", item_r1.newWindow)("backgroundColor", item_r1.backgroundColor)("textColor", item_r1.textColor);
  }
}
function AppMenuComponent_ng_container_0_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵlistener("click", function AppMenuComponent_ng_container_0_a_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.navigated.emit());
    });
    i0.ɵɵelement(1, "hpo-app-menu-button", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r1.link)("queryParams", item_r1.linkQueryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", item_r1.title)("icon", item_r1.icon)("dropdown", item_r1.hasSubItems)("isOpen", item_r1.subItemsOpened)("translate", item_r1.translate)("backgroundColor", item_r1.backgroundColor)("textColor", item_r1.textColor);
  }
}
function AppMenuComponent_ng_container_0_hpo_app_menu_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-button", 9);
    i0.ɵɵlistener("click", function AppMenuComponent_ng_container_0_hpo_app_menu_button_3_Template_hpo_app_menu_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleSubMenu(item_r1));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", item_r1.title)("icon", item_r1.icon)("dropdown", item_r1.hasSubItems)("isOpen", item_r1.subItemsOpened)("translate", item_r1.translate)("backgroundColor", item_r1.backgroundColor)("textColor", item_r1.textColor);
  }
}
function AppMenuComponent_ng_container_0_div_4_hpo_app_menu_sub_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-sub-button", 12);
    i0.ɵɵlistener("navigated", function AppMenuComponent_ng_container_0_div_4_hpo_app_menu_sub_button_1_Template_hpo_app_menu_sub_button_navigated_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.navigated.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const subItem_r6 = ctx.$implicit;
    const item_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("title", subItem_r6.title)("link", subItem_r6.link)("linkQueryParams", subItem_r6.linkQueryParams)("newWindow", subItem_r6.newWindow)("translate", item_r1.translate)("backgroundColor", subItem_r6.backgroundColor)("textColor", subItem_r6.textColor);
  }
}
function AppMenuComponent_ng_container_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, AppMenuComponent_ng_container_0_div_4_hpo_app_menu_sub_button_1_Template, 1, 7, "hpo-app-menu-sub-button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r1.subItems);
  }
}
function AppMenuComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AppMenuComponent_ng_container_0_a_1_Template, 2, 10, "a", 1)(2, AppMenuComponent_ng_container_0_a_2_Template, 2, 9, "a", 2)(3, AppMenuComponent_ng_container_0_hpo_app_menu_button_3_Template, 1, 7, "hpo-app-menu-button", 3)(4, AppMenuComponent_ng_container_0_div_4_Template, 2, 1, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r1.hasSubItems && (item_r1.link.startsWith("http") || item_r1.newWindow));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r1.hasSubItems && !item_r1.link.startsWith("http") && !item_r1.newWindow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.hasSubItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.hasSubItems && item_r1.subItemsOpened);
  }
}
const _c10 = ["sidenav"];
const _c11 = (a0, a1, a2, a3) => ({
  "mobile": a0,
  "desktop": a1,
  "search-active": a2,
  "search-inactive": a3
});
const _c12 = a0 => ({
  "max-width": a0
});
const _c13 = (a0, a1) => ({
  "mat-sidenav-desktop": a0,
  "mat-sidenav-handheld": a1
});
const _c14 = (a0, a1) => ({
  "messages-drawer": true,
  "messages-drawer-desktop": a0,
  "messages-drawer-handheld": a1
});
const _c15 = (a0, a1) => ({
  "bottom": a0,
  "right": a1
});
const _c16 = () => ({
  height: 58
});
const _c17 = a0 => ({
  value: "*",
  params: a0
});
function HpoLayoutComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.environmentNote, " ");
  }
}
function HpoLayoutComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48)(1, "button", 49, 1);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      i0.ɵɵnextContext();
      const sidenav_r4 = i0.ɵɵreference(17);
      return i0.ɵɵresetView(sidenav_r4.toggle());
    });
    i0.ɵɵelement(3, "div", 50);
    i0.ɵɵelementStart(4, "span", 51);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "menu");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const appBarButton_r5 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matRippleTrigger", appBarButton_r5)("matRippleCentered", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 3, "layout.menu"));
  }
}
function HpoLayoutComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div")(6, "small");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.applicationName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.getApplicationPageName());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.getApplicationPageSubtitle());
  }
}
function HpoLayoutComponent_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoLayoutComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_7_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.applicationSpecificTemplate);
  }
}
function HpoLayoutComponent_div_8_hpo_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-button", 56);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_8_hpo_button_1_Template_hpo_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openNotificationsListDialog());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matBadgeHidden", ctx_r1.uncheckedNews.length === 0)("matBadge", ctx_r1.uncheckedNews.length)("matBadgeOverlap", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, "layout.productNews"), " ");
  }
}
function HpoLayoutComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_8_hpo_button_1_Template, 3, 6, "hpo-button", 55);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.handsetLayout);
  }
}
function HpoLayoutComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoLayoutComponent_div_11_button_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "notifications_none");
    i0.ɵɵelementEnd();
  }
}
function HpoLayoutComponent_div_11_button_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "notification_important");
    i0.ɵɵelementEnd();
  }
}
function HpoLayoutComponent_div_11_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 59);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_11_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleMessages());
    });
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_11_button_1_Conditional_1_Template, 2, 0, "mat-icon")(2, HpoLayoutComponent_div_11_button_1_Conditional_2_Template, 2, 0, "mat-icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("color", ctx_r1.newMessageCount === 0 ? "default" : "accent")("matBadge", ctx_r1.newMessageCount)("matBadgeHidden", ctx_r1.newMessageCount === 0);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.newMessageCount === 0 ? 1 : ctx_r1.newMessageCount > 0 ? 2 : -1);
  }
}
function HpoLayoutComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_11_button_1_Template, 3, 4, "button", 58);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.handsetLayout);
  }
}
function HpoLayoutComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoLayoutComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_14_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleChat());
    });
    i0.ɵɵelementStart(1, "mat-icon", 61);
    i0.ɵɵtext(2, "chat");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(1, _c15, (tmp_2_0 = ctx_r1.chatData.floatingButtonPosition == null ? null : ctx_r1.chatData.floatingButtonPosition.bottom) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "6rem", (tmp_2_0 = ctx_r1.chatData.floatingButtonPosition == null ? null : ctx_r1.chatData.floatingButtonPosition.right) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "2.8rem"));
  }
}
function HpoLayoutComponent_hpo_app_menu_button_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-button", 62);
    i0.ɵɵpipe(1, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_hpo_app_menu_button_31_Template_hpo_app_menu_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openNotificationsListDialog());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "layout.productNews"));
  }
}
function HpoLayoutComponent_hpo_app_menu_button_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-button", 63);
    i0.ɵɵpipe(1, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_hpo_app_menu_button_37_Template_hpo_app_menu_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.toggleChat();
      return i0.ɵɵresetView(ctx_r1.menuNavigated());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "layout.chat"));
    i0.ɵɵproperty("dropdown", false);
  }
}
function HpoLayoutComponent_div_40_hpo_app_menu_sub_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-sub-button", 66);
    i0.ɵɵpipe(1, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_40_hpo_app_menu_sub_button_1_Template_hpo_app_menu_sub_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.openCompanyAdminsDialog();
      return i0.ɵɵresetView(ctx_r1.menuNavigated());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "layout.companyAdmins"));
    i0.ɵɵproperty("disableLink", true);
  }
}
function HpoLayoutComponent_div_40_hpo_app_menu_sub_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hpo-app-menu-sub-button", 68);
    i0.ɵɵpipe(1, "blah");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "layout.userguide"));
    i0.ɵɵproperty("newWindow", true)("link", ctx_r1.productManualUrl);
  }
}
function HpoLayoutComponent_div_40_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_40_hpo_app_menu_sub_button_1_Template, 2, 4, "hpo-app-menu-sub-button", 64)(2, HpoLayoutComponent_div_40_hpo_app_menu_sub_button_2_Template, 2, 5, "hpo-app-menu-sub-button", 65);
    i0.ɵɵelementStart(3, "hpo-app-menu-sub-button", 66);
    i0.ɵɵpipe(4, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_40_Template_hpo_app_menu_sub_button_click_3_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.openHelpdeskDialog(true);
      return i0.ɵɵresetView(ctx_r1.menuNavigated());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "hpo-app-menu-sub-button", 67);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_40_Template_hpo_app_menu_sub_button_click_5_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.openHelpdeskDialog(false);
      return i0.ɵɵresetView(ctx_r1.menuNavigated());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentUser.LimitedUser !== false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.currentUser.LimitedUser !== false);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 6, "layout.helpdesk"));
    i0.ɵɵproperty("disableLink", true);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 8, "layout.feedback"));
    i0.ɵɵproperty("disableLink", true);
  }
}
function HpoLayoutComponent_div_43_hpo_app_menu_sub_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-app-menu-sub-button", 70);
    i0.ɵɵpipe(1, "blah");
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_43_hpo_app_menu_sub_button_1_Template_hpo_app_menu_sub_button_click_0_listener() {
      const locale_r14 = i0.ɵɵrestoreView(_r13).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.changeLocale(locale_r14);
      return i0.ɵɵresetView(ctx_r1.languageDropdownOpen = false);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const locale_r14 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 2, "layout.locales." + locale_r14));
    i0.ɵɵproperty("disableLink", true);
  }
}
function HpoLayoutComponent_div_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, HpoLayoutComponent_div_43_hpo_app_menu_sub_button_1_Template, 2, 4, "hpo-app-menu-sub-button", 69);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.availableLocales);
  }
}
function HpoLayoutComponent_ng_container_46_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 29);
    i0.ɵɵelementStart(2, "section", 71)(3, "hpo-app-menu-button", 72);
    i0.ɵɵlistener("click", function HpoLayoutComponent_ng_container_46_Template_hpo_app_menu_button_click_3_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.debugInfoVisible = !ctx_r1.debugInfoVisible;
      return i0.ɵɵresetView(ctx_r1.menuNavigated());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
}
function HpoLayoutComponent_div_47_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73)(1, "div", 74);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_47_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.impactCounterVisible = !ctx_r1.impactCounterVisible);
    });
    i0.ɵɵtext(2, " v. ");
    i0.ɵɵelementStart(3, "span", 75);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 76)(6, "span", 77);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9, " / ");
    i0.ɵɵelementStart(10, "span", 78);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "number");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.appVersion);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.impactCounterVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 4, ctx_r1.cumulativeImpact, "1.0-1"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(12, 7, ctx_r1.impactTreshold, "1.0-1"));
  }
}
function HpoLayoutComponent_ng_container_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoLayoutComponent_router_outlet_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "router-outlet");
  }
}
function HpoLayoutComponent_hpo_card_63_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "hpo-card")(1, "hpo-card-header");
    i0.ɵɵtext(2, " Debug ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 79)(4, "hpo-card-content")(5, "h4");
    i0.ɵɵtext(6, "Environment");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "pre");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "json");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "hpo-card-content")(11, "h4");
    i0.ɵɵtext(12, "Claims");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "pre");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "json");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 2, ctx_r1.environmentVariables));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 4, ctx_r1.claims));
  }
}
function HpoLayoutComponent_app_floating_chat_64_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-floating-chat", 80);
    i0.ɵɵlistener("chatState", function HpoLayoutComponent_app_floating_chat_64_Template_app_floating_chat_chatState_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleChatState($event));
    })("messageSent", function HpoLayoutComponent_app_floating_chat_64_Template_app_floating_chat_messageSent_0_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleChatMessageSent($event));
    })("contactSupportEmitter", function HpoLayoutComponent_app_floating_chat_64_Template_app_floating_chat_contactSupportEmitter_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openHelpdeskDialog(true));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("chatVisible", ctx_r1.isChatOpen)("ownProfilePictureUrl", ctx_r1.currentUser.picture)("ownName", ctx_r1.currentUser.givenName)("mobile", ctx_r1.handsetLayout)("chatData", ctx_r1.chatData);
  }
}
function HpoLayoutComponent_div_65_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 84)(2, "mat-icon");
    i0.ɵɵtext(3, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 85);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_65_ng_container_2_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeSwUpdateNotification());
    });
    i0.ɵɵtext(8, " OK ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "layout.updateFailed"));
  }
}
function HpoLayoutComponent_div_65_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 84)(2, "mat-icon");
    i0.ɵɵtext(3, "info");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "blah");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "button", 85);
    i0.ɵɵlistener("click", function HpoLayoutComponent_div_65_ng_container_3_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeSwUpdateNotification());
    });
    i0.ɵɵtext(8, " OK ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "layout.updateDone"));
  }
}
function HpoLayoutComponent_div_65_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81);
    i0.ɵɵelementContainerStart(1, 82);
    i0.ɵɵtemplate(2, HpoLayoutComponent_div_65_ng_container_2_Template, 9, 3, "ng-container", 83)(3, HpoLayoutComponent_div_65_ng_container_3_Template, 9, 3, "ng-container", 83);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mobile", ctx_r1.handsetLayout)("note", ctx_r1.swUpdateEventType === "VERSION_READY" || ctx_r1.swUpdateEventType === "VERSION_DETECTED")("warn", ctx_r1.swUpdateEventType === "VERSION_INSTALLATION_FAILED")("success", ctx_r1.swUpdateEventType === "NO_NEW_VERSION_DETECTED");
    i0.ɵɵproperty("@slideTop", i0.ɵɵpureFunction1(13, _c17, i0.ɵɵpureFunction0(12, _c16)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", ctx_r1.swUpdateEventType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "VERSION_INSTALLATION_FAILED");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "NO_NEW_VERSION_DETECTED");
  }
}
var ToastDuration = /*#__PURE__*/function (ToastDuration) {
  /**
   * Short duration (`3000` ms)
   */
  ToastDuration[ToastDuration["short"] = 3000] = "short";
  /**
   * Normal duration (`5000` ms)
   */
  ToastDuration[ToastDuration["normal"] = 5000] = "normal";
  /**
   * Long duration (`10000` ms)
   */
  ToastDuration[ToastDuration["long"] = 10000] = "long";
  /**
   * Extra long duration (`15000` ms)
   */
  ToastDuration[ToastDuration["extra"] = 15000] = "extra";
  /**
   * Persistent toast
   *
   * **Note!** Wont dismiss unless action button is clicked or explicitly dismissed from code.
   */
  ToastDuration[ToastDuration["persistent"] = -1] = "persistent";
  return ToastDuration;
}(ToastDuration || {});
/**
 * Toast reference.
 */
class ToastRef {
  constructor(actionSubject, dismissSubject, dismissControlSubject) {
    this.actionSubject = actionSubject;
    this.dismissSubject = dismissSubject;
    this.dismissControlSubject = dismissControlSubject;
  }
  // TODO: Remove after all implementations have been migrated to use the Finnish notation
  /**
   * Toast action observable
   *
   * @deprecated Use the Finnish notation variant `action$`.
   */
  get action() {
    return this.action$;
  }
  /**
   * Toast action observable
   */
  get action$() {
    return this.actionSubject.asObservable();
  }
  /**
   * Toast dismiss observable
   */
  get dismiss$() {
    return this.dismissSubject.asObservable();
  }
  /**
   * Dismisses the toast immediately.
   */
  dismiss() {
    // Include a flag that indicates whether the toast was opened before dismiss is called
    this.dismissControlSubject.next(this.dismissControlSubject.observed);
    this.dismissControlSubject.complete();
  }
}
let ToasterService = /*#__PURE__*/(() => {
  class ToasterService {
    constructor(snackBar) {
      this.snackBar = snackBar;
      this.queueSubject = new Subject();
      this.initQueue();
    }
    ngOnDestroy() {
      this.queueSubject.complete();
    }
    /**
     * Creates a toast and adds it to the show queue.
     *
     * @param message Toast message
     * @param options Toast options. *Optional.*
     * @returns Reference to the created toast
     */
    create(message, options = {}) {
      if (!message) {
        throw new Error('[ToasterService] Cannot create a toast with empty message.');
      }
      const toast = {
        message,
        actionLabel: options.actionLabel || void 0,
        duration: options.duration || ToastDuration.normal,
        color: options.color || 'default',
        actionSubject: new Subject(),
        dismissSubject: new Subject(),
        dismissControlSubject: new ReplaySubject(1)
      };
      this.queueSubject.next(toast);
      return new ToastRef(toast.actionSubject, toast.dismissSubject, toast.dismissControlSubject);
    }
    initQueue() {
      this.queueSubject.pipe(concatMap(toast => this.processToast(toast))).subscribe();
    }
    async processToast(toast) {
      const snackBarRef = this.snackBar.open(toast.message, toast.actionLabel, {
        duration: toast.duration,
        panelClass: toast.color + '-color'
      });
      snackBarRef.onAction().subscribe(() => {
        toast.actionSubject.next();
        toast.actionSubject.complete();
      });
      snackBarRef.afterDismissed().subscribe(result => {
        // Complete subjects if they're still active
        toast.actionSubject.complete();
        toast.dismissControlSubject.complete();
        toast.dismissSubject.next({
          dismissedByAction: result.dismissedByAction
        });
        toast.dismissSubject.complete();
      });
      let toastOpenedBeforeDismissed = true;
      toast.dismissControlSubject.subscribe(opened => {
        // Set toast opened before dismiss is called flag according to the ref subject stream's result.
        // This works as replay subject replays the stream synchronously, before the await block.
        if (!opened) {
          toastOpenedBeforeDismissed = false;
        }
        snackBarRef.dismiss();
      });
      // Await for the toast to be dismissed before returning to queue
      await firstValueFrom(snackBarRef.afterDismissed().pipe(delay(toastOpenedBeforeDismissed ? 500 : 0)));
      return toast;
    }
    static {
      this.ɵfac = function ToasterService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ToasterService)(i0.ɵɵinject(i1.MatSnackBar));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ToasterService,
        factory: ToasterService.ɵfac
      });
    }
  }
  return ToasterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedService = /*#__PURE__*/(() => {
  class SharedService {
    constructor(http) {
      this.http = http;
      this.unexpiredUrl = 'EventStream.WebAPI/odata/GetUnexpiredNewsForProduct?productId={productId}&language={language}';
      this.unexpiredAndUnCheckedUrl = 'EventStream.WebAPI/odata/GetUnexpiredAndUncheckedNewsForProduct?productId={productId}&language={language}';
      this.markAsReadUrl = 'EventStream.WebAPI/odata/MarkEventLogAsRead';
      this.markNewsAsReadUrl = 'EventStream.WebAPI/odata/MarkNewsAsRead';
      this.applicationDataForPersonUrl = 'WebAPI/api/Product/GetLicencedApplications/?language={language}';
      this.helpdeskRequestUrl = 'WebAPI/api/Support/HelpdeskRequest';
      this.hasProductUsageRightUrl = 'WebAPI/api/Product/HasUsageRight?productId={0}&includePartnerLicenses={1}';
      this.changeUserLanguageUrl = 'WebAPI/api/User/ChangeUserLanguage';
      this.getTextObjectUrl = 'Settings.WebAPI/api/Settings/GetTextObject?textType={texttype}&applicationType={applicationtype}&language={language}';
      this.getSettingsValueUrl = 'Settings.WebAPI/api/Settings/GetSettingsValue?applicationType={applicationType}&settingsName={settingsName}';
      this.setSettingsValueUrl = 'Settings.WebAPI/api/Settings/SetSettingsValue?applicationType={applicationType}&settingsType={settingsType}&settingsName={settingsName}&value={value}';
      this.favouriteUpdateSubject = new Subject();
    }
    ngOnDestroy() {
      this.favouriteUpdateSubject.complete();
    }
    /**
    * Gets unexpired news
    * @param productId product id
    * @param language language
    */
    getUnexpiredNews(productId, language) {
      const url = this.backendPortalUri + this.unexpiredUrl.replace('{productId}', encodeURIComponent(productId)).replace('{language}', encodeURIComponent(language));
      return this.http.get(url);
    }
    /**
    * Gets unchecked news
    * @param productId product id
    * @param language language
    */
    getUncheckedNews(productId, language) {
      const url = this.backendPortalUri + this.unexpiredAndUnCheckedUrl.replace('{productId}', encodeURIComponent(productId)).replace('{language}', encodeURIComponent(language));
      return this.http.get(url);
    }
    /**
    * Marks notification as read
    * @param objectId Notification id
    */
    markNotificationAsRead(objectId) {
      return this.http.post(this.backendPortalUri + this.markAsReadUrl, {
        EventId: objectId
      });
    }
    /**
    * Marks news as read
    * @param markNewsAsReadParameters Product id
    */
    markNewsAsRead(markNewsAsReadParameters) {
      const url = this.backendPortalUri + this.markNewsAsReadUrl;
      return this.http.post(url, markNewsAsReadParameters);
    }
    getApplicationData(language) {
      const url = this.backendPortalUri + this.applicationDataForPersonUrl.replace('{language}', encodeURIComponent(language));
      return this.http.get(url);
    }
    updateFavourites() {
      this.favouriteUpdateSubject.next();
    }
    get favouriteUpdateRequest() {
      return this.favouriteUpdateSubject.asObservable();
    }
    changeUserLanguage(locale) {
      const requestUrl = this.backendPortalUri + this.changeUserLanguageUrl;
      return this.http.put(requestUrl, {
        Language: locale
      });
    }
    getUserInfo(userId) {
      const requestUrl = this.backendPortalUri + `WebAPI/odata/UserAdministrator(${userId})`;
      return this.http.get(requestUrl);
    }
    getTextObject(textType, applicationType, language) {
      const requestUrl = this.backendPortalUri + this.getTextObjectUrl.replace('{texttype}', encodeURIComponent(textType.toString())).replace('{applicationtype}', encodeURIComponent(applicationType.toString())).replace('{language}', encodeURIComponent(language));
      return this.http.get(requestUrl);
    }
    getSettingsValue(applicationType, settingsName) {
      const requestUrl = this.backendPortalUri + this.getSettingsValueUrl.replace('{applicationType}', encodeURIComponent(applicationType.toString())).replace('{settingsName}', encodeURIComponent(settingsName.toString()));
      return this.http.get(requestUrl);
    }
    setSettingsValue(applicationType, settingsType, settingsName, value) {
      const requestUrl = this.backendPortalUri + this.setSettingsValueUrl.replace('{applicationType}', encodeURIComponent(applicationType.toString())).replace('{settingsType}', encodeURIComponent(settingsType.toString())).replace('{settingsName}', encodeURIComponent(settingsName.toString())).replace('{value}', encodeURIComponent(value.toString()));
      return this.http.post(requestUrl, {});
    }
    sendHelpdeskRequest(request) {
      const requestUrl = this.backendPortalUri + this.helpdeskRequestUrl;
      return this.http.post(requestUrl, {
        SenderName: request.name,
        Email: request.email,
        SenderPhone: request.phone,
        Company: request.company,
        Subject: request.subject,
        Message: request.description,
        SendCopyToEmail: request.sendCopy,
        IsHelpdeskCall: request.supportRequest,
        ProductId: request.productId,
        Position: request.location,
        UserAgent: window.navigator.userAgent
      });
    }
    /**
    * Checks if user has product right
    * @param productId product id
    * @param includePartnerLicenses include partner licenses boolean (optional default true)
    */
    hasProductUsageRight(productId, includePartnerLicenses = true) {
      const url = this.backendPortalUri + this.hasProductUsageRightUrl.replace('{0}', productId.toString()).replace('{1}', includePartnerLicenses.toString());
      return this.fetchData(url);
    }
    /**
    * Gets company users
    */
    getCompanyUsers() {
      const requestUrl = this.backendPortalUri + `WebAPI/api/User/CompanyUsers`;
      return this.http.get(requestUrl);
    }
    getProductManualIndex(productId) {
      const url = this.backendPortalUri + `WebAPI/api/Product/GetManualIndexForProduct?productId=${productId}`;
      return this.http.get(url).pipe(map(result => ({
        fi: result.Fi,
        sv: result.Sv,
        en: result.En
      })));
    }
    fetchData(url) {
      return this.http.get(url);
    }
    static {
      this.ɵfac = function SharedService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SharedService)(i0.ɵɵinject(i1$1.HttpClient));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SharedService,
        factory: SharedService.ɵfac
      });
    }
  }
  return SharedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GridColumnDirective = /*#__PURE__*/(() => {
  class GridColumnDirective {
    constructor(element) {
      this.element = element;
    }
    ngOnInit() {
      this.element.nativeElement.style.gridColumn = this.gridColumn;
    }
    static {
      this.ɵfac = function GridColumnDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GridColumnDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: GridColumnDirective,
        selectors: [["", "gridColumn", ""]],
        inputs: {
          gridColumn: "gridColumn"
        }
      });
    }
  }
  return GridColumnDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GridRowDirective = /*#__PURE__*/(() => {
  class GridRowDirective {
    constructor(element) {
      this.element = element;
    }
    ngOnInit() {
      this.element.nativeElement.style.gridRow = this.gridRow;
    }
    static {
      this.ɵfac = function GridRowDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GridRowDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: GridRowDirective,
        selectors: [["", "gridRow", ""]],
        inputs: {
          gridRow: "gridRow"
        }
      });
    }
  }
  return GridRowDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HelpdeskDialogComponent = /*#__PURE__*/(() => {
  class HelpdeskDialogComponent {
    constructor(blahService, dialogRef, dialogData, fb, toaster, sharedService) {
      this.blahService = blahService;
      this.dialogRef = dialogRef;
      this.dialogData = dialogData;
      this.fb = fb;
      this.toaster = toaster;
      this.sharedService = sharedService;
      this.submitting = false;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.blahService.localeChange$.pipe(takeUntil(this.destroy$)).subscribe(newLocale => this.currentLocale = newLocale);
      this.currentLocale = this.blahService.currentLocale;
      this.fullScreenDialog = this.dialogData.fullScreenDialog;
      this.supportRequest = this.dialogData.supportRequest;
      this.location = this.dialogData.location;
      this.productId = this.dialogData.productId;
      this.claims = this.dialogData.claims;
      this.contactInformationText = this.dialogData.contactInformationText;
      // Subscribe to full-screen dialog action observable
      if (this.fullScreenDialog && this.dialogData.actionClicked) {
        this.dialogData.actionClicked.pipe(takeUntil(this.destroy$)).subscribe(() => this.submitForm());
      }
      this.helpdeskForm = this.fb.group({
        name: [this.fullName, [Validators.required]],
        email: [this.claims['email'] || '', [Validators.required, Validators.email]],
        phone: [this.claims['phone_number'] || ''],
        company: [this.claims['headpower:company_name'] || ''],
        subject: ['', [Validators.required]],
        description: ['', [Validators.required]],
        sendCopy: [false]
      });
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    get fullName() {
      return `${this.claims['given_name'] || ''} ${this.claims['family_name'] || ''}`;
    }
    errors(control) {
      return this.helpdeskForm.get(control).errors;
    }
    closeDialog() {
      this.dialogRef.close();
    }
    submitForm() {
      // Continue only if submitting is enabled
      if (this.submitting) {
        return;
      }
      // A little trick to set the form to submitted state.
      // Shows remaining errors to user.
      this.helpdeskFormRef.submitted = true;
      // Check if form is valid and display toast if it's not
      if (this.helpdeskForm.invalid) {
        this.toaster.create(this.blahService.blah('layout.formContainsErrors'));
        return;
      }
      this.submitting = true;
      const values = this.helpdeskForm.value;
      this.sharedService.sendHelpdeskRequest({
        supportRequest: this.supportRequest,
        location: this.location,
        productId: this.productId,
        name: values.name,
        email: values.email,
        phone: values.phone,
        company: values.company,
        subject: values.subject,
        description: values.description,
        sendCopy: values.sendCopy
      }).subscribe(result => this.toaster.create(this.blahService.blah(this.supportRequest ? 'layout.supportRequestSent' : 'layout.feedbackSent')), error => {
        this.submitting = false;
        this.toaster.create(this.blahService.blah('layout.formCannotBeSent'));
      });
      this.dialogRef.close();
    }
    static {
      this.ɵfac = function HelpdeskDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HelpdeskDialogComponent)(i0.ɵɵdirectiveInject(i1$2.BlahService), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(ToasterService), i0.ɵɵdirectiveInject(SharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HelpdeskDialogComponent,
        selectors: [["hpo-helpdesk-dialog"]],
        viewQuery: function HelpdeskDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpdeskFormRef = _t.first);
          }
        },
        decls: 52,
        vars: 30,
        consts: [["helpdeskFg", "ngForm"], ["mat-dialog-title", ""], [1, "subheading-text", "leading-top", 3, "innerHTML"], [1, "subheading-text", "leading-top"], ["novalidate", "", 1, "form-container", 3, "formGroup"], ["gridRow", "1", "gridColumn", "1 / 3"], ["matInput", "", "id", "HelpdeskName", "required", "", "formControlName", "name"], ["gridRow", "1", "gridColumn", "3 / 5"], ["matInput", "", "id", "HelpdeskCompany", "formControlName", "company"], ["gridRow", "2", "gridColumn", "1 / 3"], ["matInput", "", "id", "HelpdeskEmail", "required", "", "formControlName", "email"], ["gridRow", "2", "gridColumn", "3 / 5"], ["matInput", "", "id", "HelpdeskPhone", "formControlName", "phone"], ["gridRow", "3", "gridColumn", "1 / 5"], ["matInput", "", "id", "HelpdeskSubject", "required", "", "formControlName", "subject"], ["gridRow", "4", "gridColumn", "1 / 5"], ["matInput", "", "matTextareaAutosize", "", "matAutosizeMinRows", "1", "matAutosizeMaxRows", "25", "id", "HelpdeskDescription", "required", "", "formControlName", "description"], ["gridRow", "5", "gridColumn", "1 / 5", 1, "checkbox-container"], ["id", "HelpdeskSendCopy", "formControlName", "sendCopy"], ["mat-dialog-actions", "", "align", "end"], [3, "click"], ["color", "accent", 3, "click", "disabled"]],
        template: function HelpdeskDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HelpdeskDialogComponent_Conditional_1_Template, 1, 1, "div", 2)(2, HelpdeskDialogComponent_Conditional_2_Template, 3, 3, "p", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div")(4, "form", 4, 0)(6, "div", 5)(7, "mat-form-field")(8, "mat-label");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "input", 6);
            i0.ɵɵtemplate(12, HelpdeskDialogComponent_Conditional_12_Template, 3, 3, "mat-error");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 7)(14, "mat-form-field")(15, "mat-label");
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "div", 9)(20, "mat-form-field")(21, "mat-label");
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(24, "input", 10);
            i0.ɵɵtemplate(25, HelpdeskDialogComponent_Conditional_25_Template, 3, 3, "mat-error")(26, HelpdeskDialogComponent_Conditional_26_Template, 3, 3, "mat-error");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "div", 11)(28, "mat-form-field")(29, "mat-label");
            i0.ɵɵtext(30);
            i0.ɵɵpipe(31, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(32, "input", 12);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(33, "div", 13)(34, "mat-form-field")(35, "mat-label");
            i0.ɵɵtext(36);
            i0.ɵɵpipe(37, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(38, "input", 14);
            i0.ɵɵtemplate(39, HelpdeskDialogComponent_Conditional_39_Template, 3, 3, "mat-error");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(40, "div", 15)(41, "mat-form-field")(42, "mat-label");
            i0.ɵɵtext(43);
            i0.ɵɵpipe(44, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(45, "textarea", 16);
            i0.ɵɵtemplate(46, HelpdeskDialogComponent_Conditional_46_Template, 3, 3, "mat-error");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(47, "div", 17)(48, "mat-checkbox", 18);
            i0.ɵɵtext(49);
            i0.ɵɵpipe(50, "blah");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(51, HelpdeskDialogComponent_Conditional_51_Template, 7, 7, "div", 19);
          }
          if (rf & 2) {
            let tmp_5_0;
            let tmp_8_0;
            let tmp_11_0;
            let tmp_13_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.supportRequest ? 1 : 2);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("mat-mdc-dialog-content", !ctx.fullScreenDialog);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.helpdeskForm);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 16, "layout.name"));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(((tmp_5_0 = ctx.errors("name")) == null ? null : tmp_5_0.required) ? 12 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 18, "layout.company"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 20, "layout.email"));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(((tmp_8_0 = ctx.errors("email")) == null ? null : tmp_8_0.required) ? 25 : ((tmp_8_0 = ctx.errors("email")) == null ? null : tmp_8_0.email) ? 26 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 22, "layout.phone"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(37, 24, "layout.subjectQuestion"));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(((tmp_11_0 = ctx.errors("subject")) == null ? null : tmp_11_0.required) ? 39 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(44, 26, "layout.description"));
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(((tmp_13_0 = ctx.errors("description")) == null ? null : tmp_13_0.required) ? 46 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(50, 28, "layout.sendMeCopy"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.fullScreenDialog ? 51 : -1);
          }
        },
        dependencies: [i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i2.MatDialogTitle, i2.MatDialogActions, i6.MatInput, i7.MatFormField, i7.MatLabel, i7.MatError, i8.MatCheckbox, i7$1.ButtonComponent, GridColumnDirective, GridRowDirective, i1$2.BlahPipe],
        styles: [".leading-top[_ngcontent-%COMP%]{margin-top:0}.form-container[_ngcontent-%COMP%]{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:1.6rem}.form-container[_ngcontent-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{min-height:35px}@media (max-width: 959.98px){.form-container[_ngcontent-%COMP%]{display:block}.form-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-bottom:1.6rem}}"]
      });
    }
  }
  return HelpdeskDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Class for the menu item
 */
class MenuItem {
  /**
   * Constructor for the menu item
   *
   * @param title Menu item title
   * @param link Menu item link
   * @param options Menu item options
   */
  constructor(title, link, options) {
    this.title = title;
    this.translate = true;
    this.transParams = undefined;
    this.link = link;
    this.newWindow = false;
    this.icon = undefined;
    this.backgroundColor = options?.backgroundColor;
    this.textColor = options?.textColor;
    this.subItems = [];
    this.subItemsOpened = false;
    this.linkQueryParams = null;
    this.selected = false;
    if (options) {
      if (typeof options.translate !== 'undefined') this.translate = options.translate;
      if (typeof options.transParams !== 'undefined') this.transParams = options.transParams;
      if (typeof options.newWindow !== 'undefined') this.newWindow = options.newWindow;
      if (typeof options.icon !== 'undefined') this.icon = options.icon;
      if (typeof options.subItems !== 'undefined') this.subItems = options.subItems;
      if (typeof options.subItems !== 'undefined') this.subItems = options.subItems;
      if (typeof options.queryParams !== 'undefined') this.linkQueryParams = options.queryParams;
    }
  }
  /**
   * Determines if menu item has sub items
   */
  get hasSubItems() {
    return Array.isArray(this.subItems) && this.subItems.length > 0;
  }
}
class Notification {
  constructor() {
    this.objectId = '';
    this.title = '';
    this.content = '';
    this.created = '';
    this.startDate = '';
    this.eventId = 0;
    this.isUnchecked = false;
    this.isSelected = false;
    this.important = false;
    this.dateText = '';
  }
}
let ImportantNewsDialogComponent = /*#__PURE__*/(() => {
  class ImportantNewsDialogComponent {
    constructor(data, sharedService, dialogRef, sanitizer) {
      this.data = data;
      this.sharedService = sharedService;
      this.dialogRef = dialogRef;
      this.sanitizer = sanitizer;
      this.updateRequest = new EventEmitter();
    }
    ngOnInit() {
      this.fullScreenDialog = this.data.fullScreenDialog;
      this.title = this.data.notification.title;
      this.content = this.data.notification.content;
      this.notification = this.data.notification;
      this.uncheckedNews = this.data.uncheckedNews;
      // Bypass html sanitization as the content is trusted and non user editable
      if (this.notification) {
        this.trustedContent = this.sanitizer.bypassSecurityTrustHtml(this.notification.content);
      }
      this.dialogRef.afterClosed().subscribe(() => {
        this.sharedService.markNotificationAsRead(this.notification.objectId).subscribe({
          next: () => {
            this.uncheckedNews.pop();
            this.updateRequest.emit(this.uncheckedNews);
          },
          error: () => {
            console.error('Failed to mark notification as read (probably was marked already)');
          }
        });
      });
    }
    confirm() {
      this.dialogRef.close();
    }
    static {
      this.ɵfac = function ImportantNewsDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ImportantNewsDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(i1$3.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ImportantNewsDialogComponent,
        selectors: [["notification-important-news-dialog"]],
        outputs: {
          updateRequest: "updateRequest"
        },
        decls: 6,
        vars: 3,
        consts: [["mat-dialog-title", ""], ["mat-dialog-content", ""], [1, "importantNewsContent", 3, "innerHtml"], ["mat-dialog-actions", "", "align", "right"], ["mat-button", "", 3, "id", "click", 4, "ngIf"], ["mat-button", "", 3, "click", "id"]],
        template: function ImportantNewsDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵelement(3, "span", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 3);
            i0.ɵɵtemplate(5, ImportantNewsDialogComponent_button_5_Template, 3, 4, "button", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHtml", ctx.trustedContent, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.fullScreenDialog);
          }
        },
        dependencies: [i12.NgIf, i2.MatDialogTitle, i2.MatDialogActions, i2.MatDialogContent, i5.MatButton, i1$2.BlahPipe],
        styles: ["[_nghost-%COMP%]     .importantNewsContent img{width:100%}[_nghost-%COMP%]     .importantNewsContent iframe{width:100%}[_nghost-%COMP%]     .importantNewsContent video{width:100%}"]
      });
    }
  }
  return ImportantNewsDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class MarkNewsAsReadParameters {}
let NotificationItemComponent = /*#__PURE__*/(() => {
  class NotificationItemComponent {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.copyLinkEvent = new EventEmitter();
    }
    ngOnChanges(changes) {
      if (changes.notification) {
        // Bypass html sanitization as the content is trusted and non user editable
        this.trustedContent = this.notification ? this.sanitizer.bypassSecurityTrustHtml(this.notification.content) : undefined;
      }
    }
    copyLink(id) {
      this.copyLinkEvent.emit(id);
    }
    static {
      this.ɵfac = function NotificationItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationItemComponent)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotificationItemComponent,
        selectors: [["app-notification-item"]],
        inputs: {
          notification: "notification"
        },
        outputs: {
          copyLinkEvent: "copyLinkEvent"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 16,
        vars: 10,
        consts: [[1, "notification"], [1, "notification-header"], [1, "notification-header-title-container"], [1, "notification-header-title"], [4, "ngIf"], [1, "notification-header-date"], ["mat-icon-button", "", 3, "click", "matTooltip"], [1, "notification-content"], [1, "notification-body", 3, "innerHtml"]],
        template: function NotificationItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, NotificationItemComponent_mat_icon_4_Template, 2, 0, "mat-icon", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "date");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div")(10, "button", 6);
            i0.ɵɵpipe(11, "blah");
            i0.ɵɵlistener("click", function NotificationItemComponent_Template_button_click_10_listener($event) {
              ctx.copyLink(ctx.notification.objectId);
              return $event.stopPropagation();
            });
            i0.ɵɵelementStart(12, "mat-icon");
            i0.ɵɵtext(13, "link");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(14, "div", 7);
            i0.ɵɵelement(15, "span", 8);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.notification.important);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.notification.title, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 5, ctx.notification.startDate, "shortDate"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("matTooltip", i0.ɵɵpipeBind1(11, 8, "layout.copyLink"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("innerHtml", ctx.trustedContent, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i12.NgIf, i3$1.MatIcon, i4.MatTooltip, i5.MatIconButton, i12.DatePipe, i1$2.BlahPipe],
        styles: [".notification[_ngcontent-%COMP%]{padding:6px 0 0 10px}.notification-header[_ngcontent-%COMP%]{display:flex;align-items:center;gap:10px}.notification-header-title-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;flex:1;align-items:center}.notification-header-title[_ngcontent-%COMP%]{font-weight:700;flex:1}[_nghost-%COMP%]     .notification-body img{max-width:100%}[_nghost-%COMP%]     .notification-body iframe{max-width:100%}[_nghost-%COMP%]     .notification-body video{max-width:100%}@media screen and (max-width: 495px){.notification-header-title-container[_ngcontent-%COMP%]{display:block}.notification-header-title[_ngcontent-%COMP%]{width:100%}}"]
      });
    }
  }
  return NotificationItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsListDialogComponent = /*#__PURE__*/(() => {
  class NotificationsListDialogComponent {
    constructor(blahService, data, dialogRef, sharedService, toaster, cdRef, errorHandler) {
      this.blahService = blahService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.sharedService = sharedService;
      this.toaster = toaster;
      this.cdRef = cdRef;
      this.errorHandler = errorHandler;
      this.updateRequest = new EventEmitter();
      this.loading = false;
      this.allNotificationItems = [];
      this.pageItems = [];
      this.unexpiredNews = [];
      this.uncheckedNews = [];
      this.notificationIsSelected = false;
      this.dateTodayTime = new Date().getTime().toString();
      this.checkedArray = [];
      this.unCheckedArray = [];
      this.itemsPerPage = 16;
      this.currentPage = 1;
      this.noOfPages = 1;
    }
    ngOnInit() {
      this.loading = true;
      this.fullScreenDialog = this.data.fullScreenDialog;
      this.productId = this.data.productId;
      this.portalBaseUri = this.data.portalBaseUri;
      this.uncheckedNewsFromLayout = this.data.uncheckedNews;
      this.getUnexpiredNews();
      this.cdRef.markForCheck();
    }
    /**
    * Opens notification
    * @param notification Notification
    */
    openNotification(notification) {
      if (notification) {
        this.allNotificationItems.forEach(val => val.isSelected = false);
        notification.isSelected = true;
        if (notification.isUnchecked) {
          this.sharedService.markNotificationAsRead(notification.objectId).subscribe(data => {
            this.uncheckedNewsFromLayout.length = this.uncheckedNewsFromLayout.length - 1;
            this.updateRequest.emit(this.uncheckedNewsFromLayout);
          }, error => {
            console.error('Failed to mark notification as read (probably was marked already)');
          });
          notification.isUnchecked = false;
          // Remove from unchecked array as well
          this.uncheckedNews = this.uncheckedNews.filter(news => news.eventId != notification.eventId);
          this.unReadNotificationsCount = this.unReadNotificationsCount - 1;
          this.checkedArray = this.allNotificationItems.filter(d => d.isUnchecked === true).sort((a, b) => b.startDate.localeCompare(a.startDate));
          this.unCheckedArray = this.allNotificationItems.filter(d => d.isUnchecked === false).sort((a, b) => b.startDate.localeCompare(a.startDate));
          this.allNotificationItems = [];
          this.allNotificationItems = this.checkedArray.concat(this.unCheckedArray);
        }
        this.selectedNotification = notification;
        this.notificationIsSelected = true;
      }
    }
    /**
    * Sets notification date text
    * @param date date
    */
    notificationDateText(date) {
      let dateTime = new Date();
      let dateToday = dateTime.setHours(0, 0, 0, 0);
      let yesterDay = new Date(dateTime.setDate(dateTime.getDate() - 1)).setHours(0, 0, 0, 0);
      var notificationDate = new Date(date).setHours(0, 0, 0, 0);
      var dateText;
      if (notificationDate == dateToday) {
        dateText = 'today';
      }
      if (notificationDate == yesterDay) {
        dateText = 'yesterDay';
      }
      return dateText;
    }
    /**
    * Copies notification link
    * @param e Event
    * @param notificationId Notification id
    */
    copyLink(notificationId) {
      const notificationLink = `${this.portalBaseUri}newportal/Notification/${notificationId}`;
      navigator.clipboard.writeText(notificationLink);
      this.toaster.create(this.blahService.blah('layout.linkCopied'));
    }
    /**
    * Closes dialog
    */
    closeDialog() {
      this.dialogRef.close();
    }
    /**
    * Gets unexpired news
    */
    getUnexpiredNews() {
      this.currentLocale = this.blahService.currentLocale;
      //Clears arrays (needed in case if language is changed)
      this.allNotificationItems = [];
      this.unexpiredNews = [];
      this.sharedService.getUnexpiredNews(this.productId.toString(), this.currentLocale.substr(0, 2)).pipe(mergeMap(data => {
        this.parseNotifications(this.unexpiredNews, data.value);
        return this.getUncheckedNews();
      })).subscribe(data => {
        this.parseNotifications(this.uncheckedNews, data.value);
        this.initNotifications();
        this.loading = false;
        this.cdRef.markForCheck();
      }, error => {
        console.error('Failed to merge map news');
      });
    }
    /**
    * Parses notifications
    * @param array destination array of notifications
    * @param notifications source array of notifications
    */
    parseNotifications(array, notifications) {
      for (let notification of notifications) {
        let newNotification = new Notification();
        newNotification.objectId = notification.ObjectId;
        newNotification.title = notification.Title;
        newNotification.content = notification.Content;
        newNotification.created = notification.Created;
        newNotification.startDate = notification.StartDate;
        newNotification.eventId = notification.EventId;
        newNotification.important = notification.Important;
        newNotification.dateText = this.notificationDateText(notification.StartDate);
        array.push(newNotification);
      }
    }
    /**
    * Inits notifications
    */
    initNotifications() {
      this.unexpiredNews.forEach(val => {
        if (this.uncheckedNews.some(n => n.eventId == val.eventId)) {
          val.isUnchecked = true;
        }
        this.allNotificationItems.push(val);
      });
      this.checkedArray = this.allNotificationItems.filter(d => d.isUnchecked === true).sort((a, b) => b.startDate.localeCompare(a.startDate));
      this.unCheckedArray = this.allNotificationItems.filter(d => d.isUnchecked === false).sort((a, b) => b.startDate.localeCompare(a.startDate));
      this.unReadNotificationsCount = this.allNotificationItems.filter((x, i) => {
        return x.isUnchecked;
      }).length;
      this.noOfPages = Math.ceil(this.allNotificationItems.length / this.itemsPerPage);
      this.changePage(this.currentPage);
    }
    /**
    * Gets unchecked news
    */
    getUncheckedNews() {
      return this.sharedService.getUncheckedNews(this.productId.toString(), this.currentLocale.substr(0, 2));
    }
    /**
    * Marks news as read
    */
    markNewsAsRead() {
      var markNewsAsReadParameters = new MarkNewsAsReadParameters();
      markNewsAsReadParameters.ProductId = this.productId;
      if (this.unReadNotificationsCount > 0) {
        this.sharedService.markNewsAsRead(markNewsAsReadParameters).subscribe(data => {
          this.uncheckedNewsFromLayout.length = 0;
          this.updateRequest.emit(this.uncheckedNewsFromLayout);
          this.allNotificationItems.forEach(element => {
            element.isUnchecked = false;
          });
          this.unReadNotificationsCount = 0;
          this.cdRef.markForCheck();
        }, error => {
          this.errorHandler.handleError(error);
        });
      }
    }
    /**
    * Closes dialog
    */
    confirm() {
      this.dialogRef.close();
    }
    prevPage() {
      if (this.currentPage > 1) {
        this.changePage(--this.currentPage);
      }
    }
    nextPage() {
      if (this.currentPage < this.noOfPages) {
        this.changePage(++this.currentPage);
      }
    }
    changePage(page) {
      this.pageItems = this.allNotificationItems.slice((page - 1) * this.itemsPerPage, page * this.itemsPerPage);
    }
    static {
      this.ɵfac = function NotificationsListDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsListDialogComponent)(i0.ɵɵdirectiveInject(i1$2.BlahService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(ToasterService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ErrorHandler));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotificationsListDialogComponent,
        selectors: [["notifications-list-dialog"]],
        outputs: {
          updateRequest: "updateRequest"
        },
        decls: 2,
        vars: 2,
        consts: [[4, "ngIf"], ["class", "notification-container", 4, "ngIf"], [1, "notification-list-page-container"], [1, "notifications-content-header"], ["mat-icon-button", "", "class", "notifications-content-close-btn", 3, "click", 4, "ngIf"], ["class", "as-read-btn-container", 4, "ngIf"], ["id", "notifications-content", 4, "ngIf"], ["mat-icon-button", "", 1, "notifications-content-close-btn", 3, "click"], [1, "as-read-btn-container"], ["id", "markNewsAsRead-btn", "href", "#", 3, "click"], [3, "width", "type", 4, "ngFor", "ngForOf"], [3, "width", "type"], ["id", "notifications-content"], [1, "notifications-list"], ["class", "list-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "list-pagination", 4, "ngIf"], [2, "text-align", "center"], [1, "list-item", 3, "click", "ngClass"], [1, "list-item-title"], [1, "list-item-date"], [1, "list-pagination"], [3, "click", "disabled"], [1, "notification-container"], ["mat-dialog-title", "", 1, "notification-header"], [3, "click"], ["mat-dialog-content", "", 2, "max-height", "100%", 3, "copyLinkEvent", "notification"]],
        template: function NotificationsListDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NotificationsListDialogComponent_ng_container_0_Template, 8, 5, "ng-container", 0)(1, NotificationsListDialogComponent_div_1_Template, 8, 4, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.notificationIsSelected);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.notificationIsSelected);
          }
        },
        dependencies: [i12.NgClass, i12.NgForOf, i12.NgIf, i7$1.ButtonComponent, i7$1.PlaceholderComponent, i3$1.MatIcon, i2.MatDialogTitle, i2.MatDialogContent, i5.MatIconButton, NotificationItemComponent, i12.DatePipe, i1$2.BlahPipe],
        styles: [".notification-list-page-container[_ngcontent-%COMP%]   .notifications-content-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-bottom:20px}.notification-list-page-container[_ngcontent-%COMP%]   .notifications-content-header[_ngcontent-%COMP%]   .notifications-content-close-btn[_ngcontent-%COMP%]{cursor:pointer}.notifications-list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:10px;cursor:pointer;transition:all .15s;min-height:46px;box-sizing:border-box;border-bottom:1px solid #e8e8e8}.notifications-list[_ngcontent-%COMP%]   .list-item.unread[_ngcontent-%COMP%]{font-weight:700}.notifications-list[_ngcontent-%COMP%]   .list-item-title[_ngcontent-%COMP%]{display:flex;align-items:center;gap:10px}.notifications-list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]:hover{background:#e8e8e8}.notifications-list[_ngcontent-%COMP%]   .list-pagination[_ngcontent-%COMP%]{margin-top:20px;display:flex;justify-content:flex-end;gap:10px}@media screen and (max-width: 495px){.notification-list-page-container[_ngcontent-%COMP%]{padding-top:20px}.notifications-list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]{gap:0;flex-wrap:wrap}.notifications-list[_ngcontent-%COMP%]   .list-item-title[_ngcontent-%COMP%]{width:100%}}"]
      });
    }
  }
  return NotificationsListDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Person {
  constructor() {
    this.name = '';
    this.phone = '';
    this.email = '';
  }
}
let CompanyAdminsDialogComponent = /*#__PURE__*/(() => {
  class CompanyAdminsDialogComponent {
    constructor(blahService, data, dialogRef, toaster, sharedService, cdRef) {
      this.blahService = blahService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.toaster = toaster;
      this.sharedService = sharedService;
      this.cdRef = cdRef;
      this.destroy$ = new Subject();
      this.companyAdmins = [];
      this.loading = false;
    }
    ngOnInit() {
      this.loading = true;
      this.fullScreenDialog = this.data.fullScreenDialog;
      this.getCompanyUsers();
      this.cdRef.markForCheck();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
    * Gets company users
    */
    getCompanyUsers() {
      this.sharedService.getCompanyUsers().subscribe(data => {
        data.forEach(val => {
          if (val.Role == 10) {
            let newPerson = new Person();
            newPerson.name = val.Name;
            newPerson.phone = val.Phone;
            newPerson.email = val.Email;
            this.companyAdmins.push(newPerson);
          }
        });
        this.loading = false;
        this.cdRef.markForCheck();
      }, error => {
        this.toaster.create(this.blahService.blah('layout.unknownError'));
      });
    }
    /**
    * Closes dialog
    */
    closeDialog() {
      this.dialogRef.close();
    }
    /**
    * Closes dialog
    */
    confirm() {
      this.dialogRef.close();
    }
    static {
      this.ɵfac = function CompanyAdminsDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CompanyAdminsDialogComponent)(i0.ɵɵdirectiveInject(i1$2.BlahService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.MatDialogRef), i0.ɵɵdirectiveInject(ToasterService), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CompanyAdminsDialogComponent,
        selectors: [["company-admins-dialog"]],
        decls: 5,
        vars: 5,
        consts: [["mat-dialog-title", ""], ["id", "companyAdmins-container"], ["mat-dialog-actions", "", "align", "end"], [1, "person-details"], ["type", "input", "rows", "3"], [1, "detail-container-block"], [1, "mat-h3"], [3, "href"], [1, "detail-container", "disabled"], [1, "detail-container"], [1, "detail-icon"], [1, "detail-icon", "disabled"], [3, "click"]],
        template: function CompanyAdminsDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CompanyAdminsDialogComponent_Conditional_0_Template, 3, 3, "h2", 0);
            i0.ɵɵelementStart(1, "div");
            i0.ɵɵtemplate(2, CompanyAdminsDialogComponent_Conditional_2_Template, 9, 0, "div")(3, CompanyAdminsDialogComponent_Conditional_3_Template, 3, 0, "div", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CompanyAdminsDialogComponent_Conditional_4_Template, 4, 3, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.fullScreenDialog ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("mat-mdc-dialog-content", !ctx.fullScreenDialog);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 2 : 3);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.fullScreenDialog ? 4 : -1);
          }
        },
        dependencies: [i3$1.MatIcon, i2.MatDialogTitle, i2.MatDialogActions, i7$1.PlaceholderComponent, i7$1.ButtonComponent, i1$2.BlahPipe],
        styles: [".mat-h3[_ngcontent-%COMP%]{margin:0}.person-details[_ngcontent-%COMP%]{margin:0 0 2.6rem}.person-details[_ngcontent-%COMP%]   .detail-container[_ngcontent-%COMP%]{width:100%;display:grid;grid-template-columns:min-content auto;align-content:center;margin-bottom:.8rem}.person-details[_ngcontent-%COMP%]   .detail-container[_ngcontent-%COMP%]   .detail-icon[_ngcontent-%COMP%]{margin-right:.8rem}.person-details[_ngcontent-%COMP%]   .detail-container-block[_ngcontent-%COMP%]{margin-bottom:.8rem}.person-details-block[_ngcontent-%COMP%]{display:block}.disabled[_ngcontent-%COMP%]{opacity:.5}"]
      });
    }
  }
  return CompanyAdminsDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LayoutBreakpointService = /*#__PURE__*/(() => {
  class LayoutBreakpointService {
    /**
     * Layout breakpoint state observer
     */
    get observer$() {
      return this.breakpointSubject.asObservable();
    }
    /**
     * Current layout breakpoint state
     */
    get breakpoint() {
      return this.currentBreakpoint ? {
        ...this.currentBreakpoint
      } : void 0;
    }
    /**
     * If the current layout breakpoint state is handset device
     */
    get handset() {
      return this.currentBreakpoint?.handset;
    }
    constructor(breakpointObserver) {
      this.breakpointObserver = breakpointObserver;
      this.breakpointSubject = new ReplaySubject(1);
      this.destroy$ = new Subject();
      // Extra small handset
      this.breakpointObserver.observe(['(max-width: 599.98px)']).pipe(filter(result => result.matches)).pipe(takeUntil(this.destroy$)).subscribe(result => this.updateBreakpoint({
        layout: 'xs',
        handset: true,
        minWidth: void 0,
        maxWidth: 599.98
      }));
      // Small handset
      this.breakpointObserver.observe(['(min-width: 600px) and (max-width: 959.98px)']).pipe(filter(result => result.matches)).pipe(takeUntil(this.destroy$)).subscribe(result => this.updateBreakpoint({
        layout: 'sm',
        handset: true,
        minWidth: 600,
        maxWidth: 959.98
      }));
      // Medium
      this.breakpointObserver.observe(['(min-width: 960px) and (max-width: 1279.98px)']).pipe(filter(result => result.matches)).pipe(takeUntil(this.destroy$)).subscribe(result => this.updateBreakpoint({
        layout: 'md',
        handset: false,
        minWidth: 960,
        maxWidth: 1279.98
      }));
      // Large
      this.breakpointObserver.observe(['(min-width: 1280px) and (max-width: 1599.98px)']).pipe(filter(result => result.matches)).pipe(takeUntil(this.destroy$)).subscribe(result => this.updateBreakpoint({
        layout: 'lg',
        handset: false,
        minWidth: 1280,
        maxWidth: 1599.98
      }));
      // Extra large
      this.breakpointObserver.observe(['(min-width: 1600px)']).pipe(filter(result => result.matches)).pipe(takeUntil(this.destroy$)).subscribe(result => this.updateBreakpoint({
        layout: 'xl',
        handset: false,
        minWidth: 1600,
        maxWidth: void 0
      }));
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
      this.breakpointSubject.complete();
    }
    updateBreakpoint(breakpoint) {
      this.currentBreakpoint = breakpoint;
      this.breakpointSubject.next(this.currentBreakpoint);
    }
    static {
      this.ɵfac = function LayoutBreakpointService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutBreakpointService)(i0.ɵɵinject(i1$4.BreakpointObserver));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LayoutBreakpointService,
        factory: LayoutBreakpointService.ɵfac
      });
    }
  }
  return LayoutBreakpointService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Single live message.
 */
class SingleLiveMessage {
  constructor(result, productSpecific) {
    // Live messages (from SignalR) have camel casing
    this.Topic = result.topic;
    this.CreatorId = result.creatorId;
    this.Created = new Date(result.created);
    this.ProductSpecific = productSpecific;
    this.Payload = result.payload;
  }
}

/**
 * Message stream state.
 */
var MessageStreamState = /*#__PURE__*/function (MessageStreamState) {
  /**
   * Message stream active
   */
  MessageStreamState[MessageStreamState["Active"] = 0] = "Active";
  /**
   * Message stream completed
   */
  MessageStreamState[MessageStreamState["Completed"] = 1] = "Completed";
  /**
   * Message stream canceled
   */
  MessageStreamState[MessageStreamState["Canceled"] = 2] = "Canceled";
  /**
   * Message stream marked as failed
   */
  MessageStreamState[MessageStreamState["Failed"] = 3] = "Failed";
  return MessageStreamState;
}(MessageStreamState || {});
/**
 * Message stream.
 */
class MessageStream {
  constructor(result) {
    // Results directly from api have pascal casing
    this.Id = result.Id;
    this.ProductId = result.ProductId;
    this.Topic = result.Topic;
    this.State = result.State;
    this.CreatorId = result.CreatorId;
    this.Created = new Date(result.Created);
    this.Expiration = new Date(result.Expiration);
    this.Messages = result.Messages?.map(o => new MessageStreamMessage(o)) ?? [];
  }
}
/**
 * Message stream message.
 */
class MessageStreamMessage {
  constructor(result) {
    this.Id = result.Id;
    this.Payload = result.Payload;
    this.CreatorId = result.CreatorId;
    this.Created = new Date(result.Created);
    this.MessageStreamId = result.MessageStreamId;
  }
}

/**
 * Message stream live action type.
 */
var MessageStreamLiveActionType = /*#__PURE__*/function (MessageStreamLiveActionType) {
  /**
   * Live message
   */
  MessageStreamLiveActionType[MessageStreamLiveActionType["LiveMessage"] = 0] = "LiveMessage";
  /**
   * Stream state change
   */
  MessageStreamLiveActionType[MessageStreamLiveActionType["StateChange"] = 1] = "StateChange";
  /**
   * Stream subscription change
   */
  MessageStreamLiveActionType[MessageStreamLiveActionType["SubscriptionChange"] = 2] = "SubscriptionChange";
  return MessageStreamLiveActionType;
}(MessageStreamLiveActionType || {});
/**
 * Message stream live message.
 */
class MessageStreamLiveMessage {
  constructor(result) {
    // Live messages (from SignalR) have camel casing
    this.MessageStreamId = result.messageStreamId;
    this.MessageId = result.messageId;
    this.ProductId = result.productId;
    this.Topic = result.topic;
    this.State = result.state;
    this.CreatorId = result.creatorId;
    this.Created = new Date(result.created);
    this.Payload = result.payload;
  }
  /**
   * Creates a new instance of `MessageStreamLiveMessage` class from given message stream and message.
   *
   * @param message Message stream message
   * @param messageStream Message stream
   * @returns Stream live message
   */
  static fromStreamMessage(message, messageStream) {
    return new MessageStreamLiveMessage({
      messageStreamId: messageStream.Id,
      messageId: message.Id,
      productId: messageStream.ProductId,
      topic: messageStream.Topic,
      state: messageStream.State,
      creatorId: message.CreatorId,
      created: message.Created,
      // Date accepts date object as parameter so this is correct
      payload: message.Payload
    });
  }
  /**
   * Creates a new instance of `MessageStreamMessage` class from current live message.
   *
   * @returns Stream message
   */
  toStreamMessage() {
    return new MessageStreamMessage({
      Id: this.MessageId,
      Payload: this.Payload,
      CreatorId: this.CreatorId,
      Created: this.Created,
      // Date accepts date object as parameter so this is correct
      MessageStreamId: this.MessageStreamId
    });
  }
}
/**
 * Message stream live state change.
 */
class MessageStreamLiveStateChange {
  constructor(result) {
    this.MessageStreamId = result.messageStreamId;
    this.State = result.state;
  }
}
/**
 * Message stream live subscription change.
 */
class MessageStreamLiveSubscriptionChange {
  constructor(result) {
    this.MessageStreamId = result.messageStreamId;
    this.IsSubscriber = result.isSubscriber;
    this.ProductId = result.productId;
    this.Topic = result.topic;
    this.State = result.state;
  }
}

/**
 * Live Messaging service for handling Live Messaging client-side operations.
 */
let LiveMessagingService = /*#__PURE__*/(() => {
  class LiveMessagingService {
    /**
     * Flag indicating if service is initialized
     */
    get initialized() {
      return this.isInitialized;
    }
    /**
     * Flag indicating if service is being initialized
     */
    get initializing() {
      return this.isInitializing;
    }
    /**
     * Service initialized observable
     */
    get initialized$() {
      return this.initializedSubject.asObservable();
    }
    constructor(http, zone) {
      this.http = http;
      this.zone = zone;
      this.isInitialized = false;
      this.isInitializing = false;
      this.initializedSubject = new Subject();
      this.singleMessageSubject = new Subject();
      this.streamMessageSubject = new Subject();
      this.streamStateChangeSubject = new Subject();
      this.streamSubscriptionChangeSubject = new Subject();
    }
    ngOnDestroy() {
      this.initializedSubject.complete();
      this.singleMessageSubject.complete();
      this.streamMessageSubject.complete();
      this.streamStateChangeSubject.complete();
      this.streamSubscriptionChangeSubject.complete();
      this.hubConnection?.stop();
    }
    /**
     * Initializes the Live Messaging service.
     *
     * Must be called only once.
     *
     * @param productId Current product id
     * @param apiBaseUrl Environment API base url
     * @param accessTokenFactory Access token factory
     * @param logLevel Live Messaging log level (`0` = Trace, `1` = Debug, `2` = Information, `3` = Warn, `4` = Error). Default is `2` = Information.
     * @returns Service initialized observable
     */
    init(productId, apiBaseUrl, accessTokenFactory, logLevel = 2) {
      if (this.isInitialized || this.isInitializing) {
        throw new Error('[LiveMessagingService] Initialize called multiple times.');
      }
      this.isInitializing = true;
      this.productId = productId;
      this.apiBaseUrl = apiBaseUrl;
      this.accessTokenFactory = accessTokenFactory;
      this.hubConnection = new HubConnectionBuilder().withUrl(`${this.apiBaseUrl}hub`, {
        accessTokenFactory: this.accessTokenFactory
      }).withAutomaticReconnect().configureLogging(logLevel).build();
      this.hubConnection.onclose(error => {
        console.error('[LiveMessagingService]', 'Unable to reconnect to SignalR service:', error);
      });
      this.initLiveMethods();
      this.hubConnection.start().then(() => {
        this.isInitializing = false;
        this.isInitialized = true;
        this.initializedSubject.next();
        this.initializedSubject.complete();
      }).catch(error => {
        this.isInitializing = false;
        console.error('[LiveMessagingService]', 'Unable to start SignalR connection:', error);
      });
      return this.initializedSubject.asObservable();
    }
    //#region Single message
    /**
     * Creates an observable for listening single messages.
     *
     * #### Topic example:
     *
     * Topic:
     * `iwm/task/created/e653e020-65e7-4ddb-a500-903778af239a`
     *
     * `*` wildcard: `iwm/task/created/*`
     * accepts everything inside path part (until next `/`) so above topic will be matched,
     * but f.ex. `iwm/task/created/e653e020-65e7-4ddb-a500-903778af239a/afterGuid` wont be matched.
     * For that the following must be used `iwm/task/created/* /afterGuid` or `iwm/task/created/* /*`.
     *
     * `**` wildcard: `iwm/task/created/**` or `iwm/task/created**`
     * accepts everyting after so all above topics will be matched.
     *
     * @param topic For filtering messages with it's topic.
     *              Supports wildcard selectors: `*` accepts everything inside path but not `/`.
     *              `**` accepts everything.
     *              *Optional.*
     * @returns Single live message observable
     */
    listenToSingleMessages(topic) {
      const topicQuery = this.buildPathQuery(topic ?? '');
      return this.singleMessageSubject.pipe(filter(message => !topic || topicQuery.test(message.Topic)));
    }
    /**
     * Observable for all single live messages for current user
     */
    get singleLiveMessages$() {
      return this.singleMessageSubject.asObservable();
    }
    //#endregion Single message
    //#region Message stream
    /**
     * Gets all available streams for current user.
     *
     * #### Topic example:
     *
     * Topic:
     * `iwm/task/created/e653e020-65e7-4ddb-a500-903778af239a`
     *
     * `*` wildcard: `iwm/task/created/*`
     * accepts everything inside path part (until next `/`) so above topic will be matched,
     * but f.ex. `iwm/task/created/e653e020-65e7-4ddb-a500-903778af239a/afterGuid` wont be matched.
     * For that the following must be used `iwm/task/created/* /afterGuid` or `iwm/task/created/* /*`.
     *
     * `**` wildcard: `iwm/task/created/**` or `iwm/task/created**`
     * accepts everyting after so all above topics will be matched.
     *
     * @param topic For filtering streams with it's topic.
     *              Supports wildcard selectors: `*` accepts everything inside path but not `/`.
     *              `**` accepts everything.
     *              *Optional.*
     * @param includeMessages If includes stream messages. Default is `false`.
     * @param onlyLatestMessage If includes only latest stream message. Default is `false`.
     * @param onlyActive If includes only streams that are active. Default is `true`.
     * @returns Message stream array observable
     */
    getStreams(topic, includeMessages = false, onlyLatestMessage = false, onlyActive = true) {
      const baseUrl = `${this.apiBaseUrl}api/messagestreams`;
      let queryParams = [`includeMessages=${includeMessages}`, `onlyLatestMessage=${onlyLatestMessage}`, `onlyActive=${onlyActive}`];
      if (topic) queryParams.push(`topic=${topic}`);
      const requestUrl = `${baseUrl}?${queryParams.join('&')}`;
      return this.http.get(requestUrl).pipe(map$1(results => results.map(result => new MessageStream(result))));
    }
    /**
     * Gets a single stream.
     *
     * @param streamId Stream id
     * @param includeMessages If includes stream messages. Default is `false`.
     * @param onlyLatestMessage If includes only latest stream message. Default is `false`.
     * @returns Message stream observable
     */
    getStream(streamId, includeMessages = false, onlyLatestMessage = false) {
      const baseUrl = `${this.apiBaseUrl}api/messagestreams/${streamId}`;
      let queryParams = [`includeMessages=${includeMessages}`, `onlyLatestMessage=${onlyLatestMessage}`];
      const requestUrl = `${baseUrl}?${queryParams.join('&')}`;
      return this.http.get(requestUrl).pipe(map$1(result => new MessageStream(result)));
    }
    /**
     * Gets all messages in stream.
     *
     * @param streamId Stream id
     * @returns Stream message array observable
     */
    getMessages(streamId) {
      const requestUrl = `${this.apiBaseUrl}api/messagestreams/${streamId}/messages`;
      return this.http.get(requestUrl).pipe(map$1(results => results.map(result => new MessageStreamMessage(result))));
    }
    /**
     * Gets a single message in stream.
     *
     * @param streamId Stream id
     * @param messageId Message id
     * @returns Stream message observable
     */
    getMessage(streamId, messageId) {
      const requestUrl = `${this.apiBaseUrl}api/messagestreams/${streamId}/messages/${messageId}`;
      return this.http.get(requestUrl).pipe(map$1(result => new MessageStreamMessage(result)));
    }
    /**
     * Deletes a single message from stream.
     *
     * @param streamId Stream id
     * @param messageId Message id
     * @returns Stream message observable
     */
    deleteMessage(streamId, messageId) {
      const requestUrl = `${this.apiBaseUrl}api/messagestreams/${streamId}/messages/${messageId}`;
      return this.http.delete(requestUrl);
    }
    /**
     * Creates an observable for listening stream messages.
     *
     * @param streamId Stream id
     * @param withLatestMessage If gets latest message from stream and projects it to observable. Default is `false`.
     * @returns Stream live message observable
     */
    listenToStreamMessages(streamId, withLatestMessage = false) {
      if (withLatestMessage) {
        // Because this is an async request the function will return the observable before request completes
        this.getStream(streamId, true, true).subscribe({
          next: messageStream => {
            if (messageStream.Messages.length > 0) {
              const message = messageStream.Messages[0];
              const liveMessage = MessageStreamLiveMessage.fromStreamMessage(message, messageStream);
              this.streamMessageSubject.next(liveMessage);
            }
          },
          error: error => {
            console.error('[LiveMessagingService]', 'Unable to get the latest message from stream:', error);
          }
        });
      }
      return this.streamMessageSubject.pipe(
      // This lets only messages with given stream id to pass
      filter(message => message.MessageStreamId === streamId));
    }
    /**
     * Creates an observable for listening stream state changes.
     *
     * @param streamId Stream id
     * @returns Stream live state change observable
     */
    listenToStreamStateChanges(streamId) {
      return this.streamStateChangeSubject.pipe(
      // This lets only messages with given stream id to pass
      filter(message => message.MessageStreamId === streamId));
    }
    /**
     * Creates an observable for listening stream subscription changes.
     *
     * #### Topic example:
     *
     * Topic:
     * `iwm/task/e653e020-65e7-4ddb-a500-903778af239a`
     *
     * `*` wildcard: `iwm/task/*`
     * accepts everything inside path part (until next `/`) so above topic will be matched,
     * but f.ex. `iwm/task/e653e020-65e7-4ddb-a500-903778af239a/afterGuid` wont be matched.
     * For that the following must be used `iwm/task/* /afterGuid` or `iwm/task/* /*`.
     *
     * `**` wildcard: `iwm/task/**` or `iwm/task**`
     * accepts everyting after so all above topics will be matched.
     *
     * @param topic For filtering streams with it's topic.
     *              Supports wildcard selectors: `*` accepts everything inside path but not `/`.
     *              `**` accepts everything.
     *              *Optional.*
     * @return Stream live subscription change observable
     */
    listenToStreamSubscriptionChanges(topic) {
      const topicQuery = this.buildPathQuery(topic ?? '');
      return this.streamSubscriptionChangeSubject.pipe(
      // This filters streams by topic
      filter(message => !topic || topicQuery.test(message.Topic)));
    }
    /**
     * Observable for all live messages in every stream for current user
     */
    get streamLiveMessages$() {
      return this.streamMessageSubject.asObservable();
    }
    /**
     * Observable for all stream state changes in every stream for current user
     */
    get streamLiveStateChanges$() {
      return this.streamStateChangeSubject.asObservable();
    }
    /**
     * Observable for all stream subscription changes for current user
     */
    get streamLiveSubscriptionChanges$() {
      return this.streamSubscriptionChangeSubject.asObservable();
    }
    //#endregion Message stream
    //#region Private methods
    buildPathQuery(queryStr) {
      if (!queryStr) {
        return new RegExp('');
      }
      // Escape necessary characters
      queryStr = queryStr.replace(/([\(\)\[\]\{\}\+\?\!\|\^\$\.\\\/])/g, '\\$1');
      // Replace double wildcards with placeholder symbol
      queryStr = queryStr.replace(/\*\*/g, '§');
      // Replace single wildcards
      queryStr = queryStr.replace(/\*/g, '[^/]*');
      // And finally replace double wildcard's placeholder
      queryStr = queryStr.replace(/§/g, '.*');
      queryStr = `^${queryStr}$`;
      return new RegExp(queryStr);
    }
    initLiveMethods() {
      // FYI: As these events come from SignalR they are not run inside Angular zone by default.
      //      They are proxied through NgZone to trigger change detection.
      // Single messages
      this.hubConnection.on('Single.Global', result => this.zone.run(() => this.handleSingleMethod(result, false)));
      this.hubConnection.on(`Single.${this.productId}`, result => this.zone.run(() => this.handleSingleMethod(result, true)));
      // Streams
      this.hubConnection.on('Stream.Global', result => this.zone.run(() => this.handleStreamMethod(result)));
      this.hubConnection.on(`Stream.${this.productId}`, result => this.zone.run(() => this.handleStreamMethod(result)));
    }
    handleSingleMethod(result, productSpecific) {
      const message = new SingleLiveMessage(result, productSpecific);
      this.singleMessageSubject.next(message);
    }
    handleStreamMethod(result) {
      switch (result.actionType) {
        case MessageStreamLiveActionType.LiveMessage:
          const message = new MessageStreamLiveMessage(result);
          this.streamMessageSubject.next(message);
          break;
        case MessageStreamLiveActionType.StateChange:
          const stateChange = new MessageStreamLiveStateChange(result);
          this.streamStateChangeSubject.next(stateChange);
          break;
        case MessageStreamLiveActionType.SubscriptionChange:
          const subscriptionChange = new MessageStreamLiveSubscriptionChange(result);
          this.streamSubscriptionChangeSubject.next(subscriptionChange);
          break;
        default:
          console.error('[LiveMessagingService]', 'Unknown result from SignalR:', result);
          break;
      }
    }
    static {
      this.ɵfac = function LiveMessagingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LiveMessagingService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LiveMessagingService,
        factory: LiveMessagingService.ɵfac
      });
    }
  }
  return LiveMessagingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Checks if a property has given bitwise flag.
 *
 * @param prop Property to check against
 * @param flag Bitwise flag to check
 * @returns If a property has given bitwise flag
 */
function hasFlag(prop, flag) {
  return (prop & flag) === flag;
}
var AutoRelieveMode = /*#__PURE__*/function (AutoRelieveMode) {
  /**
   * No auto relieve
   */
  AutoRelieveMode[AutoRelieveMode["None"] = 0] = "None";
  /**
   * Auto relieve on navigation
   */
  AutoRelieveMode[AutoRelieveMode["OnNavigation"] = 1] = "OnNavigation";
  /**
   * Auto relieve on timed functions.
   *
   * This includes idle and custom `impactOverTime` implementations.
   */
  AutoRelieveMode[AutoRelieveMode["OnTimed"] = 2] = "OnTimed";
  /**
   * Auto relieve on treshold exceeded.
   *
   * **Note:** This overrides all other modes.
   */
  AutoRelieveMode[AutoRelieveMode["OnTreshold"] = 4] = "OnTreshold";
  return AutoRelieveMode;
}(AutoRelieveMode || {});
var ImpactType = /*#__PURE__*/function (ImpactType) {
  /**
   * Impact from navigation
   */
  ImpactType[ImpactType["Navigation"] = 0] = "Navigation";
  /**
   * Impact from timed function
   */
  ImpactType[ImpactType["Timed"] = 1] = "Timed";
  /**
   * Manual impact
   */
  ImpactType[ImpactType["Manual"] = 2] = "Manual";
  /**
   * Relieve triggered manually
   */
  ImpactType[ImpactType["ManualRelieve"] = 3] = "ManualRelieve";
  return ImpactType;
}(ImpactType || {});
let SmoothnessEnforcer = /*#__PURE__*/(() => {
  class SmoothnessEnforcer {
    /**
     * Indicates if the current instance is armed (initialized)
     */
    get armed() {
      return this._armed;
    }
    /**
     * Host application id
     */
    get appId() {
      return this._appId;
    }
    /**
     * Impact treshold value
     */
    get impactTreshold() {
      return this._impactTreshold;
    }
    /**
     * Indicates if the impact treshold is exceeded
     */
    get tresholdExceeded() {
      return this._tresholdExceeded;
    }
    /**
     * Cumulative impact value
     */
    get cumulativeImpact() {
      return this._cumulativeImpact;
    }
    /**
     * Impact on user navigation
     */
    get impactOnNavigation() {
      return this._impactOnNavigation;
    }
    /**
     * Impact on user idling (keeping the application open)
     */
    get impactOnIdle() {
      return this._impactOnIdle;
    }
    /**
     * If the application should be automatically relieved based on modes
     */
    get autoRelieve() {
      return this._autoRelieve;
    }
    //#endregion Public properties
    //#region Public observables
    /**
     * Triggers when the current instance is armed (initialized).
     *
     * Also triggers instantly if subscribed afterwards.
     */
    get armed$() {
      return this.armedSubject.asObservable();
    }
    /**
     * Impact observable.
     *
     * Triggers when smoothness impact is made.
     *
     * **Note:** This can trigger even if the treshold is already exceeded.
     */
    get impact$() {
      return this.impactSubject.asObservable();
    }
    /**
     * Treshold value exceeded observable.
     *
     * Triggers when the cumulative impact exceeds the impact treshold value.
     * Also triggers instantly if subscribed after treshold is exceeded.
     *
     * Observable feed contains a snapshot impact (without additional data) at the time treshold is exceeded.
     *
     * **Note:** Asynchronous operation called from observable might not complete as
     * the application can be automatically relieved.
     */
    get treshold$() {
      return this.tresholdSubject.asObservable();
    }
    /**
     * Relieve observable.
     *
     * Triggers when the application is about to be relieved.
     *
     * **Note:** No asynchronous operation should be called from observable
     * as it wont complete.
     */
    get relieve$() {
      return this.relieveSubject.asObservable();
    }
    /**
     * Relieved observable.
     *
     * Triggers after the application is relieved.
     *
     * **Note:** A snapshot of relieved observable is kept for 10 seconds
     *           to allow the application to fully load.
     */
    get relieved$() {
      return this.relievedSubject.asObservable();
    }
    //#endregion Public observables
    //#region Private properties
    get appRelieveId() {
      return `${this.appId}-se-relieve`;
    }
    //#endregion Private properties
    //#region Constructor & interface methods
    constructor(router) {
      this.router = router;
      //#region Public properties
      /**
       * Flag that indicates if the host is in production mode.
       *
       * Unarmed messages appear only in production mode.
       */
      this.production = false;
      this._armed = false;
      this._appId = '';
      this._impactTreshold = 0;
      this._tresholdExceeded = false;
      this._cumulativeImpact = 0;
      this._impactOnNavigation = 0;
      this._impactOnIdle = 0;
      this._autoRelieve = 0;
      this.armedSubject = new ReplaySubject(1);
      this.impactSubject = new Subject();
      this.tresholdSubject = new ReplaySubject(1);
      this.relieveSubject = new Subject();
      this.relievedSubject = new ReplaySubject(1, 10000);
      this.relieving = false;
      this.timedHosts = {};
      this.destroy$ = new Subject();
    }
    ngOnDestroy() {
      this.armedSubject.complete();
      this.impactSubject.complete();
      this.tresholdSubject.complete();
      this.relieveSubject.complete();
      this.relievedSubject.complete();
      this.destroy$.next();
      this.destroy$.complete();
    }
    //#endregion Constructor & interface methods
    //#region Public methods
    /**
     * Arms (initializes) the current instance.
     *
     * @param config Smoothness config
     * @returns Initialization promise
     */
    arm(config = {}) {
      return new Promise((resolve, reject) => {
        if (this.armed) {
          reject('Current instance of Smoothness Enforcer is already armed.');
          return;
        }
        this._armed = true;
        this._appId = config.appId ?? 'default';
        this._impactTreshold = config.impactTreshold ?? 100;
        this._impactOnNavigation = config.impactOnNavigation ?? 0;
        this._impactOnIdle = config.impactOnIdle ?? 0;
        this._autoRelieve = config.autoRelieve ?? 0;
        this.armedSubject.next();
        this.initAfterStable();
        resolve();
      });
    }
    /**
     * Manually impacts the application.
     *
     * @param weight Impact weight
     * @param data Possible additional impact data
     */
    impact(weight, data) {
      if (!this.armed) {
        this.production && console.log('[Smoothness] Unable to make impact as the current instance is not armed.');
        return;
      }
      if (isNaN(weight) || weight <= 0) {
        throw new Error('[Smoothness] Impact weight must be a positive number.');
      }
      // New impact is made asynchronously to prevent any lag
      setTimeout(() => this.makeImpact(ImpactType.Manual, weight, data));
    }
    /**
     * Adds weight to the timer that impacts the application over time.
     *
     * Value is *impact per minute*. This value stacks with the global `impactOnIdle` value.
     *
     * **Note:** Impact weight will stack with different hosts.
     * Also remember to cleanup the weight when destroying host by calling `cleanupHost`.
     *
     * @param hostId Unique host id
     * @param weight Impact weight per minute
     */
    impactOverTime(hostId, weight) {
      if (!this.armed) {
        this.production && console.log('[Smoothness] Unable to make impact over time as the current instance is not armed.');
        return;
      }
      if (!hostId) {
        throw new Error('[Smoothness] Host id cannot be empty.');
      }
      if (isNaN(weight) || weight <= 0) {
        throw new Error('[Smoothness] Impact weight must be a positive number.');
      }
      this.timedHosts[hostId] = {
        weight
      };
    }
    /**
     * Cleanups any impact hooks set to given host.
     *
     * @param hostId Id of the host to clean
     */
    cleanupHost(hostId) {
      if (!hostId) {
        throw new Error('[Smoothness] Host id cannot be empty.');
      }
      delete this.timedHosts[hostId];
    }
    /**
     * Manually relieves the application.
     *
     * @param data Possible additional relieve data
     */
    relieve(data) {
      if (!this.armed) {
        this.production && console.log('[Smoothness] Unable to relieve manually as the current instance is not armed.');
        return;
      }
      // Relieve is called synchronously to be as fast as possible
      this.doRelieve(ImpactType.ManualRelieve, data);
    }
    //#endregion Public methods
    //#region Private methods
    initAfterStable() {
      // FYI: ApplicationRef.whenStable cannot be trusted in application
      //      which uses timers, like IWM.
      //      Timeout must therefore be used.
      setTimeout(() => {
        this.checkRelieved();
        this.initRouterHooks();
        this.initTimedHooks();
      }, 5000);
    }
    checkRelieved() {
      const dataStr = window.sessionStorage.getItem(this.appRelieveId);
      if (dataStr) {
        window.sessionStorage.removeItem(this.appRelieveId);
        const dateNow = new Date();
        const relieveInfo = JSON.parse(dataStr);
        const relieveInfoValidFor = 60 * 1000;
        // Relieve info is valid only for 1 minute after it's placed
        if (dateNow.valueOf() < relieveInfo.timestamp + relieveInfoValidFor) {
          const type = relieveInfo.type;
          const data = relieveInfo.data;
          // Trigger subject asynchronously to prevent possible blockage during app startup
          setTimeout(() => {
            this.relievedSubject.next({
              type,
              data
            });
          });
        }
      }
    }
    initRouterHooks() {
      if (this.impactOnNavigation > 0 && !this.router) {
        console.warn('[Smoothness] Impact on navigation is configured but no router is declared.');
      }
      // Init event hook if router is declared
      this.router?.events.pipe(filter(e => e instanceof NavigationEnd)).pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (this.impactOnNavigation > 0) {
          this.makeImpact(ImpactType.Navigation, this.impactOnNavigation);
        }
        if (this.tresholdExceeded && hasFlag(this.autoRelieve, AutoRelieveMode.OnNavigation)) {
          this.doRelieve(ImpactType.Navigation);
        }
      });
    }
    initTimedHooks() {
      // 1 minute interval
      const interval = 60 * 1000;
      timer(interval, interval).pipe(takeUntil(this.destroy$)).subscribe(() => {
        let totalImpact = this.impactOnIdle;
        for (const hostId in this.timedHosts) {
          const timedHost = this.timedHosts[hostId];
          totalImpact += timedHost.weight;
        }
        if (totalImpact > 0) {
          this.makeImpact(ImpactType.Timed, totalImpact);
        }
        if (this.tresholdExceeded && hasFlag(this.autoRelieve, AutoRelieveMode.OnTimed)) {
          this.doRelieve(ImpactType.Timed);
        }
      });
    }
    makeImpact(type, weight, data) {
      this._cumulativeImpact += weight;
      this.impactSubject.next({
        type,
        weight,
        cumulativeImpact: this.cumulativeImpact,
        impactTreshold: this.impactTreshold,
        data
      });
      // Treshold can exceed only once
      if (!this.tresholdExceeded && this.cumulativeImpact >= this.impactTreshold) {
        this._tresholdExceeded = true;
        // Create a snapshot of a impact (without additional data) that exceeded the treshold
        this.tresholdSubject.next({
          type,
          weight,
          cumulativeImpact: this.cumulativeImpact,
          impactTreshold: this.impactTreshold
        });
        if (hasFlag(this.autoRelieve, AutoRelieveMode.OnTreshold)) {
          this.doRelieve(type);
        }
      }
    }
    doRelieve(type, data) {
      // When relieve is called it cannot be called again before browser has reloaded
      if (this.relieving) {
        console.warn('[Smoothness] Cannot relieve as the current instance is already executing relieve.');
        return;
      }
      this.relieving = true;
      // Stop listening to events when relieving
      this.destroy$.next();
      this.destroy$.complete();
      this.relieveSubject.next({
        type,
        cumulativeImpact: this.cumulativeImpact,
        impactTreshold: this.impactTreshold,
        data
      });
      const dataStr = JSON.stringify({
        timestamp: new Date().valueOf(),
        type,
        data
      });
      window.sessionStorage.setItem(this.appRelieveId, dataStr);
      window.location.reload();
    }
    static {
      this.ɵfac = function SmoothnessEnforcer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SmoothnessEnforcer)(i0.ɵɵinject(i1$5.Router, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SmoothnessEnforcer,
        factory: SmoothnessEnforcer.ɵfac
      });
    }
  }
  return SmoothnessEnforcer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NoPrintDirective = /*#__PURE__*/(() => {
  class NoPrintDirective {
    constructor() {
      this.globalNoPrint = true;
    }
    static {
      this.ɵfac = function NoPrintDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NoPrintDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NoPrintDirective,
        selectors: [["", "noPrint", ""]],
        hostVars: 2,
        hostBindings: function NoPrintDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("global-no-print", ctx.globalNoPrint);
          }
        }
      });
    }
  }
  return NoPrintDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Mapper = /*#__PURE__*/(() => {
  class Mapper {
    static {
      this.Products = [{
        productId: 561,
        productName: 'IWM',
        productIcon: 'https://static.headpower.fi/icons/IWM.svg',
        color: 'rgba(0,3,208, 0.12)'
      }, {
        productId: 584,
        productName: 'IWM (Partner)',
        productIcon: 'https://static.headpower.fi/icons/IWM.svg',
        color: 'rgba(0,3,208,0.12)'
      }, {
        productId: 581,
        productName: 'IWD',
        productIcon: 'https://static.headpower.fi/icons/IWD.svg',
        color: 'rgba(0,131,169,0.12)'
      }];
    }
  }
  return Mapper;
})();
class Message {}
class MessageGroup {}
let MessagesComponent = /*#__PURE__*/(() => {
  class MessagesComponent {
    constructor(liveMessagingService, featureFlagService, toaster, blahService, cdRef) {
      this.liveMessagingService = liveMessagingService;
      this.featureFlagService = featureFlagService;
      this.toaster = toaster;
      this.blahService = blahService;
      this.cdRef = cdRef;
      this.showMessages = new EventEmitter();
      this.count = new EventEmitter();
      this._messages = [];
      this.groupedMessages = [];
      this.currentStreams = [];
      this.streamSubs = [];
      this.stateChangeSubs = [];
      this._defaultTruncateValue = 4;
      this.destroy$ = new Subject();
    }
    ngOnInit() {}
    ngOnChanges(changes) {
      if (changes.backendPortalUri && this.backendPortalUri && !this._initialized) {
        this._initialized = true;
        this.featureFlagService.isFeatureAvailable('Portal.ShowNotifications').subscribe(result => {
          if (result) {
            this.liveMessagingService.initialized$.pipe(takeUntil$1(this.destroy$)).pipe(take(1)).subscribe(() => {
              this.showMessages.emit(true);
              this.listenToPersistentNotificationStream();
            });
          }
        });
      }
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    listenToPersistentNotificationStream() {
      this.liveMessagingService.listenToStreamSubscriptionChanges(`portal/notifications/**`) // returns only visible notifications so no need to filter by id
      .pipe(takeUntil$1(this.destroy$)).subscribe({
        next: subscriptionChange => {
          if (subscriptionChange.IsSubscriber) {
            this.cdRef.markForCheck();
            // User is added to stream we are interested in so we should listen it's messages.
            this.initOperation(subscriptionChange.MessageStreamId, subscriptionChange.Topic, subscriptionChange.State);
            this.initMessageStreamListeners(subscriptionChange.MessageStreamId, false);
          } else {
            // User is removed from stream so we should reset all listeners.
            this.resetOperation(subscriptionChange.MessageStreamId);
          }
        },
        error: e => {}
      });
      // get currently active persistent stream(s) and their already existing messages by topic  
      this.liveMessagingService.getStreams(`portal/notifications/**`, true) // returns only visible notifications so no need to filter by id
      .subscribe({
        next: messageStreams => {
          const lastOpened = Date.parse(this.lastOpened);
          if (messageStreams.length > 0) {
            messageStreams.forEach(messageStream => {
              let temp = [];
              messageStream.Messages.forEach(message => {
                if (this.validatePayload(message.Payload)) {
                  temp.push(this.parseMessage(message.Payload, message.MessageStreamId, message.Id));
                  if (lastOpened < Date.parse(message.Payload.timestamp)) {
                    this.newMessageCount++;
                  }
                }
              });
              this.count.emit(this.newMessageCount);
              this._messages = temp.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
              this.group();
              this.initOperation(messageStream.Id, messageStream.Topic, messageStream.State);
              this.initMessageStreamListeners(messageStream.Id, false);
            });
          }
        },
        error: () => {}
      });
    }
    initMessageStreamListeners(streamId, withLatestMessage) {
      if (!streamId || !this.currentStreams.some(o => o.streamId === streamId)) {
        console.error('Cannot initialize message listener because stream id has not been given.');
        return;
      }
      // Listening to new stream messages
      if (!this.streamSubs.some(o => o.streamId === streamId)) {
        this.streamSubs.push({
          streamId: streamId,
          subscription: this.liveMessagingService.listenToStreamMessages(streamId, withLatestMessage).pipe(takeUntil$1(this.destroy$)).subscribe(message => {
            const stream = this.currentStreams.find(o => o.streamId == streamId);
            if (stream && this.validatePayload(message.Payload)) {
              const msg = this.parseMessage(message.Payload, message.MessageStreamId, message.MessageId);
              this._messages.splice(0, 0, msg);
              this.newMessageCount++;
              this.count.emit(this.newMessageCount);
              this.addToGroup(msg);
            }
          })
        });
      }
      // Listening to stream state changes (completed, canceled etc.)
      if (!this.stateChangeSubs.some(o => o.streamId === streamId)) {
        this.stateChangeSubs.push({
          streamId: streamId,
          subscription: this.liveMessagingService.listenToStreamStateChanges(streamId).pipe(takeUntil$1(this.destroy$)).subscribe(stateChange => {
            const stream = this.currentStreams.find(o => o.streamId === streamId);
            if (stream) {
              stream.streamState = stateChange.State;
              this.cdRef.markForCheck();
              if (stateChange.State !== MessageStreamState.Active) {
                this.resetOperation(streamId);
              }
            }
          })
        });
      }
    }
    initOperation(streamId, topic, streamState) {
      if (streamId) {
        const stream = this.currentStreams.some(o => o.streamId === streamId);
        if (!stream) {
          this.currentStreams.push({
            streamId: streamId,
            streamState: streamState
          });
        }
      }
    }
    resetOperation(streamId) {
      this.destroyMessageListeners(streamId);
      this.currentStreams = this.currentStreams.filter(o => o.streamId !== streamId);
    }
    destroyMessageListeners(streamId) {
      const messageSub = this.streamSubs.find(o => o.streamId === streamId);
      if (messageSub) {
        messageSub.subscription.unsubscribe();
        this.streamSubs = this.streamSubs.filter(o => o.streamId !== streamId);
      }
      const stateChangeSub = this.stateChangeSubs.find(o => o.streamId === streamId);
      if (stateChangeSub) {
        stateChangeSub.subscription.unsubscribe();
        this.stateChangeSubs = this.stateChangeSubs.filter(o => o.streamId !== streamId);
      }
    }
    validatePayload(payload) {
      if (!payload.productId || !Mapper.Products.find(o => o.productId === payload.productId) || !payload.messageType || !payload.targetType || !payload.content || !payload.link || !payload.timestamp || isNaN(Date.parse(payload.timestamp))) {
        return false;
      }
      return true;
    }
    parseMessage(payload, streamId, messageId) {
      return {
        productId: payload.productId,
        creator: payload.creator ? ` - ${payload.creator}` : '',
        messageType: payload.messageType,
        targetType: payload.targetType,
        targetId: payload.targetId,
        targetIdentifier: payload.targetIdentifier || '',
        targetName: payload.targetName || '',
        content: payload.content,
        timestamp: payload.timestamp,
        link: payload.link,
        streamId: streamId,
        messageId: messageId,
        expanded: false
      };
    }
    group() {
      const temp = [];
      this._messages.forEach(o => {
        let existingGroup = temp.find(t => t.productId === o.productId);
        if (existingGroup) {
          existingGroup.notifications.push(o);
        } else {
          const product = Mapper.Products.find(x => x.productId === o.productId);
          const productName = product?.productName || '';
          const productIcon = product?.productIcon || 'https://static.headpower.fi/icons/headpower.svg';
          const color = product?.color || '#f2efef';
          const index = Mapper.Products.indexOf(product);
          temp.push({
            order: index,
            productId: o.productId,
            productName: productName,
            productIcon: productIcon,
            color: color,
            notifications: [o],
            truncate: this._defaultTruncateValue
          });
        }
      });
      this.groupedMessages = temp.sort((a, b) => a.order - b.order);
    }
    addToGroup(msg) {
      let existingGroup = this.groupedMessages.find(t => t.productId === msg.productId);
      if (existingGroup) {
        existingGroup.notifications.splice(0, 0, msg);
        if (existingGroup.truncate > this._defaultTruncateValue) {
          existingGroup.truncate++;
        }
      } else {
        const product = Mapper.Products.find(x => x.productId === msg.productId);
        const productName = product?.productName || '';
        const productIcon = product?.productIcon || null;
        const color = product?.color || '#f2efef';
        const order = product?.order || 0;
        const newItem = {
          order: order,
          productId: msg.productId,
          productName: productName,
          productIcon: productIcon,
          color: color,
          notifications: [msg],
          truncate: this._defaultTruncateValue
        };
        const index = this.groupedMessages.findIndex(x => x.order >= order);
        if (index === -1) {
          this.groupedMessages.push(newItem);
        } else {
          this.groupedMessages.splice(index, 0, newItem);
        }
      }
    }
    navigate(link) {
      window.open(link);
    }
    deleteAllMessages() {
      if (this.groupedMessages.length === 0) {
        return;
      }
      const requests = [];
      this._messages.forEach(x => {
        requests.push(this.liveMessagingService.deleteMessage(x.streamId, x.messageId));
      });
      forkJoin(requests).subscribe({
        next: () => {
          this._messages = [];
          this.group();
          this.newMessageCount = 0;
          this.count.emit(this.newMessageCount);
          this.cdRef.markForCheck();
        },
        error: () => {
          this.toaster.create(this.blahService.blah('layout.noCurrentNews'));
        }
      });
    }
    deleteSingleProductMessages(productId) {
      const requests = [];
      this._messages.forEach(x => {
        if (x.productId === productId) {
          requests.push(this.liveMessagingService.deleteMessage(x.streamId, x.messageId));
        }
      });
      forkJoin(requests).subscribe({
        next: () => {
          this._messages = this._messages.filter(o => o.productId !== productId);
          this.groupedMessages = this.groupedMessages.filter(o => o.productId !== productId);
          this.updateNewMessageCount();
        },
        error: () => {
          this.toaster.create(this.blahService.blah('layout.noCurrentNews'));
        }
      });
    }
    deleteSingleMessage(item) {
      this.liveMessagingService.deleteMessage(item.streamId, item.messageId).subscribe({
        next: () => {
          this._messages = this._messages.filter(o => o.messageId !== item.messageId);
          let productMessages = this.groupedMessages.find(x => x.productId === item.productId);
          if (productMessages) {
            productMessages.notifications = productMessages.notifications.filter(m => m.messageId !== item.messageId);
            if (productMessages.truncate > this._defaultTruncateValue) {
              productMessages.truncate = productMessages.notifications.length;
            }
            this.cdRef.markForCheck();
          }
          this.updateNewMessageCount();
        },
        error: () => {
          this.toaster.create(this.blahService.blah('layout.noCurrentNews'));
        }
      });
    }
    updateNewMessageCount() {
      const lastOpened = Date.parse(this.lastOpened);
      let count = 0;
      this._messages.forEach(m => {
        if (lastOpened < Date.parse(m.timestamp)) {
          count++;
        }
      });
      this.newMessageCount = count;
      this.count.emit(this.newMessageCount);
      this.cdRef.markForCheck();
    }
    static {
      this.ɵfac = function MessagesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MessagesComponent)(i0.ɵɵdirectiveInject(LiveMessagingService), i0.ɵɵdirectiveInject(i2$1.FeatureFlagService), i0.ɵɵdirectiveInject(ToasterService), i0.ɵɵdirectiveInject(i1$2.BlahService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MessagesComponent,
        selectors: [["app-messages"]],
        inputs: {
          lastOpened: "lastOpened",
          backendPortalUri: "backendPortalUri",
          newMessageCount: "newMessageCount"
        },
        outputs: {
          showMessages: "showMessages",
          count: "count"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 12,
        vars: 13,
        consts: [[1, "content"], [1, "message-actions"], ["mat-flat-button", "", "id", "message-settings-button", 1, "messages-button", 3, "ngClass"], [1, "message-button-icon"], ["mat-flat-button", "", "id", "remove-all-messages-button", 1, "messages-button", 3, "click", "ngClass"], ["class", "info-text", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "info-text"], [1, "message-item", "group-header", 3, "id"], [1, "product-img", 3, "src"], ["mat-icon-button", "", 1, "smaller-icon-button", "visible-on-hover", 3, "click"], ["class", "info-text expand-collapse", 3, "click", 4, "ngIf"], ["class", "empty-space", 4, "ngIf"], ["class", "message-item", 3, "id", 4, "ngIf"], [1, "message-item", 3, "id"], [1, "message-header-wrapper"], [1, "message-header", 3, "id"], [1, "message-header-text"], [1, "bold"], [1, "message-item-wrapper"], [1, "message-item-content", 3, "id"], [3, "click", "id"], ["mat-icon-button", "", 1, "smaller-icon-button", 3, "click", "id"], [1, "info-text", "expand-collapse", 3, "click"], [1, "empty-space"]],
        template: function MessagesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2)(3, "mat-icon", 3);
            i0.ɵɵtext(4, "settings");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "button", 4);
            i0.ɵɵlistener("click", function MessagesComponent_Template_button_click_7_listener() {
              return ctx.deleteAllMessages();
            });
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "blah");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, MessagesComponent_div_10_Template, 3, 3, "div", 5)(11, MessagesComponent_div_11_Template, 12, 9, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(10, _c2));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "layout.messageSettings"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3, ctx.groupedMessages.length === 0));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "layout.clear"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.groupedMessages.length === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.groupedMessages);
          }
        },
        dependencies: [i12.NgClass, i12.NgForOf, i12.NgIf, i3$1.MatIcon, i5.MatButton, i5.MatIconButton, i12.DatePipe, i1$2.BlahPipe],
        styles: [".message-actions[_ngcontent-%COMP%]{margin:10px 0 4px;display:flex;justify-content:space-between}button.messages-button[_ngcontent-%COMP%]{background-color:#dbdbdb}button.messages-button.disabled[_ngcontent-%COMP%]{color:#a9a9a9;cursor:default}mat-icon.mat-icon.message-button-icon[_ngcontent-%COMP%]{margin-right:4px!important;margin-top:-2px!important}.message-item[_ngcontent-%COMP%]{border-radius:5px;background-color:#fff;box-shadow:#64646f33 0 7px 29px;margin:6px}.group-header[_ngcontent-%COMP%]{font-weight:700;padding:.5rem 1rem;font-size:18px;display:grid;grid-template-columns:24px 1fr 24px;grid-gap:1rem;align-items:center}.bold[_ngcontent-%COMP%]{font-weight:600}.product-img[_ngcontent-%COMP%]{max-height:24px;max-width:24px}.message-header-wrapper[_ngcontent-%COMP%]{border-radius:5px 5px 0 0}.message-header[_ngcontent-%COMP%]{margin:4px 4px 0;padding:.5rem;display:flex;justify-content:space-between}.message-header-text[_ngcontent-%COMP%]{height:24px;line-height:24px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.message-item[_ngcontent-%COMP%]:hover   .visible-on-hover[_ngcontent-%COMP%], .message-item.hover[_ngcontent-%COMP%]   .visible-on-hover[_ngcontent-%COMP%]{color:#000}button.mat-mdc-icon-button.smaller-icon-button[_ngcontent-%COMP%]{width:24px!important;height:24px!important;line-height:24px!important}button.mat-mdc-icon-button.smaller-icon-button.visible-on-hover[_ngcontent-%COMP%]{color:transparent}.mat-mdc-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{position:absolute;inset:0}.message-item-wrapper[_ngcontent-%COMP%]{padding:.5rem 1rem;overflow:hidden;display:grid;grid-template-columns:1fr 24px;grid-gap:.5rem}.message-item-content[_ngcontent-%COMP%]{overflow-wrap:anywhere;display:grid;grid-template-columns:1fr;grid-gap:2rem}.info-text[_ngcontent-%COMP%]{font-weight:700;font-size:14px;text-align:center;margin:16px 0}.info-text.expand-collapse[_ngcontent-%COMP%]{cursor:pointer}.empty-space[_ngcontent-%COMP%]{height:24px}"],
        data: {
          animation: [trigger('expandCollapseIcon', [state('collapsed', style({
            transform: 'rotate(0deg)'
          })), state('expanded', style({
            transform: 'rotate(180deg)'
          })), transition('collapsed <=> expanded', animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)'))]), trigger('expandCollapse', [state('collapsed', style({
            height: '3.8rem'
          })), state('expanded', style({
            height: '*'
          })), transition('collapsed <=> expanded', animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)'))])]
        },
        changeDetection: 0
      });
    }
  }
  return MessagesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Filters out all HTML tags from a string
 */
let FilterTagsPipe = /*#__PURE__*/(() => {
  class FilterTagsPipe {
    transform(value) {
      if (!value) return value;
      return value.replace(/\n/g, '') // Remove all new line characters
      .replace(/<br[\s\/]*>/g, ' ') // Replace all new line tags with whitespace
      .replace(/<[^>]*>/g, ''); // Remove all tags
    }
    static {
      this.ɵfac = function FilterTagsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterTagsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "filterTags",
        type: FilterTagsPipe,
        pure: true
      });
    }
  }
  return FilterTagsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MarkdownToHtmlPipe = /*#__PURE__*/(() => {
  class MarkdownToHtmlPipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(markdown) {
      const html = micromark(markdown);
      return this.sanitizer.sanitize(SecurityContext.HTML, html);
    }
    static {
      this.ɵfac = function MarkdownToHtmlPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MarkdownToHtmlPipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "markdownToHtml",
        type: MarkdownToHtmlPipe,
        pure: true
      });
    }
  }
  return MarkdownToHtmlPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedPipesModule = /*#__PURE__*/(() => {
  class SharedPipesModule {
    static {
      this.ɵfac = function SharedPipesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SharedPipesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SharedPipesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return SharedPipesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FloatingChatComponent = /*#__PURE__*/(() => {
  class FloatingChatComponent {
    constructor() {
      this.chatVisible = false;
      this.messageSent = new EventEmitter();
      this.chatState = new EventEmitter();
      this.contactSupportEmitter = new EventEmitter();
      this.chatVisibleLastCheck = false;
      this.userMessage = '';
      this.messagesCount = 0;
    }
    ngAfterViewChecked() {
      if (this.chatVisible && !this.chatVisibleLastCheck) {
        this.scrollToBottom();
      }
      if (this.chatVisible && this.chatScrollView && this.messagesCount !== this.chatData.messageHistory.length) {
        this.messagesCount = this.chatData.messageHistory.length;
        this.scrollToBottom();
      } else if (this.chatVisible && this.chatScrollView && this.chatData.loading) {
        this.scrollToBottom();
      }
      this.chatVisibleLastCheck = this.chatVisible;
    }
    contactSupport() {
      this.contactSupportEmitter.next();
    }
    resetState() {
      this.chatState.next('reset');
      this.userMessage = '';
    }
    toggleChat() {
      this.chatState.next('toggle');
    }
    sendMessage() {
      if (!this.chatData.loading && this.userMessage.trim() !== '') {
        this.messageSent.next(this.userMessage);
        this.userMessage = '';
      }
    }
    scrollToBottom() {
      try {
        this.chatScrollView.nativeElement.scrollTop = this.chatScrollView.nativeElement.scrollHeight;
      } catch (err) {
        console.error('Scroll to bottom failed', err);
      }
    }
    static {
      this.ɵfac = function FloatingChatComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FloatingChatComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FloatingChatComponent,
        selectors: [["app-floating-chat"]],
        viewQuery: function FloatingChatComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.chatScrollView = _t.first);
          }
        },
        inputs: {
          chatVisible: "chatVisible",
          ownName: "ownName",
          ownProfilePictureUrl: "ownProfilePictureUrl",
          mobile: "mobile",
          chatData: "chatData"
        },
        outputs: {
          messageSent: "messageSent",
          chatState: "chatState",
          contactSupportEmitter: "contactSupportEmitter"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [["chatScrollView", ""], ["id", "floating-chat-window", "class", "chat-div", 3, "ngClass", 4, "ngIf"], ["id", "floating-chat-window", 1, "chat-div", 3, "ngClass"], [1, "chat-header", 3, "ngClass"], [1, "chat-header-left"], [3, "src", 4, "ngIf"], ["id", "floating-chat-info", "matTooltipPosition", "above", 3, "matTooltip"], [1, "chat-header-right"], ["id", "floating-chat-helpdesk", "matTooltipPosition", "above", 3, "click", "matTooltip"], ["id", "floating-chat-reset", "matTooltipPosition", "above", 1, "material-symbols-outlined", "mat-symbol", 3, "click", "matTooltip"], ["id", "floating-chat-close", "matTooltipPosition", "above", 3, "click", "matTooltip"], ["id", "floating-chat-scroll-view", 1, "chat-body"], ["class", "chat-message", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], ["class", "chat-message received-message", 4, "ngIf"], [1, "chat-footer", 3, "ngClass"], ["id", "floating-chat-textarea", "matInput", "", 3, "ngModelChange", "keyup.enter", "placeholder", "maxLength", "ngModel"], ["id", "floating-chat-send", "matTooltipPosition", "above", 3, "click", "matTooltip"], [3, "src"], [1, "chat-message", 3, "id", "ngClass"], [1, "chat-message-header"], [1, "chat-message-content", 3, "id", "innerHTML"], ["class", "chat-message-footer", 4, "ngIf"], [1, "chat-message-footer"], [1, "chat-message", "received-message"], [1, "chat-message-content"], [1, "loading-dots"], [1, "dot"]],
        template: function FloatingChatComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FloatingChatComponent_div_0_Template, 27, 32, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.chatVisible);
          }
        },
        dependencies: [CommonModule, i12.NgClass, i12.NgForOf, i12.NgIf, FormsModule, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, MatIconModule, i3$1.MatIcon, BrowserAnimationsModule, MatTooltip, BlahModule, i1$2.BlahPipe, SharedPipesModule, MarkdownToHtmlPipe],
        styles: ["img[_ngcontent-%COMP%]{width:24px;height:24px;margin-right:5px;vertical-align:middle;border-radius:50%;object-fit:contain}b[_ngcontent-%COMP%], span[_ngcontent-%COMP%]{vertical-align:middle}.mat-icon[_ngcontent-%COMP%], .mat-symbol[_ngcontent-%COMP%]{cursor:pointer;vertical-align:bottom}.chat-window[_ngcontent-%COMP%]{z-index:901;position:fixed;bottom:20px;right:20px;width:30%;height:70%;border:1px solid #ccc;border-radius:10px;box-shadow:0 0 10px #0000001a;display:flex;flex-direction:column}.chat-window-mobile[_ngcontent-%COMP%]{width:100%;height:100%;position:fixed;z-index:901;left:0;top:0;display:flex;flex-direction:column}.chat-header[_ngcontent-%COMP%]{background-color:#241b5b;color:#fff;padding:10px;display:grid;grid-template-columns:1fr 1fr}.chat-header-desktop[_ngcontent-%COMP%]{border-top-left-radius:10px;border-top-right-radius:10px}.chat-header-left[_ngcontent-%COMP%]{display:inline-grid;grid-template-columns:auto auto auto;justify-content:start;grid-column-gap:5px;align-items:end}.chat-header-right[_ngcontent-%COMP%]{display:grid;justify-content:end;grid-template-columns:auto auto auto;grid-column-gap:10px}.chat-body[_ngcontent-%COMP%]{flex:1;padding:5px;overflow-y:auto;background-color:#f8f8f8}.chat-footer[_ngcontent-%COMP%]{padding:10px;display:flex;align-items:center;background-color:#a5c3d6}.chat-footer-desktop[_ngcontent-%COMP%]{border-bottom-left-radius:10px;border-bottom-right-radius:10px}.chat-footer-mobile[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font-size:16px}.chat-footer[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{flex:1;padding:5px;margin-right:10px;background-color:#a5c3d6;overflow:hidden;resize:none}.chat-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:5px 10px;border:none;border-radius:5px;cursor:pointer}.chat-message[_ngcontent-%COMP%]{margin-bottom:5px;padding:5px;border-radius:5px}.chat-message-content[_ngcontent-%COMP%]{margin-left:29px;word-wrap:anywhere}[_nghost-%COMP%]  .chat-message-content>*:first-child{margin-top:0}[_nghost-%COMP%]  .chat-message-content>h3{font-size:2rem;font-weight:400}[_nghost-%COMP%]  .chat-message-content>h2{font-size:2.2rem;font-weight:400}[_nghost-%COMP%]  .chat-message-content>h1{font-size:2.4rem;font-weight:400}[_nghost-%COMP%]  .chat-message-content>*:last-child{margin-bottom:0}.chat-message-footer[_ngcontent-%COMP%]{margin-left:29px;font-size:.9rem;opacity:70%}.sent-message[_ngcontent-%COMP%]{margin-left:10%;background-color:#a5c3d6}.received-message[_ngcontent-%COMP%]{margin-right:10%;background-color:#b9d9d5}.loading-dots[_ngcontent-%COMP%]{display:flex;align-items:center}.dot[_ngcontent-%COMP%]{width:10px;height:10px;margin:0 5px;background-color:#333;border-radius:50%;animation:_ngcontent-%COMP%_dot-blink 1.4s infinite both}.dot[_ngcontent-%COMP%]:nth-child(1){animation-delay:-.32s}.dot[_ngcontent-%COMP%]:nth-child(2){animation-delay:-.16s}@keyframes _ngcontent-%COMP%_dot-blink{0%,80%,to{opacity:0}40%{opacity:1}}#floating-chat-textarea[_ngcontent-%COMP%]{border-style:none;outline:none;min-height:50px}#floating-chat-textarea[_ngcontent-%COMP%]:focus{border-style:none;outline:none}"],
        data: {
          animation: [trigger('floatIn', [state('void', style({
            transform: 'translateY(100%)',
            opacity: 0
          })), transition(':enter', [animate('300ms ease-out', style({
            transform: 'translateY(0)',
            opacity: 1
          }))]), transition(':leave', [animate('300ms ease-in', style({
            transform: 'translateY(100%)',
            opacity: 0
          }))])])]
        }
      });
    }
  }
  return FloatingChatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppMenuButtonComponent = /*#__PURE__*/(() => {
  class AppMenuButtonComponent {
    constructor() {
      this.title = '';
      this.icon = '';
      this.dropdown = false;
      this.isOpen = false;
      this.translate = false;
      this.newWindow = false;
      this.highlight = false;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function AppMenuButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMenuButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AppMenuButtonComponent,
        selectors: [["hpo-app-menu-button"]],
        inputs: {
          title: "title",
          icon: "icon",
          backgroundColor: "backgroundColor",
          textColor: "textColor",
          dropdown: "dropdown",
          isOpen: "isOpen",
          translate: "translate",
          newWindow: "newWindow",
          highlight: "highlight"
        },
        decls: 7,
        vars: 14,
        consts: [[1, "menu-item", 3, "ngClass"], [1, "menu-icon"], ["class", "menu-title", 4, "ngIf"], ["class", "drop-down-arrow", 3, "color", 4, "ngIf"], [1, "menu-title"], [4, "ngIf"], ["aria-hidden", "true", 3, "inline"], [1, "drop-down-arrow"]],
        template: function AppMenuButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "mat-icon");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, AppMenuButtonComponent_div_4_Template, 4, 4, "div", 2)(5, AppMenuButtonComponent_div_5_Template, 3, 2, "div", 2)(6, AppMenuButtonComponent_div_6_Template, 3, 4, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background-color", ctx.backgroundColor)("color", ctx.textColor);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c9, ctx.highlight, ctx.backgroundColor));
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("color", ctx.textColor);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.translate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.translate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dropdown);
          }
        },
        dependencies: [i12.NgClass, i12.NgIf, i3$1.MatIcon, i1$2.BlahPipe],
        styles: [".menu-item[_ngcontent-%COMP%]{line-height:1;display:flex;font-size:1.3rem;flex-direction:row;justify-content:flex-start;padding:.5rem .5rem .5rem 1rem;color:var(--color-text-dark);cursor:pointer;background-color:#fff;transition:background-color .15s,opacity .15s}.menu-item[_ngcontent-%COMP%]:hover{background-color:var(--color-primary-50)}.menu-item[_ngcontent-%COMP%]:hover.colored{opacity:.75}.menu-item.highlight[_ngcontent-%COMP%]{background-color:var(--color-primary-50)}.menu-icon[_ngcontent-%COMP%]{color:var(--color-text-gray);padding:.2rem 1rem 0 .2rem}.menu-title[_ngcontent-%COMP%]{font-weight:500;flex-grow:2;word-break:break-all;padding:.7rem .4rem 0 1rem}.drop-down-arrow[_ngcontent-%COMP%]{color:var(--color-text-gray);padding:.2rem .2rem 0 1rem}"]
      });
    }
  }
  return AppMenuButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppMenuSubButtonComponent = /*#__PURE__*/(() => {
  class AppMenuSubButtonComponent {
    constructor() {
      this.title = '';
      this.link = '';
      this.linkQueryParams = null;
      this.disableLink = false;
      this.newWindow = false;
      this.translate = false;
      this.highlight = false;
      this.navigated = new EventEmitter();
    }
    ngOnInit() {}
    static {
      this.ɵfac = function AppMenuSubButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMenuSubButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AppMenuSubButtonComponent,
        selectors: [["hpo-app-menu-sub-button"]],
        inputs: {
          title: "title",
          backgroundColor: "backgroundColor",
          textColor: "textColor",
          link: "link",
          linkQueryParams: "linkQueryParams",
          disableLink: "disableLink",
          newWindow: "newWindow",
          translate: "translate",
          highlight: "highlight"
        },
        outputs: {
          navigated: "navigated"
        },
        decls: 3,
        vars: 3,
        consts: [[3, "href", 4, "ngIf"], [3, "routerLink", "queryParams", "click", 4, "ngIf"], ["class", "menu-sub-item", 3, "background-color", "color", 4, "ngIf"], [3, "href"], [1, "menu-sub-item", 3, "ngClass"], ["aria-hidden", "true", 3, "inline", 4, "ngIf"], ["aria-hidden", "true", 3, "inline"], [3, "click", "routerLink", "queryParams"], ["class", "menu-sub-item", 3, "ngClass", "background-color", "color", 4, "ngIf"], [1, "menu-sub-item"]],
        template: function AppMenuSubButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AppMenuSubButtonComponent_a_0_Template, 4, 12, "a", 0)(1, AppMenuSubButtonComponent_a_1_Template, 3, 4, "a", 1)(2, AppMenuSubButtonComponent_div_2_Template, 2, 5, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.link.startsWith("http") || ctx.newWindow) && !ctx.disableLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.link.startsWith("http") && !ctx.newWindow && !ctx.disableLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.disableLink);
          }
        },
        dependencies: [i12.NgClass, i12.NgIf, i1$5.RouterLink, i3$1.MatIcon, i1$2.BlahPipe],
        styles: ["a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:link, a[_ngcontent-%COMP%]:visited, a[_ngcontent-%COMP%]:hover{color:var(--color-text-dark)}.menu-sub-item[_ngcontent-%COMP%]{font-size:1.3rem;line-height:1;cursor:pointer;padding:1rem 0 1rem 5.5rem;text-decoration:none;background-color:#fff;transition:background-color .15s,opacity .15s}.menu-sub-item[_ngcontent-%COMP%]:hover{background-color:var(--color-primary-50)}.menu-sub-item[_ngcontent-%COMP%]:hover.colored{opacity:.75}.menu-sub-item.highlight[_ngcontent-%COMP%]{background-color:var(--color-primary-50)}"]
      });
    }
  }
  return AppMenuSubButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AppMenuComponent = /*#__PURE__*/(() => {
  class AppMenuComponent {
    constructor(router) {
      this.router = router;
      /* /Menu Minimized */
      this.navigated = new EventEmitter();
      this.menuMinimizedChange = new EventEmitter();
    }
    ngOnInit() {}
    /**
     * Toggle open/close state of submenu lists
     * @param item MenuItem
     */
    toggleSubMenu(item) {
      item.subItemsOpened = !item.subItemsOpened;
    }
    /**
     * Navigate to a page with router instead of refreshing page
     * @param link Link to a page
     */
    navigate(link) {
      if (link.startsWith('http')) {
        window.location.href = link;
      } else {
        this.router.navigate([link]);
        this.navigated.emit();
      }
    }
    static {
      this.ɵfac = function AppMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppMenuComponent)(i0.ɵɵdirectiveInject(i1$5.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AppMenuComponent,
        selectors: [["hpo-app-menu"]],
        inputs: {
          menuItems: "menuItems"
        },
        outputs: {
          navigated: "navigated",
          menuMinimizedChange: "menuMinimizedChange"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngFor", "ngForOf"], [3, "href", 4, "ngIf"], [3, "routerLink", "queryParams", "click", 4, "ngIf"], [3, "title", "icon", "dropdown", "isOpen", "translate", "backgroundColor", "textColor", "click", 4, "ngIf"], ["class", "dropdown", 4, "ngIf"], [3, "href"], [3, "title", "icon", "dropdown", "isOpen", "translate", "newWindow", "backgroundColor", "textColor"], [3, "click", "routerLink", "queryParams"], [3, "title", "icon", "dropdown", "isOpen", "translate", "backgroundColor", "textColor"], [3, "click", "title", "icon", "dropdown", "isOpen", "translate", "backgroundColor", "textColor"], [1, "dropdown"], [3, "title", "link", "linkQueryParams", "newWindow", "translate", "backgroundColor", "textColor", "navigated", 4, "ngFor", "ngForOf"], [3, "navigated", "title", "link", "linkQueryParams", "newWindow", "translate", "backgroundColor", "textColor"]],
        template: function AppMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AppMenuComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.menuItems);
          }
        },
        dependencies: [i12.NgForOf, i12.NgIf, i1$5.RouterLink, AppMenuButtonComponent, AppMenuSubButtonComponent],
        styles: ["a[_ngcontent-%COMP%]{text-decoration:none}"]
      });
    }
  }
  return AppMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoLayoutComponent = /*#__PURE__*/(() => {
  class HpoLayoutComponent {
    get productManualUrl() {
      const lang = this.blahService.currentLocale.substring(0, 2);
      const productManualPath = this.productManualIndex?.[lang] ?? '';
      return this.iwiBaseUrl + productManualPath;
    }
    get swUpdateNotificationVisible() {
      return !this.swUpdateDisabled && (this.swUpdateEventType === 'NO_NEW_VERSION_DETECTED' || this.swUpdateEventType === 'VERSION_INSTALLATION_FAILED');
    }
    constructor(blahService, layoutBreakpoint, router, route, sharedService, dialog, toaster, fullScreenDialog, swUpdate, liveMessagingService, featureFlagService, smoothness) {
      this.blahService = blahService;
      this.layoutBreakpoint = layoutBreakpoint;
      this.router = router;
      this.route = route;
      this.sharedService = sharedService;
      this.dialog = dialog;
      this.toaster = toaster;
      this.fullScreenDialog = fullScreenDialog;
      this.swUpdate = swUpdate;
      this.liveMessagingService = liveMessagingService;
      this.featureFlagService = featureFlagService;
      this.smoothness = smoothness;
      this.locationUri = window.location.href;
      this.localeSwitcher = true;
      this.searchActive = false;
      this.portalProductId = 577;
      this.swUpdateDisabled = false;
      this.noNoteEnvironments = ['PROD'];
      // Floating chat window inputs
      this.chatEnabled = false;
      this.logoutClicked = new EventEmitter();
      this.sidenavToggled = new EventEmitter();
      // Floating chat window outputs
      this.chatReset = new EventEmitter();
      this.chatMessageSent = new EventEmitter();
      this.menuMinimized = false;
      this.menuState = 'out'; // menu is hidden by default
      this.debugInfoVisible = false;
      this.languageDropdownOpen = false;
      this.supportDropdownOpen = false;
      this.favouriteApps = [];
      this.nonPerson = false;
      this.portalMenuItems = [];
      this.allNotificationItems = [];
      this.unexpiredNews = [];
      this.uncheckedNews = [];
      this.hideNews = true;
      this.messagingServiceInitializeTriggered = false;
      this.messagingServiceInitialized = false;
      this.newMessageCount = 0;
      this.messagesOpen = false;
      this.impactCounterVisible = false;
      this.cumulativeImpact = 0;
      this.impactTreshold = 0;
      this.isChatOpen = false;
      // True when viewed on a handset
      this.handsetLayout = false;
      this.iwiBaseUrl = 'https://ohjeistot.headpower.fi/';
      this.destroy$ = new Subject();
    }
    ngOnChanges(changes) {
      if (changes.environmentVariables) {
        const envName = this.environmentVariables?.config?.environmentName;
        this.environmentNote = envName && !this.noNoteEnvironments.includes(envName) ? envName : undefined;
      }
      if (changes.currentUser && this.currentUser) {
        this.messagesLastOpened = localStorage.getItem(`notificationsLastChecked_${this.currentUser.userId}`) ?? '0001-01-01T00:00:00.0000001+03:00';
      }
      // Initialize LiveMessagingService ...
      // - if showMessages === true and
      // - if not initialized yet (either here in layout or in product itself) and
      // - when currentuser's access token is ready and available
      if (!this.messagingServiceInitializeTriggered && (changes.showMesages || changes.backendLiveMsgUri || changes.currentUser) && this.showMessages && this.backendLiveMsgUri && this.currentUser?.accessToken) {
        this.messagingServiceInitializeTriggered = true;
        this.initFeatureFlagsService();
        this.initLiveMessagingService();
      }
    }
    ngOnInit() {
      this.initSwUpdate();
      // Initialize smoothness hooks if service is provided in host app
      if (this.smoothness) {
        this.initSmoothnessHooks();
      }
      // Locale change updater
      this.blahService.localeChange$.pipe(takeUntil(this.destroy$)).subscribe(newLocale => {
        this.portalMenuItems = this.getPortalMenuItems();
        this.updateDayjsLocale(newLocale);
        this.getContactInformationTexts();
        this.getUnexpiredNews();
      });
      // Layout breakpoint observer
      this.layoutBreakpoint.observer$.pipe(takeUntil(this.destroy$)).subscribe(result => this.handsetLayout = result.handset);
      // Set current locale
      this.updateDayjsLocale(this.blahService.currentLocale);
      this.sharedService.portalBaseUri = this.portalBaseUri;
      this.sharedService.backendAccountUri = this.backendAccountUri;
      this.sharedService.backendPortalUri = this.backendPortalUri;
      this.availableLocales = this.blahService.availableLocales.sort((a, b) => {
        // 'fi-FI' will always be the first
        if (a === 'fi-FI') {
          return -1;
        }
        if (b === 'fi-FI') {
          return 1;
        }
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        } else {
          return 0;
        }
      });
      // Get indication where to open product (new tab or current one)
      this.sharedService.getSettingsValue(13, 1701).subscribe(result => {
        this.openProductToNewTab = !!result && result !== '0';
      }, error => {
        console.error('[HpoLayout]', 'Failed to get indication where to open product (new tab or current one).');
      });
      this.getContactInformationTexts();
      this.portalMenuItems = this.getPortalMenuItems();
      this.fetchProductManualIndex();
      this.updateApplicationData();
      this.sharedService.favouriteUpdateRequest.pipe(takeUntil(this.destroy$)).subscribe(() => this.updateApplicationData());
      this.getUnexpiredNews();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    initSwUpdate() {
      if (!this.swUpdate.isEnabled) {
        console.log('[SwUpdate]', 'Service Worker is not enabled.');
        return;
      }
      const noteKey = `${this.productId}-swupdate`;
      this.swUpdate.versionUpdates.pipe(
      // Sw update might emit duplicate events so use distinct
      distinctUntilKeyChanged('type')).pipe(takeUntil(this.destroy$)).subscribe(e => {
        // Clear previous close handle when new event triggers
        if (this.swUpdateNotificationCloseHandle) {
          clearTimeout(this.swUpdateNotificationCloseHandle);
          this.swUpdateNotificationCloseHandle = undefined;
        }
        switch (e.type) {
          case 'VERSION_READY':
            {
              localStorage.setItem(noteKey, '1');
              this.swUpdateEventType = 'VERSION_READY';
              this.initSwUpdateVersionReadyEventHooks();
              console.log('[SwUpdate]', 'Software update downloaded, waiting for reload to install.');
            }
            break;
          case 'VERSION_INSTALLATION_FAILED':
            {
              localStorage.removeItem(noteKey);
              this.swUpdateEventType = 'VERSION_INSTALLATION_FAILED';
              console.error('[SwUpdate]', !this.swUpdateDisabled ? 'Software update failed, notifying user.' : 'Software update failed, notifying is disabled by the app.');
              console.error('[SwUpdate]', e.error);
            }
            break;
          case 'VERSION_DETECTED':
            {
              localStorage.removeItem(noteKey);
              this.swUpdateEventType = 'VERSION_DETECTED';
              console.log('[SwUpdate]', 'Software update found, downloading...');
            }
            break;
          case 'NO_NEW_VERSION_DETECTED':
            {
              // Check for updated only after reload (no previous update event).
              // As this event is also triggered after VERSION_READY.
              if (!this.swUpdateEventType) {
                const wasUpdated = localStorage.getItem(noteKey);
                if (wasUpdated) {
                  localStorage.removeItem(noteKey);
                  this.swUpdateEventType = 'NO_NEW_VERSION_DETECTED';
                  // Close notification automatically after 10 seconds
                  this.swUpdateNotificationCloseHandle = setTimeout(() => {
                    this.swUpdateNotificationCloseHandle = undefined;
                    this.closeSwUpdateNotification();
                  }, 10000);
                  console.log('[SwUpdate]', !this.swUpdateDisabled ? 'Software updated, notifying user.' : 'Software updated, notifying is disabled by the app.');
                }
              }
            }
            break;
        }
      });
    }
    initSwUpdateVersionReadyEventHooks() {
      // After sw update is downloaded, call reload after possible navigation.
      this.router.events.pipe(filter(e => e instanceof NavigationEnd), take$1(1)).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.swUpdateReload();
      });
    }
    swUpdateReload() {
      if (this.swUpdateDisabled) {
        console.log('[SwUpdate]', 'Software update reload called, but update is disabled by the app.');
        return;
      }
      window.location.reload();
    }
    closeSwUpdateNotification() {
      this.swUpdateEventType = undefined;
    }
    initFeatureFlagsService() {
      const envName = this.environmentVariables?.config?.environmentName;
      const flagClaims = {
        'env': envName,
        ...this.claims
      };
      // Configure FeatureFlags
      this.featureFlagService.config = {
        environment: this.environmentVariables,
        claims: flagClaims,
        baseUri: 'https://backend.headpower.fi',
        filterClaims: ['iss', 'aud', 'exp', 'nbf', 'nonce', 'iat', 'at_hash', 'sid', 'auth_time', 'idp', 'amr']
      };
      this.featureFlagService.init();
    }
    initLiveMessagingService() {
      this.featureFlagService.isFeatureAvailable('Portal.ShowNotifications').subscribe(result => {
        if (result) {
          const logLevel = this.productionMode ? 2 :
          // Information in prod mode
          1; // Debug in dev mode
          this.liveMessagingService.init(this.productId, `${this.backendLiveMsgUri}/LiveMessaging.WebAPI/`, () => this.currentUser?.accessToken, logLevel);
        }
      });
    }
    initSmoothnessHooks() {
      this.smoothness.armed$.pipe(take$1(1)).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.cumulativeImpact = this.smoothness.cumulativeImpact;
        this.impactTreshold = this.smoothness.impactTreshold;
      });
      this.smoothness.impact$.pipe(takeUntil(this.destroy$)).subscribe(impact => {
        this.cumulativeImpact = impact.cumulativeImpact;
      });
    }
    getPortalMenuItems() {
      if (this.currentUser.limitedUser) {
        return [];
      }
      const menu = [new MenuItem('layout.portal', this.portalBaseUri, {
        icon: 'home'
      }), new MenuItem('layout.favorites', '', {
        icon: 'star',
        subItems: this.favouriteApps
      })];
      const locale = this.claims?.locale ?? '';
      if (locale.includes('-FI') || locale === 'fi') {
        menu.splice(1, 0, new MenuItem('layout.guidelines', this.iwiBaseUrl, {
          icon: 'info'
        }));
      }
      return menu;
    }
    clearArray(arr) {
      while (arr.length > 0) {
        arr.pop();
      }
    }
    updateApplicationData() {
      this.currentLocale = this.blahService.currentLocale;
      this.sharedService.getApplicationData(this.currentLocale).subscribe(res => {
        // Clear arrays
        // We cannot assign new empty array because that will break the reference
        this.clearArray(this.favouriteApps);
        const favourites = res.filter(o => o.PersonFavoriteApplication == 1);
        favourites.forEach(favApp => {
          const appLink = favApp.Url.startsWith('http') ? favApp.Url : this.portalBaseUri.substr(0, this.portalBaseUri.length - 1) + favApp.Url;
          this.favouriteApps.push(new MenuItem(favApp.AccessName, appLink, {
            translate: false,
            newWindow: this.openProductToNewTab
          }));
        });
        // Sort favourites
        this.favouriteApps.sort((a, b) => {
          if (a.title > b.title) {
            return 1;
          } else if (a.title < b.title) {
            return -1;
          } else {
            return 0;
          }
        });
      });
    }
    updateDayjsLocale(locale) {
      dayjs.locale(locale.substring(0, 2));
    }
    /**
    * Gets unexpired news
    */
    getUnexpiredNews() {
      // NewPortal does not have Shared news functionality
      if (this.productId !== 577) {
        // Check IWM (we have some special conditions there)
        if (this.productId === 561) {
          const queryParams = this.route.snapshot.queryParamMap;
          if (queryParams.get('openedFromIwd') === 'true') {
            this.sharedService.hasProductUsageRight(561, false).subscribe(result => {
              this.hideNews = !result;
            }, error => {
              this.hideNews = true;
              console.error('[HpoLayout]', 'Failed to check user rights for IWM in getUnexpiredNews method.');
            });
          }
        }
        this.currentLocale = this.blahService.currentLocale;
        // Clears arrays (needed in case if language is changed)
        this.allNotificationItems = [];
        this.unexpiredNews = [];
        this.uncheckedNews = [];
        this.sharedService.getUnexpiredNews(this.productId.toString(), this.currentLocale.substr(0, 2)).pipe(tap(result => this.parseNotifications(this.unexpiredNews, result.value)), switchMap(result => this.getUncheckedNews()), tap(result => this.parseNotifications(this.uncheckedNews, result.value))).subscribe(result => {
          // If there are no valid news hide news from the top bar
          if (this.unexpiredNews.length > 0 || this.uncheckedNews.length > 0) {
            this.hideNews = false;
          } else {
            this.hideNews = true;
          }
          this.initNotifications();
        }, error => {
          console.error('[HpoLayout]', 'Failed to merge news in getUnexpiredNews method.');
        });
      } else {
        this.hideNews = true;
      }
    }
    /**
    * Parses notifications
    * @param array destination array of notifications
    * @param notifications source array of notifications
    */
    parseNotifications(array, notifications) {
      for (const notification of notifications) {
        let newNotification = new Notification();
        newNotification.objectId = notification.ObjectId;
        newNotification.title = notification.Title;
        newNotification.content = notification.Content;
        newNotification.created = notification.Created;
        newNotification.eventId = notification.EventId;
        newNotification.important = notification.Important;
        array.push(newNotification);
      }
    }
    /**
    * Inits notifications
    */
    initNotifications() {
      this.unexpiredNews.forEach(val => {
        if (this.uncheckedNews.some(n => n.eventId === val.eventId)) {
          val.isUnchecked = true;
          if (val.important) {
            this.sharedService.getUserInfo(this.currentUser.userId).subscribe(userData => {
              this.nonPerson = userData.NonPerson;
              if (!this.nonPerson) {
                this.openImportantNewsDialog(val);
              }
            }, error => {
              console.error('[HpoLayout]', 'Failed to check NonPerson status in getUserInfo method.');
            });
          }
        }
        this.allNotificationItems.push(val);
      });
    }
    /**
    * Gets unchecked news
    */
    getUncheckedNews() {
      return this.sharedService.getUncheckedNews(this.productId.toString(), this.currentLocale.substr(0, 2));
    }
    /**
    * Gets contact information text/parts
    */
    getContactInformationTexts() {
      return this.sharedService.getTextObject(5, 1, this.blahService.currentLocale).subscribe(result => {
        this.contactInformationText = result.TextParts[0].Value;
      }, error => {
        console.error('[HpoLayout]', 'Failed to get Helpdesk contact information Text/Parts');
      });
    }
    /** Returns application page name or an empty string */
    getApplicationPageName() {
      this.applicationPageName = this.applicationPageName ? this.applicationPageName : '';
      return this.applicationPageName;
    }
    /** Returns application subtitle if present */
    getApplicationPageSubtitle() {
      return this.applicationPageSubtitle ? this.applicationPageSubtitle : '';
    }
    get encodedLocationUri() {
      return encodeURIComponent(this.locationUri);
    }
    fetchProductManualIndex() {
      this.sharedService.getProductManualIndex(this.productId).subscribe(result => {
        this.productManualIndex = result;
      });
    }
    openPortalProfileSettings() {
      if (!this.currentUser.limitedUser) {
        const url = this.portalBaseUri + 'newportal/Profile';
        window.open(url, "_blank");
      }
    }
    openHelpdeskDialog(supportRequest) {
      const dialogConfig = {
        width: !this.handsetLayout ? '800px' : undefined,
        maxWidth: !this.handsetLayout ? '100vw' : undefined,
        maxHeight: !this.handsetLayout ? '90vh' : undefined,
        disableClose: true,
        autoFocus: false,
        data: {
          supportRequest,
          fullScreenDialog: this.handsetLayout,
          location: window.location.href,
          productId: this.productId,
          claims: this.claims,
          contactInformationText: this.contactInformationText,
          // Full-screen dialog properties
          dialogTitle: supportRequest ? 'layout.supportRequest' : 'layout.feedback',
          actionLabel: 'layout.send'
        }
      };
      if (this.handsetLayout) {
        this.fullScreenDialog.open(HelpdeskDialogComponent, dialogConfig);
      } else {
        this.dialog.open(HelpdeskDialogComponent, dialogConfig);
      }
    }
    /**
    * Open important news dialog and
    * marks notification as read
    */
    openImportantNewsDialog(notification) {
      const dialogConfig = {
        width: !this.handsetLayout ? '800px' : undefined,
        maxWidth: !this.handsetLayout ? '100vw' : undefined,
        maxHeight: !this.handsetLayout ? '90vh' : undefined,
        disableClose: true,
        autoFocus: false,
        data: {
          fullScreenDialog: this.handsetLayout,
          notification: notification,
          uncheckedNews: this.uncheckedNews
        }
      };
      if (this.handsetLayout) {
        this.fullScreenDialog.open(ImportantNewsDialogComponent, dialogConfig);
      } else {
        this.dialog.open(ImportantNewsDialogComponent, dialogConfig);
      }
    }
    /**
    * Open notifications list dialog
    */
    openNotificationsListDialog() {
      if (this.allNotificationItems.length === 0) {
        this.toaster.create(this.blahService.blah('layout.noCurrentNews'));
        return;
      }
      const dialogConfig = {
        width: !this.handsetLayout ? '800px' : undefined,
        maxWidth: !this.handsetLayout ? '100vw' : undefined,
        height: '100vh',
        maxHeight: '100vh',
        disableClose: false,
        autoFocus: false,
        data: {
          fullScreenDialog: this.handsetLayout,
          productId: this.productId,
          portalBaseUri: this.portalBaseUri,
          uncheckedNews: this.uncheckedNews,
          // Full-screen dialog properties
          dialogTitle: 'layout.productNews'
        },
        position: {
          right: '0',
          top: '0'
        }
      };
      if (this.handsetLayout) {
        this.fullScreenDialog.open(NotificationsListDialogComponent, dialogConfig);
      } else {
        this.dialog.open(NotificationsListDialogComponent, dialogConfig);
      }
    }
    toggleMessages() {
      this.messagesLastOpened = new Date().toISOString();
      localStorage.setItem(`notificationsLastChecked_${this.currentUser.userId}`, this.messagesLastOpened);
      this.messagesOpen = !this.messagesOpen;
      if (!this.messagesOpen) {
        this.newMessageCount = 0;
      }
    }
    close() {
      if (this.messagesOpen) {
        this.toggleMessages();
      }
    }
    /**
    * Open company admins dialog
    */
    openCompanyAdminsDialog() {
      const dialogConfig = {
        width: !this.handsetLayout ? '800px' : undefined,
        maxWidth: !this.handsetLayout ? '100vw' : undefined,
        maxHeight: !this.handsetLayout ? '90vh' : undefined,
        disableClose: false,
        autoFocus: false,
        data: {
          fullScreenDialog: this.handsetLayout,
          dialogTitle: 'layout.companyAdmins'
        }
      };
      if (this.handsetLayout) {
        this.fullScreenDialog.open(CompanyAdminsDialogComponent, dialogConfig);
      } else {
        this.dialog.open(CompanyAdminsDialogComponent, dialogConfig);
      }
    }
    changeLocale(locale) {
      this.sharedService.changeUserLanguage(locale).subscribe({
        error: e => console.error(e)
      });
      this.blahService.changeLocale(locale);
    }
    logOut() {
      this.logoutClicked.emit(true);
    }
    navOpenedChange(opened) {
      this.sidenavToggled.emit(opened);
    }
    toggleLanguages() {
      this.languageDropdownOpen = !this.languageDropdownOpen;
    }
    /**
     * Toggle support dropdown closed/open
     */
    toggleSupport() {
      this.supportDropdownOpen = !this.supportDropdownOpen;
    }
    menuNavigated() {
      // Hide the side menu when navigation occurs and we are in handset layout
      if (this.handsetLayout) {
        this.sideNav.close();
      }
    }
    handleChatState(event) {
      if (event === 'toggle') {
        this.toggleChat();
      } else if (event === 'reset') {
        this.chatReset.next();
      }
    }
    handleChatMessageSent(event) {
      this.chatMessageSent.next(event);
    }
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
    }
    static {
      this.ɵfac = function HpoLayoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoLayoutComponent)(i0.ɵɵdirectiveInject(i1$2.BlahService), i0.ɵɵdirectiveInject(LayoutBreakpointService), i0.ɵɵdirectiveInject(i1$5.Router), i0.ɵɵdirectiveInject(i1$5.ActivatedRoute), i0.ɵɵdirectiveInject(SharedService), i0.ɵɵdirectiveInject(i2.MatDialog), i0.ɵɵdirectiveInject(ToasterService), i0.ɵɵdirectiveInject(i7$1.FullScreenDialogService), i0.ɵɵdirectiveInject(i8$1.SwUpdate), i0.ɵɵdirectiveInject(LiveMessagingService), i0.ɵɵdirectiveInject(i2$1.FeatureFlagService), i0.ɵɵdirectiveInject(SmoothnessEnforcer, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HpoLayoutComponent,
        selectors: [["hpo-layout"]],
        viewQuery: function HpoLayoutComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sideNav = _t.first);
          }
        },
        inputs: {
          productionMode: "productionMode",
          environmentVariables: "environmentVariables",
          claims: "claims",
          portalBaseUri: "portalBaseUri",
          accountBaseUri: "accountBaseUri",
          backendAccountUri: "backendAccountUri",
          backendPortalUri: "backendPortalUri",
          locationUri: "locationUri",
          applicationName: "applicationName",
          applicationNameShort: "applicationNameShort",
          applicationPageName: "applicationPageName",
          applicationPageSubtitle: "applicationPageSubtitle",
          productId: "productId",
          menuItems: "menuItems",
          menuIsHidden: "menuIsHidden",
          currentUser: "currentUser",
          applicationSpecificTemplate: "applicationSpecificTemplate",
          applicationSearchTemplate: "applicationSearchTemplate",
          mainTemplate: "mainTemplate",
          floatingActionButtonTemplate: "floatingActionButtonTemplate",
          localeSwitcher: "localeSwitcher",
          searchActive: "searchActive",
          portalProductId: "portalProductId",
          deputyFeatureProductId: "deputyFeatureProductId",
          appVersion: "appVersion",
          swUpdateDisabled: "swUpdateDisabled",
          noNoteEnvironments: "noNoteEnvironments",
          chatEnabled: "chatEnabled",
          chatData: "chatData",
          backendLiveMsgUri: "backendLiveMsgUri",
          showMessages: "showMessages"
        },
        outputs: {
          logoutClicked: "logoutClicked",
          sidenavToggled: "sidenavToggled",
          chatReset: "chatReset",
          chatMessageSent: "chatMessageSent"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 66,
        vars: 69,
        consts: [["sidenav", ""], ["appBarButton", ""], ["noPrint", "", "role", "navigation", 1, "app-bar"], [1, "default-content", 3, "ngClass"], ["class", "environment-note", 4, "ngIf"], ["class", "side-navigation-icon", 4, "ngIf"], ["class", "title", 4, "ngIf"], [1, "app-content"], [1, "container"], ["class", "app-specific-space", 4, "ngIf"], ["class", "product-news", 4, "ngIf"], [1, "search", 3, "ngClass"], [4, "ngTemplateOutlet"], ["class", "messages-icon-button-container", 4, "ngIf"], [1, "floating-action-button"], ["id", "floating-chat-button-container", 3, "ngStyle", "click", 4, "ngIf"], [1, "sidenav-container", "page-content-container"], ["noPrint", "", 1, "sidenav", "layout-sidenav", 3, "openedStart", "closedStart", "mode", "opened", "ngClass"], [1, "user-profile-container"], ["href", "#", "tabindex", "-1", 1, "user-profile-link", 3, "click"], [1, "user-profile-picture-container"], ["width", "46", "height", "46", 3, "src"], [1, "user-profile-info-layer"], [1, "user-name"], [1, "user-company"], [1, "menu-items-container"], [1, "portal-menu", "menu-section"], [3, "navigated", "menuItems"], ["id", "productNewsHandset", 3, "title", "click", 4, "ngIf"], [1, "menu-divider"], [1, "app-menu", "menu-section"], [1, "support-menu", "menu-section"], ["id", "floating-chat-mobile-menu-button", "icon", "chat", 3, "title", "dropdown", "click", 4, "ngIf"], ["icon", "help", 3, "click", "title", "dropdown", "isOpen"], [4, "ngIf"], ["icon", "language", 3, "click", "title", "dropdown", "isOpen"], ["icon", "input", 3, "click", "title"], ["class", "app-info-container", 4, "ngIf"], [3, "hasBackdrop"], ["id", "messages-drawer", "mode", "over", "position", "end", "disableClose", "", 3, "opened", "ngClass", "autoFocus"], [2, "padding", ".5rem"], ["mat-flat-button", "", "id", "close-messages-drawer-button", 3, "click"], [1, "messages-button-icon"], [3, "showMessages", "count", "lastOpened", "backendPortalUri", "newMessageCount"], ["id", "main"], [3, "chatVisible", "ownProfilePictureUrl", "ownName", "mobile", "chatData", "chatState", "messageSent", "contactSupportEmitter", 4, "ngIf"], ["id", "swupdate-notification", "class", "swupdate-notification", 3, "mobile", "note", "warn", "success", 4, "ngIf"], [1, "environment-note"], [1, "side-navigation-icon"], ["type", "button", 1, "app-bar-button", 3, "click"], ["matRipple", "", 1, "app-bar-button-ripple", 3, "matRippleTrigger", "matRippleCentered"], [1, "sr-only"], [1, "title"], [1, "app-specific-space"], [1, "product-news"], ["id", "productNews", "color", "primary", "class", "badge-inline", 3, "matBadgeHidden", "matBadge", "matBadgeOverlap", "click", 4, "ngIf"], ["id", "productNews", "color", "primary", 1, "badge-inline", 3, "click", "matBadgeHidden", "matBadge", "matBadgeOverlap"], [1, "messages-icon-button-container"], ["mat-icon-button", "", "id", "messages-icon-button", "class", "badge-inline", "matBadgeOverlap", "true", 3, "color", "matBadge", "matBadgeHidden", "click", 4, "ngIf"], ["mat-icon-button", "", "id", "messages-icon-button", "matBadgeOverlap", "true", 1, "badge-inline", 3, "click", "color", "matBadge", "matBadgeHidden"], ["id", "floating-chat-button-container", 3, "click", "ngStyle"], ["id", "floating-chat-button-icon"], ["id", "productNewsHandset", 3, "click", "title"], ["id", "floating-chat-mobile-menu-button", "icon", "chat", 3, "click", "title", "dropdown"], ["icon", "help", 3, "title", "disableLink", "click", 4, "ngIf"], ["icon", "help", 3, "title", "newWindow", "link", 4, "ngIf"], ["icon", "help", 3, "click", "title", "disableLink"], ["icon", "feedback", 3, "click", "title", "disableLink"], ["icon", "help", 3, "title", "newWindow", "link"], [3, "title", "disableLink", "click", 4, "ngFor", "ngForOf"], [3, "click", "title", "disableLink"], [1, "debug-menu", "menu-section"], ["title", "Toggle debug info", 3, "click"], [1, "app-info-container"], [1, "app-version", 3, "click"], ["id", "app-version"], [1, "impact-counter", 3, "hidden"], ["id", "app-cumulative-impact"], ["id", "app-impact-treshold"], [1, "debug-info"], [3, "chatState", "messageSent", "contactSupportEmitter", "chatVisible", "ownProfilePictureUrl", "ownName", "mobile", "chatData"], ["id", "swupdate-notification", 1, "swupdate-notification"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "info-container"], ["mat-button", "", "id", "swupdate-close-button", 3, "click"]],
        template: function HpoLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
            i0.ɵɵtemplate(2, HpoLayoutComponent_div_2_Template, 2, 1, "div", 4)(3, HpoLayoutComponent_div_3_Template, 9, 5, "div", 5)(4, HpoLayoutComponent_div_4_Template, 8, 3, "div", 6);
            i0.ɵɵelementStart(5, "div", 7)(6, "div", 8);
            i0.ɵɵtemplate(7, HpoLayoutComponent_div_7_Template, 2, 1, "div", 9)(8, HpoLayoutComponent_div_8_Template, 2, 1, "div", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 11);
            i0.ɵɵtemplate(10, HpoLayoutComponent_ng_container_10_Template, 1, 0, "ng-container", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, HpoLayoutComponent_div_11_Template, 2, 1, "div", 13);
            i0.ɵɵelementStart(12, "div", 14);
            i0.ɵɵtemplate(13, HpoLayoutComponent_ng_container_13_Template, 1, 0, "ng-container", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(14, HpoLayoutComponent_div_14_Template, 3, 4, "div", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "mat-sidenav-container", 16)(16, "mat-sidenav", 17, 0);
            i0.ɵɵlistener("openedStart", function HpoLayoutComponent_Template_mat_sidenav_openedStart_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navOpenedChange(true));
            })("closedStart", function HpoLayoutComponent_Template_mat_sidenav_closedStart_16_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.navOpenedChange(false));
            });
            i0.ɵɵelementStart(18, "div", 18)(19, "a", 19);
            i0.ɵɵlistener("click", function HpoLayoutComponent_Template_a_click_19_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.openPortalProfileSettings();
              return i0.ɵɵresetView(false);
            });
            i0.ɵɵelementStart(20, "div", 20);
            i0.ɵɵelement(21, "img", 21);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "div", 22)(23, "span", 23);
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(25, "br");
            i0.ɵɵelementStart(26, "span", 24);
            i0.ɵɵtext(27);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(28, "div", 25)(29, "section", 26)(30, "hpo-app-menu", 27);
            i0.ɵɵlistener("navigated", function HpoLayoutComponent_Template_hpo_app_menu_navigated_30_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.menuNavigated());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(31, HpoLayoutComponent_hpo_app_menu_button_31_Template, 2, 3, "hpo-app-menu-button", 28);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(32, "div", 29);
            i0.ɵɵelementStart(33, "section", 30)(34, "hpo-app-menu", 27);
            i0.ɵɵlistener("navigated", function HpoLayoutComponent_Template_hpo_app_menu_navigated_34_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.menuNavigated());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(35, "div", 29);
            i0.ɵɵelementStart(36, "section", 31);
            i0.ɵɵtemplate(37, HpoLayoutComponent_hpo_app_menu_button_37_Template, 2, 4, "hpo-app-menu-button", 32);
            i0.ɵɵelementStart(38, "hpo-app-menu-button", 33);
            i0.ɵɵpipe(39, "blah");
            i0.ɵɵlistener("click", function HpoLayoutComponent_Template_hpo_app_menu_button_click_38_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleSupport());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(40, HpoLayoutComponent_div_40_Template, 7, 10, "div", 34);
            i0.ɵɵelementStart(41, "hpo-app-menu-button", 35);
            i0.ɵɵpipe(42, "blah");
            i0.ɵɵlistener("click", function HpoLayoutComponent_Template_hpo_app_menu_button_click_41_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleLanguages());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(43, HpoLayoutComponent_div_43_Template, 2, 1, "div", 34);
            i0.ɵɵelementStart(44, "hpo-app-menu-button", 36);
            i0.ɵɵpipe(45, "blah");
            i0.ɵɵlistener("click", function HpoLayoutComponent_Template_hpo_app_menu_button_click_44_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.logOut());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(46, HpoLayoutComponent_ng_container_46_Template, 4, 0, "ng-container", 34);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(47, HpoLayoutComponent_div_47_Template, 13, 10, "div", 37);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-sidenav-content")(49, "mat-drawer-container", 38)(50, "mat-drawer", 39)(51, "div", 40)(52, "div")(53, "button", 41);
            i0.ɵɵlistener("click", function HpoLayoutComponent_Template_button_click_53_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.close());
            });
            i0.ɵɵelementStart(54, "mat-icon", 42);
            i0.ɵɵtext(55, "close");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(56);
            i0.ɵɵpipe(57, "blah");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(58, "app-messages", 43);
            i0.ɵɵlistener("showMessages", function HpoLayoutComponent_Template_app_messages_showMessages_58_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.messagingServiceInitialized = $event);
            })("count", function HpoLayoutComponent_Template_app_messages_count_58_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.newMessageCount = $event);
            });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(59, "mat-drawer-content")(60, "div", 44);
            i0.ɵɵtemplate(61, HpoLayoutComponent_ng_container_61_Template, 1, 0, "ng-container", 12)(62, HpoLayoutComponent_router_outlet_62_Template, 1, 0, "router-outlet", 34);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(63, HpoLayoutComponent_hpo_card_63_Template, 16, 6, "hpo-card", 34);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(64, HpoLayoutComponent_app_floating_chat_64_Template, 1, 5, "app-floating-chat", 45)(65, HpoLayoutComponent_div_65_Template, 4, 15, "div", 46);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(56, _c11, ctx.handsetLayout, !ctx.handsetLayout, ctx.searchActive && ctx.handsetLayout, !ctx.searchActive && ctx.handsetLayout));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.environmentNote);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.searchActive && ctx.handsetLayout || !ctx.handsetLayout);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.searchActive && ctx.handsetLayout || !ctx.handsetLayout);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.handsetLayout);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.hideNews);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(61, _c12, ctx.searchActive && ctx.handsetLayout));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.applicationSearchTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showMessages && ctx.messagingServiceInitialized);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.floatingActionButtonTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.chatEnabled && !ctx.isChatOpen && !ctx.handsetLayout && !ctx.messagesOpen);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mode", ctx.handsetLayout ? "over" : "side")("opened", ctx.handsetLayout ? false : true)("ngClass", i0.ɵɵpureFunction2(63, _c13, !ctx.handsetLayout, ctx.handsetLayout));
            i0.ɵɵadvance(5);
            i0.ɵɵpropertyInterpolate("src", ctx.currentUser.picture, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.currentUser.givenName, " ", ctx.currentUser.familyName, "");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.currentUser.companyName);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("menuItems", ctx.portalMenuItems);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.handsetLayout && !ctx.hideNews);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("menuItems", ctx.menuItems);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.chatEnabled && ctx.handsetLayout);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(39, 48, "layout.support"));
            i0.ɵɵproperty("dropdown", true)("isOpen", ctx.supportDropdownOpen);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.supportDropdownOpen);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(42, 50, "layout.language"));
            i0.ɵɵproperty("dropdown", true)("isOpen", ctx.languageDropdownOpen);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.languageDropdownOpen);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(45, 52, "layout.logOut"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.productionMode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.appVersion);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hasBackdrop", false);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("top", 48, "px");
            i0.ɵɵproperty("opened", ctx.messagesOpen)("ngClass", i0.ɵɵpureFunction2(66, _c14, !ctx.handsetLayout, ctx.handsetLayout))("autoFocus", false);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(57, 54, "layout.close"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("lastOpened", ctx.messagesLastOpened)("backendPortalUri", ctx.backendPortalUri)("newMessageCount", ctx.newMessageCount);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.mainTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mainTemplate === undefined);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.debugInfoVisible);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.chatEnabled && !ctx.messagesOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.swUpdateNotificationVisible);
          }
        },
        dependencies: [i12.NgClass, i12.NgForOf, i12.NgIf, i12.NgTemplateOutlet, i12.NgStyle, i12.NgSwitch, i12.NgSwitchCase, i1$5.RouterOutlet, i13.MatDrawer, i13.MatDrawerContainer, i13.MatDrawerContent, i13.MatSidenav, i13.MatSidenavContainer, i13.MatSidenavContent, i3$1.MatIcon, i15.MatRipple, i16.MatBadge, i5.MatButton, i5.MatIconButton, i7$1.ButtonComponent, i7$1.CardComponent, i7$1.CardContentComponent, i7$1.CardHeaderComponent, NoPrintDirective, MessagesComponent, FloatingChatComponent, AppMenuComponent, AppMenuButtonComponent, AppMenuSubButtonComponent, i12.JsonPipe, i12.DecimalPipe, i1$2.BlahPipe],
        styles: ["[_nghost-%COMP%]     .layout-sidenav>.mat-drawer-inner-container{display:flex;flex-direction:column;overflow:hidden}@media print{mat-sidenav-container[_ngcontent-%COMP%]{padding-top:0!important}mat-sidenav-content[_ngcontent-%COMP%]{margin-left:0!important}}a[_ngcontent-%COMP%]{cursor:pointer}#main[_ngcontent-%COMP%]{min-height:calc(100vh - 48px)}.app-bar[_ngcontent-%COMP%]{height:48px;box-shadow:0 1px 4px #00000040;position:fixed;z-index:2;top:0;left:0;width:100%;line-height:1;color:#000000ab;background-color:#fff}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]{display:grid;grid-gap:.8rem}.app-bar[_ngcontent-%COMP%]   .default-content.desktop[_ngcontent-%COMP%]{grid-template-columns:min-content minmax(19.2rem,min-content) auto minmax(20rem,min-content) min-content 11.2rem}.app-bar[_ngcontent-%COMP%]   .default-content.desktop[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{grid-column:4}.app-bar[_ngcontent-%COMP%]   .default-content.search-active[_ngcontent-%COMP%]{grid-template-columns:auto}.app-bar[_ngcontent-%COMP%]   .default-content.search-active[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{grid-column:1/6}.app-bar[_ngcontent-%COMP%]   .default-content.search-inactive[_ngcontent-%COMP%]{grid-template-columns:min-content auto min-content}.app-bar[_ngcontent-%COMP%]   .default-content.search-inactive[_ngcontent-%COMP%]   .search[_ngcontent-%COMP%]{grid-column:5}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .side-navigation-icon[_ngcontent-%COMP%]{padding:.2rem;grid-column:1}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .environment-note[_ngcontent-%COMP%]{position:absolute;top:35px;left:56px;font-size:11px;font-weight:700;color:var(--color-warn-A200)}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{padding:1.4rem 0 0;grid-column:2;font-size:2rem;white-space:nowrap;word-wrap:none}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .app-content[_ngcontent-%COMP%]{grid-column:3}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .app-content[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr 1fr;grid-gap:1rem}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .app-content[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   .product-news[_ngcontent-%COMP%]{margin-top:7px}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .messages-icon-button-container[_ngcontent-%COMP%]{grid-column:5}.app-bar[_ngcontent-%COMP%]   .default-content[_ngcontent-%COMP%]   .floating-action-button[_ngcontent-%COMP%]{grid-column:6;z-index:3}.mat-sidenav-desktop[_ngcontent-%COMP%]{position:fixed;width:240px;top:48px}.mat-sidenav-handheld[_ngcontent-%COMP%]{position:fixed;top:48px;width:calc(100vw - 4rem);box-shadow:0 0 8px -1px #0000004d!important}.mat-badge-content[_ngcontent-%COMP%]{top:0!important}.navbar-header[_ngcontent-%COMP%]   .hepo-logo[_ngcontent-%COMP%]{width:32px;height:32px}.dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%]{display:flex;align-items:center}.dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%] > span[_ngcontent-%COMP%], .dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{margin-right:.2rem}.dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%] > .dropdown-icon[_ngcontent-%COMP%]{top:0;margin-right:.5rem}.dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%] > .dropdown-image[_ngcontent-%COMP%]{height:32px;margin-right:1rem}.dropdown.multi-line-dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%]{padding-top:9px;padding-bottom:9px}.dropdown.multi-line-dropdown[_ngcontent-%COMP%] > .dropdown-toggle[_ngcontent-%COMP%] > .dropdown-placeholder[_ngcontent-%COMP%]{height:46px;margin:0}.debug-toggle[_ngcontent-%COMP%]{margin-top:3rem;margin-bottom:1rem}.user-profile-container[_ngcontent-%COMP%]{width:100%;min-height:120px;display:flex}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]{width:100%;overflow:hidden;padding:2.4rem 0 2.4rem 1.6rem;text-decoration:none;display:flex;justify-content:flex-start;align-items:center}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]   .user-profile-picture-container[_ngcontent-%COMP%]{line-height:0;margin-right:1.6rem}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]   .user-profile-picture-container[_ngcontent-%COMP%] > img[_ngcontent-%COMP%]{border-radius:50%}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]   .user-profile-info-layer[_ngcontent-%COMP%]{flex-grow:2;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]   .user-profile-info-layer[_ngcontent-%COMP%] > .user-name[_ngcontent-%COMP%]{font-weight:500}.user-profile-container[_ngcontent-%COMP%]   .user-profile-link[_ngcontent-%COMP%]   .user-profile-info-layer[_ngcontent-%COMP%] > .user-company[_ngcontent-%COMP%]{font-weight:400}.menu-items-container[_ngcontent-%COMP%]{overflow-y:auto;flex-grow:1}.app-info-container[_ngcontent-%COMP%]{display:flex;padding-left:2px;padding-right:2px;font-size:11px;color:#aaa;cursor:default}.app-info-container[_ngcontent-%COMP%]   .app-version[_ngcontent-%COMP%]{flex-grow:1}.app-info-container[_ngcontent-%COMP%]   .impact-counter[_ngcontent-%COMP%]{text-align:right}.menu-divider[_ngcontent-%COMP%]{margin:.3rem 0;height:0px;width:100%;border-bottom:1px solid #EEE}.navbar-btn[_ngcontent-%COMP%]{margin-top:14px!important;margin-bottom:0!important}.navbar[_ngcontent-%COMP%]{box-shadow:0 3px 6px #0003}.menu-section-title[_ngcontent-%COMP%]{padding:.2rem .2rem .2rem 1.5rem;font-weight:500;color:#00000080}.app-bar-flex-container[_ngcontent-%COMP%]{display:flex;flex-direction:row}.app-bar-sidenav-icon[_ngcontent-%COMP%]{order:1;padding:1rem}.app-bar-branding[_ngcontent-%COMP%]{order:2;padding:1.5rem 1rem}.app-bar-branding-logo[_ngcontent-%COMP%]{width:32px;height:32px}.app-bar-title[_ngcontent-%COMP%]{order:3;font-size:2rem;padding:2.2rem 0;flex-grow:2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-bar-menu-item[_ngcontent-%COMP%]{order:4;padding:1rem}.app-bar-button[_ngcontent-%COMP%]{padding:1rem;background:none;border:none;position:relative;line-height:0;outline:none;color:var(--color-text-gray)}.app-bar-button-ripple[_ngcontent-%COMP%]{top:calc(50% - 25px);left:calc(50% - 25px);width:50px;height:50px;position:absolute;pointer-events:none;border-radius:50%}.max-width[_ngcontent-%COMP%]{width:100%}.white-text[_ngcontent-%COMP%]{color:#fff}.hidden[_ngcontent-%COMP%]{display:none}.page-content-container[_ngcontent-%COMP%]{padding-top:48px}.debug-info[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap}.debug-info[_ngcontent-%COMP%]   pre[_ngcontent-%COMP%]{font-size:1.4rem}.messages-drawer[_ngcontent-%COMP%]{position:fixed;background-color:#dbdbdb}.messages-drawer-desktop[_ngcontent-%COMP%]{width:480px}.messages-drawer-handheld[_ngcontent-%COMP%]{width:calc(100vw - 5rem);box-shadow:0 0 8px -1px #0000004d!important}#close-messages-drawer-button[_ngcontent-%COMP%]{background-color:#dbdbdb}.swupdate-notification[_ngcontent-%COMP%]{position:fixed;z-index:950;top:20px;left:50%;transform:translate(-50%);width:400px;height:58px;padding:0 1.6rem;box-sizing:border-box;border-radius:4px;box-shadow:0 3px 5px -4px #0003,0 1px 18px #0000001f;border:1px solid var(--color-text-gray);background-color:#fff;display:flex;align-items:center;justify-content:space-between}.swupdate-notification.mobile[_ngcontent-%COMP%]{top:0;left:0;right:0;transform:none;width:auto}.swupdate-notification[_ngcontent-%COMP%]   .info-container[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.8rem}.swupdate-notification[_ngcontent-%COMP%]   .info-container[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{animation-name:spinner;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}#floating-chat-button-icon[_ngcontent-%COMP%]{padding:6px;font-size:36px;width:36px;height:36px;color:#fff}#floating-chat-button-container[_ngcontent-%COMP%]{width:48px;height:48px;border-radius:5px;background-color:#241b5b;cursor:pointer;position:fixed;z-index:901}"],
        data: {
          animation: [trigger('slideInOut', [state('in', style({
            transform: 'translateX(0%)'
          })), state('out', style({
            transform: 'translateX(-100%)'
          })), transition('out <=> in', animate('400ms ease-in-out'))]), trigger('slideTop', [transition(':enter', [style({
            top: '-{{height}}px',
            opacity: 0
          }), animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)')], {
            params: {
              height: 0
            }
          }), transition(':leave', [animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)', style({
            top: '-{{height}}px',
            opacity: 0
          }))], {
            params: {
              height: 0
            }
          })])]
        }
      });
    }
  }
  return HpoLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedDirectivesModule = /*#__PURE__*/(() => {
  class SharedDirectivesModule {
    static {
      this.ɵfac = function SharedDirectivesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SharedDirectivesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SharedDirectivesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return SharedDirectivesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Application insights service for tracking application usage.
 */
let ApplicationInsightsService = /*#__PURE__*/(() => {
  class ApplicationInsightsService {
    /**
     * Initializes the application insights service.
     *
     * Should be called only once.
     *
     * @param connectionString ConnectionString of the resource
     * @param autoRouteTracking Automatically tracks route changes in Single Page Applications (SPA). If true, each route change will send a new Pageview to Application Insights.
     */
    init(connectionString, autoRouteTracking = false) {
      if (this.appInsights) {
        throw new Error('[ApplicationInsightsService] Initialize called multiple times.');
      }
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString,
          enableAutoRouteTracking: autoRouteTracking
        }
      });
      this.appInsights.loadAppInsights();
    }
    ngOnDestroy() {
      this.appInsights?.unload();
    }
    /**
     * Logs that a page, or similar container was displayed to the user.
     *
     * @param name The string that was used as the name in startTrackPage
     * @param url A relative or absolute URL that identifies the page or other item
     */
    trackPageView(name, url) {
      this.appInsights?.trackPageView({
        name,
        uri: url
      });
    }
    /**
     * Logs a user action or other occurrence.
     *
     * @param name An event name string
     * @param properties Additional metric properties
     */
    trackEvent(name, properties) {
      this.appInsights?.trackEvent({
        name
      }, properties);
    }
    /**
     * Logs a numeric value that is not associated with a specific event.
     * Typically used to send regular reports of performance indicators.
     *
     * @param name Name of this metric
     * @param average Recorded value/average for this metric
     * @param properties Additional metric properties
     */
    trackMetric(name, average, properties) {
      this.appInsights?.trackMetric({
        name,
        average
      }, properties);
    }
    /**
     * Logs an exception that have been caught.
     *
     * @param exception Error/exception to log
     * @param severityLevel Specified severity of exception for use with telemetry filtering in dashboard
     */
    trackException(exception, severityLevel) {
      this.appInsights?.trackException({
        exception,
        severityLevel
      });
    }
    /**
     * Logs a diagnostic scenario such entering or leaving a function.
     *
     * @param message A trace message
     * @param properties Additional metric properties
     */
    trackTrace(message, properties) {
      this.appInsights?.trackTrace({
        message
      }, properties);
    }
    static {
      this.ɵfac = function ApplicationInsightsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApplicationInsightsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ApplicationInsightsService,
        factory: ApplicationInsightsService.ɵfac
      });
    }
  }
  return ApplicationInsightsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HelpdeskModule = /*#__PURE__*/(() => {
  class HelpdeskModule {
    static {
      this.ɵfac = function HelpdeskModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HelpdeskModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HelpdeskModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatInputModule, MatCheckboxModule, BlahModule, ButtonModule, SharedDirectivesModule]
      });
    }
  }
  return HelpdeskModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsModule = /*#__PURE__*/(() => {
  class NotificationsModule {
    static {
      this.ɵfac = function NotificationsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NotificationsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, BlahModule, SpinnerModule, ButtonModule, CardModule, NotificationModule, PlaceholderModule, MatIconModule, MatListModule, MatTooltipModule, SharedPipesModule, MatDialogModule, MatButtonModule]
      });
    }
  }
  return NotificationsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CompanyAdminsModule = /*#__PURE__*/(() => {
  class CompanyAdminsModule {
    static {
      this.ɵfac = function CompanyAdminsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CompanyAdminsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CompanyAdminsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, BlahModule, MatIconModule, MatDialogModule, PlaceholderModule, ButtonModule]
      });
    }
  }
  return CompanyAdminsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessagesModule = /*#__PURE__*/(() => {
  class MessagesModule {
    static {
      this.ɵfac = function MessagesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MessagesModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MessagesModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, BlahModule, ButtonModule, MatIconModule, MatButtonModule]
      });
    }
  }
  return MessagesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoLayoutModule = /*#__PURE__*/(() => {
  class HpoLayoutModule {
    static {
      this.ɵfac = function HpoLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HpoLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [SharedService, LayoutBreakpointService, ToasterService, LiveMessagingService, ApplicationInsightsService, {
          provide: MAT_TABS_CONFIG,
          useValue: {
            stretchTabs: false
          }
        }],
        imports: [CommonModule, RouterModule, BlahModule, MatSidenavModule, MatIconModule, MatRippleModule, MatInputModule, MatCheckboxModule, MatDialogModule, MatBadgeModule, MatSnackBarModule, MatButtonModule, ButtonModule, CardModule, FullScreenDialogModule, LayoutModule, SharedDirectivesModule, HelpdeskModule, NotificationsModule, CompanyAdminsModule, MessagesModule, FloatingChatComponent]
      });
    }
  }
  return HpoLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CurrentUser {
  constructor() {
    this.givenName = '';
    this.familyName = '';
    this.email = '';
    this.phone = '';
    this.picture = '';
    this.accessToken = '';
    this.companyName = '';
    this.id = '';
    this.userId = '';
    this.companyOldId = '';
    this.companyId = '';
    this.limitedUser = false;
  }
}
class CanActivatePromise {
  canActivate(route, state) {
    throw new Error('canActivate not implemented');
  }
  canActivatePromise(route, state) {
    const canActivateResult = this.canActivate(route, state);
    if (canActivateResult instanceof Promise) {
      return canActivateResult;
    }
    if (isObservable(canActivateResult)) {
      return firstValueFrom(canActivateResult);
    }
    return Promise.resolve(canActivateResult);
  }
}
class FilterDataSource extends MatTableDataSource {
  /**
   * Current page data after pagination.
   *
   * This is the data that should be rendered.
   *
   * **Note:** This wont update if `withoutMatTable` was set to `false` in constructor.
   */
  get currentPageData() {
    return this._currentPageData;
  }
  /**
   * Initializes a new instance of `FilterDataSource` class.
   *
   * @param initialData Possible initial data
   * @param withoutMatTable If the data source is used separately from `MatTable`.
   *                        **Note:** If this is set to `false`, `currentPageData` wont update. Default is `false`.
   */
  constructor(initialData = [], withoutMatTable = false) {
    super(initialData);
    this._currentPageData = [];
    if (withoutMatTable) {
      this._connection = this.connect().subscribe(data => this.setCurrentPage(data));
    }
  }
  /**
   * Frees all resources used by the data source.
   */
  destroy() {
    this._connection?.unsubscribe();
    super.disconnect();
  }
  /**
   * Alias for `destroy()`.
   *
   * Used by `MatTable`.
   */
  disconnect() {
    this.destroy();
  }
  /**
   * Triggers filter update cycle manually and updates both additional & text filters.
   *
   * Should be used together with `additionalFilterPredicate`.
   */
  updateFilters() {
    // Because 'this._filter' subject is private,
    // we have to trigger filtering by using filter setter.
    this.filter = this.filter;
  }
  // Override base filter method to add additional filter functionality.
  // In the end the base text filter is still used.
  _filterData(data) {
    if (this.additionalFilterPredicate) {
      // Cache predicate to ensure that the same predicate exists until filtering is complete,
      // even if the user changes it on the fly.
      const filterPredicate = this.additionalFilterPredicate;
      data = data.filter(o => filterPredicate(o));
    }
    return super._filterData(data);
  }
  setCurrentPage(data) {
    this._currentPageData = data;
  }
}
const getDefaultTheme = () => structuredClone({
  name: 'default',
  // HPO blue
  primary: {
    '50': '#d9e2ff',
    '100': '#afc6ff',
    '200': '#85aafc',
    '300': '#6a8fe0',
    '400': '#4f75c4',
    '500': '#345ca9',
    '600': '#154490',
    '700': '#002d6d',
    '800': '#002358',
    '900': '#000f2f',
    'A100': '#afc6ff',
    'A200': '#85aafc',
    'A400': '#4f75c4',
    'A700': '#002d6d',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-light)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-dark)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  },
  // Material pink
  accent: {
    '50': '#fce4ec',
    '100': '#f8bbd0',
    '200': '#f48fb1',
    '300': '#f06292',
    '400': '#ec407a',
    '500': '#e91e63',
    '600': '#d81b60',
    '700': '#c2185b',
    '800': '#ad1457',
    '900': '#880e4f',
    'A100': '#ff80ab',
    'A200': '#ff4081',
    'A400': '#f50057',
    'A700': '#c51162',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-dark)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-light)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  },
  // Material red
  warn: {
    '50': '#ffebee',
    '100': '#ffcdd2',
    '200': '#ef9a9a',
    '300': '#e57373',
    '400': '#ef5350',
    '500': '#f44336',
    '600': '#e53935',
    '700': '#d32f2f',
    '800': '#c62828',
    '900': '#b71c1c',
    'A100': '#ff8a80',
    'A200': '#ff5252',
    'A400': '#ff1744',
    'A700': '#d50000',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-dark)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-light)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  }
});
const getOldTheme = () => structuredClone({
  name: 'old',
  // HPO old blue
  primary: {
    '50': '#54b3db',
    '100': '#54b3db',
    '200': '#54b3db',
    '300': '#54b3db',
    '400': '#54b3db',
    '500': '#0083a9',
    '600': '#0083a9',
    '700': '#00567a',
    '800': '#00567a',
    '900': '#00567a',
    'A100': '#54b3db',
    'A200': '#0083a9',
    'A400': '#00567a',
    'A700': '#00567a',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-dark)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-light)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  },
  // Material pink
  accent: {
    '50': '#fce4ec',
    '100': '#f8bbd0',
    '200': '#f48fb1',
    '300': '#f06292',
    '400': '#ec407a',
    '500': '#e91e63',
    '600': '#d81b60',
    '700': '#c2185b',
    '800': '#ad1457',
    '900': '#880e4f',
    'A100': '#ff80ab',
    'A200': '#ff4081',
    'A400': '#f50057',
    'A700': '#c51162',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-dark)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-light)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  },
  // Material red
  warn: {
    '50': '#ffebee',
    '100': '#ffcdd2',
    '200': '#ef9a9a',
    '300': '#e57373',
    '400': '#ef5350',
    '500': '#f44336',
    '600': '#e53935',
    '700': '#d32f2f',
    '800': '#c62828',
    '900': '#b71c1c',
    'A100': '#ff8a80',
    'A200': '#ff5252',
    'A400': '#ff1744',
    'A700': '#d50000',
    contrast: {
      '50': 'var(--color-text-dark)',
      '100': 'var(--color-text-dark)',
      '200': 'var(--color-text-dark)',
      '300': 'var(--color-text-dark)',
      '400': 'var(--color-text-dark)',
      '500': 'var(--color-text-light)',
      '600': 'var(--color-text-light)',
      '700': 'var(--color-text-light)',
      '800': 'var(--color-text-light)',
      '900': 'var(--color-text-light)',
      'A100': 'var(--color-text-dark)',
      'A200': 'var(--color-text-light)',
      'A400': 'var(--color-text-light)',
      'A700': 'var(--color-text-light)'
    }
  }
});
let ThemeService = /*#__PURE__*/(() => {
  class ThemeService {
    /**
     * Clone of the current global theme
     */
    get globalTheme() {
      return structuredClone(this._globalTheme);
    }
    /**
     * Active theme mode
     */
    get themeMode() {
      return this._themeMode;
    }
    /**
     * Global theme changed observable.
     *
     * Observable contains the new global theme's name.
     */
    get globalThemeChange$() {
      return this.themeChangeSubject.asObservable();
    }
    /**
     * Theme mode changed observable.
     *
     * Observable contains the new theme mode.
     */
    get themeModeChange$() {
      return this.themeModeChangeSubject.asObservable();
    }
    constructor(document) {
      this.document = document;
      this._globalTheme = {};
      this._themeMode = 'light';
      this.themeChangeSubject = new Subject();
      this.themeModeChangeSubject = new Subject();
    }
    /**
     * Initializes the theme service.
     *
     * @param theme Possible global theme to apply at initialization. If not given default theme is used.
     * @param themeMode Theme mode to use. Default is `'light'`.
     */
    init(theme, themeMode = 'light') {
      this._globalTheme = theme ? structuredClone(theme) : getDefaultTheme();
      this._themeMode = themeMode;
      this.headStyleElemRef = this.document.createElement('style');
      this.document.head.appendChild(this.headStyleElemRef);
      this.document.body.classList.add('hpo-theme', this.getClassByThemeMode(this._themeMode));
      this.renderGlobalTheme(this._globalTheme);
    }
    /**
     * Changes the global theme.
     *
     * @param theme New global theme
     */
    changeTheme(theme) {
      this._globalTheme = structuredClone(theme);
      this.renderGlobalTheme(this._globalTheme);
      this.themeChangeSubject.next(this._globalTheme.name);
    }
    /**
     * Changes the theme mode.
     *
     * @param themeMode New theme mode
     */
    changeThemeMode(themeMode) {
      const prevThemeMode = this._themeMode;
      this._themeMode = themeMode;
      if (this._themeMode !== prevThemeMode) {
        this.document.body.classList.remove(this.getClassByThemeMode(prevThemeMode));
        this.document.body.classList.add(this.getClassByThemeMode(this._themeMode));
        this.themeModeChangeSubject.next(this._themeMode);
      }
    }
    /**
     * Gets the name of the theme that is currently active on element matched by the given selector.
     *
     * @param selector Element CSS selector
     * @returns Currently active theme's name or *null* if no matching element found
     */
    getActiveThemeName(selector) {
      const elem = this.document.querySelector(selector);
      if (!elem) {
        return null;
      }
      const rawValue = window.getComputedStyle(elem).getPropertyValue('--theme-name');
      const themeName = rawValue.replace(/"/g, '').trim();
      return themeName;
    }
    /**
     * Generates a theme from given colors.
     *
     * Colors can be any CSS color (hex, rgb, hsl etc.).
     *
     * @param name Theme unique name
     * @param primaryColor Primary palette base color
     * @param accentColor Possible accent palette base color. If not given current global theme's accent palette is used.
     * @param warnColor Possible warn palette base color. If not given current global theme's warn palette is used.
     * @returns Theme from given colors
     */
    generateThemeFromColors(name, primaryColor, accentColor, warnColor) {
      const primary = this.generatePaletteFromColor(primaryColor);
      let accent;
      let warn;
      if (accentColor) accent = this.generatePaletteFromColor(accentColor);
      if (warnColor) warn = this.generatePaletteFromColor(warnColor);
      if (!accentColor || !warnColor) {
        const globalTheme = structuredClone(this._globalTheme);
        if (!accentColor) accent = globalTheme.accent;
        if (!warnColor) warn = globalTheme.warn;
      }
      const theme = {
        name,
        primary,
        accent,
        warn
      };
      return theme;
    }
    /**
     * Generates a color palette from given color.
     *
     * @param color Color to generate the palette from. Color can be any CSS color (hex, rgb, hsl etc.).
     * @param lightTreshold Light treshold level to determine contrast colors. Value range is `0-1`. Default is `0.28`.
     * @returns Color palette from given color
     */
    generatePaletteFromColor(color, lightTreshold = 0.28) {
      const baseColor = tinycolor(color);
      const baseLight = tinycolor('#fff');
      const baseDark = tinycolor('#000');
      const colors = [tinycolor.mix(baseLight, baseColor, 15).saturate(10),
      // 50
      tinycolor.mix(baseLight, baseColor, 30).saturate(10),
      // 100
      tinycolor.mix(baseLight, baseColor, 50).saturate(10),
      // 200
      tinycolor.mix(baseLight, baseColor, 70).saturate(10),
      // 300
      tinycolor.mix(baseLight, baseColor, 85).saturate(10),
      // 400
      baseColor,
      // 500
      tinycolor.mix(baseDark, baseColor, 85).saturate(10),
      // 600
      tinycolor.mix(baseDark, baseColor, 65).saturate(10),
      // 700
      tinycolor.mix(baseDark, baseColor, 45).saturate(10),
      // 800
      tinycolor.mix(baseDark, baseColor, 35).saturate(10),
      // 900
      tinycolor.mix(baseLight, baseColor, 90).saturate(80).lighten(20),
      // A100
      tinycolor.mix(baseLight, baseColor, 90).saturate(80).lighten(6),
      // A200
      tinycolor.mix(baseLight, baseColor, 90).saturate(100).darken(8),
      // A400
      tinycolor.mix(baseLight, baseColor, 90).saturate(100).darken(16) // A700
      ].map(o => ({
        color: o.toHexString(),
        contrastColor: o.getLuminance() < lightTreshold ? 'var(--color-text-light)' : 'var(--color-text-dark)'
      }));
      const palette = {
        '50': colors[0].color,
        '100': colors[1].color,
        '200': colors[2].color,
        '300': colors[3].color,
        '400': colors[4].color,
        '500': colors[5].color,
        '600': colors[6].color,
        '700': colors[7].color,
        '800': colors[8].color,
        '900': colors[9].color,
        'A100': colors[10].color,
        'A200': colors[11].color,
        'A400': colors[12].color,
        'A700': colors[13].color,
        contrast: {
          '50': colors[0].contrastColor,
          '100': colors[1].contrastColor,
          '200': colors[2].contrastColor,
          '300': colors[3].contrastColor,
          '400': colors[4].contrastColor,
          '500': colors[5].contrastColor,
          '600': colors[6].contrastColor,
          '700': colors[7].contrastColor,
          '800': colors[8].contrastColor,
          '900': colors[9].contrastColor,
          'A100': colors[10].contrastColor,
          'A200': colors[11].contrastColor,
          'A400': colors[12].contrastColor,
          'A700': colors[13].contrastColor
        }
      };
      return palette;
    }
    /**
     * Gets default tones (default, lighter & darker) for the given palette.
     *
     * @param paletteName Palette name to get the default tones for
     * @returns Default tones for the given palette
     */
    getDefaultTonesForPalette(paletteName) {
      switch (paletteName) {
        case 'accent':
          return {
            default: 'A200',
            lighter: 'A100',
            darker: 'A400'
          };
        default:
          return {
            default: '500',
            lighter: '100',
            darker: '700'
          };
      }
    }
    renderGlobalTheme(theme) {
      const varString = this.ωgenerateThemeVariables(theme);
      this.headStyleElemRef.textContent = `:root{${varString}}`;
    }
    getClassByThemeMode(themeMode) {
      switch (themeMode) {
        case 'light':
          return 'hpo-light-theme';
        case 'dark':
          return 'hpo-dark-theme';
        default:
          return 'theme';
      }
    }
    /**
     * @private
     */
    ωgenerateThemeVariables(theme) {
      let vars = '';
      vars += `--theme-name:"${theme.name}";`;
      vars += this.ωgeneratePaletteVariables('primary', theme.primary);
      vars += this.ωgeneratePaletteVariables('accent', theme.accent);
      vars += this.ωgeneratePaletteVariables('warn', theme.warn);
      if (theme.customPalettes) {
        for (const [name, palette] of Object.entries(theme.customPalettes)) {
          vars += this.ωgeneratePaletteVariables(name, palette);
        }
      }
      return vars;
    }
    /**
     * @private
     */
    ωgeneratePaletteVariables(paletteName, palette) {
      const defaultTonesForPalette = this.getDefaultTonesForPalette(paletteName);
      const defaultTone = palette.defaultTones?.default || defaultTonesForPalette.default;
      const lighterTone = palette.defaultTones?.lighter || defaultTonesForPalette.lighter;
      const darkerTone = palette.defaultTones?.darker || defaultTonesForPalette.darker;
      let vars = '';
      const paletteKeys = Object.keys(palette).filter(o => o !== 'contrast' && o !== 'defaultTones');
      const contrastKeys = Object.keys(palette.contrast);
      for (const key of paletteKeys) {
        vars += `--color-${paletteName}-${key}:${palette[key]};`;
      }
      vars += `--color-${paletteName}:${palette[defaultTone]};`;
      vars += `--color-${paletteName}-lighter:${palette[lighterTone]};`;
      vars += `--color-${paletteName}-darker:${palette[darkerTone]};`;
      for (const key of contrastKeys) {
        vars += `--color-${paletteName}-${key}-contrast:${palette.contrast[key]};`;
      }
      vars += `--color-${paletteName}-contrast:${palette.contrast[defaultTone]};`;
      vars += `--color-${paletteName}-lighter-contrast:${palette.contrast[lighterTone]};`;
      vars += `--color-${paletteName}-darker-contrast:${palette.contrast[darkerTone]};`;
      return vars;
    }
    static {
      this.ɵfac = function ThemeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ThemeService)(i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ThemeService,
        factory: ThemeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ThemeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ThemeDirective = /*#__PURE__*/(() => {
  class ThemeDirective {
    constructor(themeService, elem) {
      this.themeService = themeService;
      this.elem = elem;
    }
    ngOnChanges(changes) {
      if (changes.theme) {
        if (this.theme) {
          const varString = this.themeService.ωgenerateThemeVariables(this.theme);
          this.elem.nativeElement.style.cssText = varString;
        } else {
          this.elem.nativeElement.style.cssText = '';
        }
      }
    }
    static {
      this.ɵfac = function ThemeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ThemeDirective)(i0.ɵɵdirectiveInject(ThemeService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ThemeDirective,
        selectors: [["", "theme", ""]],
        inputs: {
          theme: "theme"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return ThemeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AppMenuButtonComponent, AppMenuComponent, AppMenuSubButtonComponent, ApplicationInsightsService, AutoRelieveMode, CanActivatePromise, CurrentUser, FilterDataSource, FilterTagsPipe, GridColumnDirective, GridRowDirective, HpoLayoutComponent, HpoLayoutModule, ImpactType, LayoutBreakpointService, LiveMessagingService, MarkNewsAsReadParameters, MarkdownToHtmlPipe, MenuItem, MessageStream, MessageStreamLiveActionType, MessageStreamLiveMessage, MessageStreamLiveStateChange, MessageStreamLiveSubscriptionChange, MessageStreamMessage, MessageStreamState, NoPrintDirective, Person, SharedDirectivesModule, SharedPipesModule, SharedService, SingleLiveMessage, SmoothnessEnforcer, ThemeDirective, ThemeService, ToastDuration, ToastRef, ToasterService, getDefaultTheme, getOldTheme, hasFlag };
